(window.theme = window.theme || {}),
  (theme.Sections = function () {
    (this.constructors = {}),
      (this.instances = []),
      $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  }),
  (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (s, t) {
      var a = $(s),
        e = a.attr("data-section-id"),
        o = a.attr("data-section-type");
      if (((t = t || this.constructors[o]), !_.isUndefined(t))) {
        var n = _.assignIn(new t(s), { id: e, type: o, container: s });
        this.instances.push(n);
      }
    },
    _onSectionLoad: function (s) {
      var t = $("[data-section-id]", s.target)[0];
      if (t) {
        this._createInstance(t);
        var a = _.find(this.instances, function (e) {
          return e.id === s.detail.sectionId;
        });
        !_.isUndefined(a) && _.isFunction(a.onLoad) && a.onLoad(s);
      }
    },
    _onSectionUnload: function (s) {
      this.instances = _.filter(this.instances, function (t) {
        var a = t.id === s.detail.sectionId;
        return a && _.isFunction(t.onUnload) && t.onUnload(s), !a;
      });
    },
    _onSelect: function (s) {
      var t = _.find(this.instances, function (a) {
        return a.id === s.detail.sectionId;
      });
      !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(s);
    },
    _onDeselect: function (s) {
      var t = _.find(this.instances, function (a) {
        return a.id === s.detail.sectionId;
      });
      !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(s);
    },
    _onBlockSelect: function (s) {
      var t = _.find(this.instances, function (a) {
        return a.id === s.detail.sectionId;
      });
      !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(s);
    },
    _onBlockDeselect: function (s) {
      var t = _.find(this.instances, function (a) {
        return a.id === s.detail.sectionId;
      });
      !_.isUndefined(t) &&
        _.isFunction(t.onBlockDeselect) &&
        t.onBlockDeselect(s);
    },
    register: function (s, t) {
      (this.constructors[s] = t),
        $("[data-section-type=" + s + "]").each(
          function (a, e) {
            this._createInstance(e, t);
          }.bind(this)
        );
    },
  })),
  (window.slate = window.slate || {}),
  (slate.rte = {
    wrapTable: function (s) {
      s.$tables.wrap('<div class="' + s.tableWrapperClass + '"></div>');
    },
    wrapIframe: function (s) {
      s.$iframes.each(function () {
        $(this).wrap('<div class="' + s.iframeWrapperClass + '"></div>'),
          (this.src = this.src);
      });
    },
  }),
  (window.slate = window.slate || {}),
  (slate.a11y = {
    pageLinkFocus: function (s) {
      s.first()
        .attr("tabIndex", "-1")
        .focus()
        .addClass("js-focus-hidden")
        .one("blur", function () {
          s.first().removeClass("js-focus-hidden").removeAttr("tabindex");
        });
    },
    focusHash: function () {
      var s = window.location.hash;
      s && document.getElementById(s.slice(1)) && this.pageLinkFocus($(s));
    },
    bindInPageLinks: function () {
      $("a[href*=#]").on(
        "click",
        function (s) {
          this.pageLinkFocus($(s.currentTarget.hash));
        }.bind(this)
      );
    },
    trapFocus: function (s) {
      var t = s.namespace ? "focusin." + s.namespace : "focusin";
      s.$elementToFocus || (s.$elementToFocus = s.$container),
        s.$container.attr("tabindex", "-1"),
        s.$elementToFocus.focus(),
        $(document).off("focusin"),
        $(document).on(t, function (a) {
          s.$container[0] === a.target ||
            s.$container.has(a.target).length ||
            s.$container.focus();
        });
    },
    removeTrapFocus: function (s) {
      var t = s.namespace ? "focusin." + s.namespace : "focusin";
      s.$container &&
        s.$container.length &&
        s.$container.removeAttr("tabindex"),
        $(document).off(t);
    },
  }),
  (theme.Images = (function () {
    return {
      preload: function (s, t) {
        typeof s == "string" && (s = [s]);
        for (var a, e = 0; e < s.length; e++)
          (a = s[e]), this.loadImage(this.getSizedImageUrl(a, t));
      },
      loadImage: function (s) {
        new Image().src = s;
      },
      switchImage: function (s, t, a) {
        var e = this.imageSize(t.src),
          o = this.getSizedImageUrl(s.src, e);
        a ? a(o, s, t) : (t.src = o);
      },
      imageSize: function (s) {
        var t = s.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
        );
        return t === null ? null : t[2] === void 0 ? t[1] : t[1] + t[2];
      },
      getSizedImageUrl: function (s, t) {
        if (t === null) return s;
        if (t === "master") return this.removeProtocol(s);
        var a = s.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (a !== null) {
          var e = s.split(a[0]),
            o = a[0];
          return this.removeProtocol(e[0] + "_" + t + o);
        }
        return null;
      },
      removeProtocol: function (s) {
        return s.replace(/http(s)?:/, "");
      },
    };
  })()),
  (theme.Currency = (function () {
    return {
      formatMoney: function (s, t) {
        function a(r, c, d, l) {
          if (((d = d || ","), (l = l || "."), isNaN(r) || r === null))
            return 0;
          r = (r / 100).toFixed(c);
          var u = r.split("."),
            f = u[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + d),
            h = u[1] ? l + u[1] : "";
          return f + h;
        }
        typeof s == "string" && (s = s.replace(".", ""));
        var e = "",
          o = /\{\{\s*(\w+)\s*\}\}/,
          n = t || "${{amount}}";
        switch (n.match(o)[1]) {
          case "amount":
            e = a(s, 2);
            break;
          case "amount_no_decimals":
            e = a(s, 0);
            break;
          case "amount_with_comma_separator":
            e = a(s, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            e = a(s, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            e = a(s, 0, " ");
            break;
          case "amount_with_apostrophe_separator":
            e = a(s, 2, "'");
        }
        return n.replace(o, e);
      },
    };
  })()),
  (slate.Variants = (function () {
    function s(t) {
      (this.$container = t.$container),
        (this.product = t.product),
        (this.singleOptionSelector = t.singleOptionSelector),
        (this.originalSelectorId = t.originalSelectorId),
        (this.enableHistoryState = t.enableHistoryState),
        (this.currentVariant = this._getVariantFromOptions()),
        $(this.singleOptionSelector, this.$container).on(
          "change",
          this._onSelectChange.bind(this)
        );
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _getCurrentOptions: function () {
          var t = _.map(
            $(this.singleOptionSelector, this.$container),
            function (a) {
              var e = $(a),
                o = e.attr("type"),
                n = {};
              return o === "radio" || o === "checkbox"
                ? !!e[0].checked &&
                    ((n.value = e.val()), (n.index = e.data("index")), n)
                : ((n.value = e.val()), (n.index = e.data("index")), n);
            }
          );
          return (t = _.compact(t)), t;
        },
        _getVariantFromOptions: function () {
          var t = this._getCurrentOptions(),
            a = this.product.variants,
            e = _.find(a, function (o) {
              return t.every(function (n) {
                return _.isEqual(o[n.index], n.value);
              });
            });
          return e;
        },
        _onSelectChange: function () {
          var t = this._getVariantFromOptions();
          this.$container.trigger({ type: "variantChange", variant: t }),
            t &&
              (this._updateMasterSelect(t),
              this._updateImages(t),
              this._updatePrice(t),
              this._updateSKU(t),
              (this.currentVariant = t),
              this.enableHistoryState && this._updateHistoryState(t));
        },
        _updateImages: function (t) {
          var a = t.featured_image || {},
            e = this.currentVariant.featured_image || {};
          t.featured_image &&
            a.src !== e.src &&
            this.$container.trigger({ type: "variantImageChange", variant: t });
        },
        _updatePrice: function (t) {
          (t.price === this.currentVariant.price &&
            t.compare_at_price === this.currentVariant.compare_at_price) ||
            this.$container.trigger({ type: "variantPriceChange", variant: t });
        },
        _updateSKU: function (t) {
          t.sku === this.currentVariant.sku ||
            this.$container.trigger({ type: "variantSKUChange", variant: t });
        },
        _updateHistoryState: function (t) {
          if (history.replaceState && t) {
            var a =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              t.id;
            window.history.replaceState({ path: a }, "", a);
          }
        },
        _updateMasterSelect: function (t) {
          $(this.originalSelectorId, this.$container).val(t.id);
        },
      })),
      s
    );
  })()),
  (theme.Drawers = (function () {
    function s(t, a, e) {
      return (
        (this.nodes = {
          $parent: $("html").add("body"),
          $page: $("#PageContainer"),
        }),
        (this.config = $.extend(
          {
            close: ".js-drawer-close",
            open: ".js-drawer-open-" + a,
            openClass: "js-drawer-open",
            dirOpenClass: "js-drawer-open-" + a,
          },
          e
        )),
        (this.position = a),
        (this.$drawer = $("#" + t)),
        !!this.$drawer.length && ((this.drawerIsOpen = !1), void this.init())
      );
    }
    return (
      (s.prototype.init = function () {
        $(this.config.open).on("click", $.proxy(this.open, this)),
          this.$drawer.on(
            "click",
            this.config.close,
            $.proxy(this.close, this)
          );
      }),
      (s.prototype.open = function (t) {
        var a = !1;
        return (
          t ? t.preventDefault() : (a = !0),
          t &&
            t.stopPropagation &&
            (t.stopPropagation(), (this.$activeSource = $(t.currentTarget))),
          this.drawerIsOpen && !a
            ? this.close()
            : (this.$drawer.prepareTransition(),
              this.nodes.$parent.addClass(
                this.config.openClass + " " + this.config.dirOpenClass
              ),
              (this.drawerIsOpen = !0),
              slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus",
              }),
              this.config.onDrawerOpen &&
                typeof this.config.onDrawerOpen == "function" &&
                !a &&
                this.config.onDrawerOpen(),
              this.$activeSource &&
                this.$activeSource.attr("aria-expanded") &&
                this.$activeSource.attr("aria-expanded", "true"),
              this.bindEvents(),
              this)
        );
      }),
      (s.prototype.close = function () {
        this.drawerIsOpen &&
          ($(document.activeElement).trigger("blur"),
          this.$drawer.prepareTransition(),
          this.nodes.$parent.removeClass(
            this.config.dirOpenClass + " " + this.config.openClass
          ),
          (this.drawerIsOpen = !1),
          slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: "drawer_focus",
          }),
          this.unbindEvents());
      }),
      (s.prototype.bindEvents = function () {
        this.nodes.$parent.on(
          "keyup.drawer",
          $.proxy(function (t) {
            return t.keyCode !== 27 || (this.close(), !1);
          }, this)
        ),
          this.nodes.$page.on("touchmove.drawer", function () {
            return !1;
          }),
          this.nodes.$page.on(
            "click.drawer",
            $.proxy(function () {
              return this.close(), !1;
            }, this)
          );
      }),
      (s.prototype.unbindEvents = function () {
        this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
      }),
      s
    );
  })()),
  (theme.Helpers = (function () {
    function s() {
      return t;
    }
    var t = !1;
    return {
      setTouch: function () {
        t = !0;
      },
      isTouch: s,
    };
  })()),
  (theme.LibraryLoader = (function () {
    function s(r, c) {
      var d = document.createElement("script");
      return (
        (d.src = r.src),
        d.addEventListener("load", function () {
          (r.status = e.loaded), c();
        }),
        d
      );
    }
    function t(r, c) {
      var d = document.createElement("link");
      return (
        (d.href = r.src),
        (d.rel = "stylesheet"),
        (d.type = "text/css"),
        d.addEventListener("load", function () {
          (r.status = e.loaded), c();
        }),
        d
      );
    }
    var a = { link: "link", script: "script" },
      e = { requested: "requested", loaded: "loaded" },
      o = "https://cdn.shopify.com/shopifycloud/",
      n = {
        youtubeSdk: {
          tagId: "youtube-sdk",
          src: "https://www.youtube.com/iframe_api",
          type: a.script,
        },
        plyrShopifyStyles: {
          tagId: "plyr-shopify-styles",
          src: o + "shopify-plyr/v1.0/shopify-plyr.css",
          type: a.link,
        },
        modelViewerUiStyles: {
          tagId: "shopify-model-viewer-ui-styles",
          src: o + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
          type: a.link,
        },
      };
    return {
      load: function (r, c) {
        var d = n[r];
        if (d && d.status !== e.requested) {
          if (((c = c || function () {}), d.status === e.loaded))
            return void c();
          d.status = e.requested;
          var l;
          switch (d.type) {
            case a.script:
              l = s(d, c);
              break;
            case a.link:
              l = t(d, c);
          }
          (l.id = d.tagId), (d.element = l);
          var u = document.getElementsByTagName(d.type)[0];
          u.parentNode.insertBefore(l, u);
        }
      },
    };
  })()),
  (theme.Search = (function () {
    function s() {
      $(e.searchAjax).each(function () {
        var n = $(this),
          r = n.find(e.searchInput),
          c = null,
          d = n.data("limit"),
          l = n.data("featured"),
          u = n.data("featured_limit");
        r.off("keyup"),
          r.on("keyup", function () {
            clearTimeout(c),
              (c = setTimeout(function () {
                var f = r.val();
                if (!(1 < f.length)) $(e.searchResults).empty();
                else if (f in o) {
                  var h = o[f];
                  $(e.searchResults).html(h.html),
                    $(h.html).find(".not__found").length &&
                    !$(h.html).find(".featured_title").length
                      ? n.closest(e.searchScreen).removeClass("searching")
                      : n.closest(e.searchScreen).addClass("searching");
                } else
                  $(e.searchResults).empty(),
                    $.ajax({
                      url: "/search",
                      data: {
                        view: "search",
                        type: "product",
                        searched_limit: d,
                        featured: l,
                        featured_limit: u,
                        q: "*" + f + "*",
                        cache: !1,
                      },
                      dataType: "html",
                      type: "GET",
                      beforeSend: function () {
                        n.addClass("loading").addClass("searching");
                      },
                      complete: function () {
                        n.removeClass("loading");
                      },
                      success: function (b) {
                        setTimeout(function () {
                          $(e.searchResults).html(b),
                            $(b).find(".not__found").length &&
                            !$(b).find(".featured_title").length
                              ? n
                                  .closest(e.searchScreen)
                                  .removeClass("searching")
                              : n.closest(e.searchScreen).addClass("searching"),
                            (o[f] = { found: !0, html: b });
                        }, 650);
                      },
                    });
              }, 500));
          }),
          n.removeClass("no-js");
      });
    }
    function t(n) {
      if (typeof $.fn.typed == "undefined") return !1;
      var r = "^800 " + $(".search__label-text", n).data("typedtext"),
        c = $(".search__label-text", n).data("typedtext_2");
      $(".search__label-text", n).typed({
        strings: [r, c],
        typeSpeed: 30,
        backSpeed: 20,
      }),
        $(".search__label", n).on("click", function () {
          $(this).fadeOut(200, function () {
            $(this).addClass("hide");
          }),
            $(e.searchInput, n).focus();
        });
    }
    function a() {
      $(document).off("click", e.searchToggle),
        $(document).on("click", e.searchToggle, function (n) {
          n.preventDefault();
          var r = $("body"),
            c = $(this).closest(".header__search"),
            d = $(".search__label-text", c);
          c.hasClass("opened")
            ? (r.removeClass("search-opened"), c.removeClass("opened"))
            : (r.addClass("search-opened"),
              c.addClass("opened"),
              $(e.searchInput, c).val(""),
              $(e.searchResults, c).empty(),
              $(e.searchInput, c).focus()),
            d.length &&
              d.attr("data-first_time") == "0" &&
              (d.attr("data-first_time", "1"), t(c));
        }),
        $(document).keyup(function (n) {
          if (n.keyCode == 27) {
            var r = $(e.search);
            r.hasClass("opened") &&
              ($("body").removeClass("search-opened"), r.removeClass("opened"));
          }
        }),
        $(document).mouseup(function (n) {
          var r = $(e.searchToggle),
            c = $(e.searchScreen);
          if (
            !r.is(n.target) &&
            r.has(n.target).length === 0 &&
            !c.is(n.target) &&
            c.has(n.target).length === 0
          ) {
            var d = $(e.search);
            d.hasClass("opened") &&
              ($("body").removeClass("search-opened"), d.removeClass("opened"));
          }
        });
    }
    var e = {
        search: ".header__search, .mobile-header__search",
        searchInput: ".search__input",
        searchToggle: ".search__toggle",
        searchScreen: ".search__fullscreen",
        searchAjax: ".search__ajax.no-js",
        searchResults: ".search__results",
      },
      o = {};
    return {
      init: function () {
        $(e.search).length && (s(), a());
      },
    };
  })()),
  (theme.CurrencyPicker = (function () {
    var s = {
      container: ".currency__picker",
      currency: ".currency__picker .ml__switcher .currency:not(.active)",
    };
    return {
      init: function () {
        $(s.container).length &&
          ($(s.currency).off("click"),
          $(s.currency).on("click", function (t) {
            t.preventDefault();
            var a = $(this).data("iso_code"),
              e = $(this).closest("form");
            e.find("[data-iso_code-input]").val(a), e.submit();
          }));
      },
      formatMoney: function (t) {
        var a = theme.Currency.formatMoney(t, theme.settings.moneyFormat);
        return (
          (a = a.replace(theme.settings.currencySymbol, "")),
          '<span class="money"><span class="currency_symbol">' +
            theme.settings.currencySymbol +
            "</span>" +
            a +
            "</span>"
        );
      },
    };
  })()),
  (theme.LanguagePicker = (function () {
    var s = {
      container: ".language__picker",
      language: ".language__picker .ml__switcher .locale:not(.active)",
    };
    return {
      init: function () {
        $(s.container).length &&
          ($(s.language).off("click"),
          $(s.language).on("click", function (t) {
            t.preventDefault();
            var a = $(this).data("iso_code"),
              e = $(this).closest("form");
            e.find("[data-iso_code-input]").val(a), e.submit();
          }));
      },
    };
  })()),
  (theme.MiniCart = (function () {
    function s(d) {
      return (
        typeof d == "undefined" && (d = 0),
        $(c.miniCart).addClass("loading"),
        $.get("/search", function (l) {
          if (
            ($(c.miniCart).each(function () {
              var f = $(this),
                h = "";
              f.hasClass("minicart-frame")
                ? (h = ".minicart-frame")
                : f.hasClass("minicart-sidebar") && (h = ".minicart-sidebar");
              var b = $(l).find(c.miniCart + h);
              f.removeClass("loading").html(b.html());
              var C = f.prev();
              C.html(b.prev().html()),
                C.addClass("anim"),
                setTimeout(function () {
                  C.removeClass("anim");
                }, 2e3);
            }),
            0 < d)
          ) {
            var u = ".product__" + d;
            $(u + " .addcart_btn").removeClass("added");
          }
        })
      );
    }
    function t() {
      $(document).off("click", c.headerCart),
        $(document).on("click", c.headerCart, function (d) {
          var l = $(this),
            u = l.parent().find(c.miniCart);
          u.length &&
            u.hasClass("minicart-sidebar") &&
            ($(c.miniCart).each(function () {
              u.attr("id") != $(this).attr("id") &&
                $(this).removeClass("opened");
            }),
            u.hasClass("opened")
              ? u.removeClass("opened")
              : (u.addClass("opened"),
                $("body").addClass("cart-opened"),
                theme.MiniCart.anim()),
            d.preventDefault());
        });
    }
    function a() {
      $(document).off("change", c.miniCartAgree),
        $(document).on("change", c.miniCartAgree, function () {
          var d = $(this);
          d.is(":checked")
            ? ($(c.miniCartAgree).prop("checked", !0),
              $(c.miniCartCheckout).removeClass("btn-disabled"))
            : ($(c.miniCartAgree).prop("checked", !1),
              $(c.miniCartCheckout).addClass("btn-disabled"));
        }),
        $(document).off("click", c.miniCartCheckout),
        $(document).on("click", c.miniCartCheckout, function (d) {
          if ($(c.miniCartAgree).length) {
            var l = $(c.miniCartAgree);
            if (!l.is(":checked")) {
              var u = l.data("message");
              alert(u), d.preventDefault();
            }
          }
        });
    }
    function e() {
      $(document).off("click", c.miniCartRemove),
        $(document).on("click", c.miniCartRemove, function (d) {
          d.preventDefault();
          var l = $(this),
            u = l.attr("href"),
            f = l.data("product_id");
          $(c.miniCart).addClass("loading"),
            $.post(u, function () {
              s(f);
            });
        });
    }
    function o() {
      $(document).off("click", c.miniCartClose),
        $(document).on("click", c.miniCartClose, function () {
          $(c.miniCart).removeClass("loading").removeClass("opened"),
            $("body").removeClass("cart-opened");
        });
    }
    function n(d, l) {
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        async: !0,
        cache: !1,
        data: l.serialize(),
        dataType: "json",
        beforeSend: function () {
          d.addClass("loading");
        },
        success: function () {
          s();
        },
      });
    }
    function r() {
      $(document).off("click", c.miniCartQty + " .plus"),
        $(document).on("click", c.miniCartQty + " .plus", function () {
          var d = $(this).parent(),
            l = d.find(".qty"),
            u = parseInt(l.val());
          ++u, l.val(u).trigger("change");
        }),
        $(document).off("click", c.miniCartQty + " .minus"),
        $(document).on("click", c.miniCartQty + " .minus", function () {
          var d = $(this).parent(),
            l = d.find(".qty"),
            u = parseInt(l.val());
          1 < u && (--u, l.val(u).trigger("change"));
        }),
        $(document).off("change", c.miniCartQty + " .qty"),
        $(document).on("change", c.miniCartQty + " .qty", function () {
          var d = $(this).closest("form"),
            l = $(this).closest(".minicart");
          n(l, d);
        });
    }
    var c = {
      headerSticky: ".header-sticky__placeholder",
      headerCart: ".header__cart .cart__link",
      miniCart: ".minicart",
      miniCartAgree: ".minicart .cart__agree",
      miniCartCheckout: ".minicart .btn-checkout",
      miniCartRemove: ".minicart .item__remove",
      miniCartClose: ".minicart .cart__close, .minicart__overlay",
      miniCartQty: ".minicart .item__qty",
    };
    return {
      init: function () {
        t(), a(), e(), o(), r();
      },
      update: s,
      open: function () {
        if ($(c.miniCart).length) {
          if ($(c.headerSticky).length && $(c.headerSticky).hasClass("stick")) {
            var d = $(c.headerSticky).find(c.headerCart);
            if (d.length) {
              var l = d.closest(".header__cart").find(c.miniCart);
              if (
                l.length &&
                l.hasClass("minicart-sidebar") &&
                !l.hasClass("opened")
              )
                return d.trigger("click"), !1;
            }
          }
          $(c.headerCart).each(function () {
            var u = $(this);
            if (u.is(":visible")) {
              var f = u.closest(".header__cart").find(c.miniCart);
              if (
                f.length &&
                f.hasClass("minicart-sidebar") &&
                !f.hasClass("opened")
              )
                return u.trigger("click"), !1;
            }
          });
        }
      },
      anim: function () {
        var d = new TimelineLite(),
          l = $(".minicart .cart__content"),
          u = $(".minicart .cart__item"),
          f = $(".minicart .cart__total"),
          h = $(".minicart .cart__free-shipping"),
          b = $(".minicart .cart__actions"),
          C = $(".minicart .cart__empty"),
          I = $(".minicart .cart__return");
        theme.settings.rtl
          ? (d.fromTo(
              l,
              0.5,
              { autoAlpha: 0 },
              { autoAlpha: 1, ease: Power4.easeIn },
              0.1
            ),
            d.staggerFromTo(
              u,
              0.5,
              { opacity: 0, skewX: -20, x: -60 },
              { opacity: 1, skewX: 0, x: 0 },
              0.1,
              0.2
            ),
            d.fromTo(f, 0.8, { opacity: 0, x: -80 }, { opacity: 1, x: 0 }, 0.2),
            d.fromTo(h, 0.8, { opacity: 0, x: -80 }, { opacity: 1, x: 0 }, 0.3),
            d.fromTo(b, 0.8, { opacity: 0, x: -80 }, { opacity: 1, x: 0 }, 0.4),
            d.fromTo(C, 0.8, { opacity: 0, x: -80 }, { opacity: 1, x: 0 }, 0.2),
            d.fromTo(I, 0.8, { opacity: 0, x: -80 }, { opacity: 1, x: 0 }, 0.3))
          : (d.fromTo(
              l,
              0.5,
              { autoAlpha: 0 },
              { autoAlpha: 1, ease: Power4.easeIn },
              0.1
            ),
            d.staggerFromTo(
              u,
              0.5,
              { opacity: 0, skewX: 20, x: 60 },
              { opacity: 1, skewX: 0, x: 0 },
              0.1,
              0.2
            ),
            d.fromTo(f, 0.8, { opacity: 0, x: 80 }, { opacity: 1, x: 0 }, 0.2),
            d.fromTo(h, 0.8, { opacity: 0, x: 80 }, { opacity: 1, x: 0 }, 0.3),
            d.fromTo(b, 0.8, { opacity: 0, x: 80 }, { opacity: 1, x: 0 }, 0.4),
            d.fromTo(C, 0.8, { opacity: 0, x: 80 }, { opacity: 1, x: 0 }, 0.2),
            d.fromTo(I, 0.8, { opacity: 0, x: 80 }, { opacity: 1, x: 0 }, 0.3));
      },
    };
  })()),
  (function () {
    function s(a) {
      var e = document.createElement("a");
      return (e.ref = a), e.hostname;
    }
    var t = $(".return-link");
    document.referrer &&
      t.length &&
      window.history.length &&
      t.one("click", function (a) {
        a.preventDefault();
        var e = s(document.referrer),
          o = s(window.location.href);
        return o === e && history.back(), !1;
      });
  })(),
  (theme.SlideshowSection = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = (this.sectionId = a.attr("data-section-id")),
        o = (this.slideshow = "#Slideshow-" + e);
      $(".slideshow__video", o).each(function () {
        var n = $(this);
        theme.SlideshowVideo.init(n),
          theme.SlideshowVideo.loadVideo(n.attr("id"));
      }),
        this.beforeInit(o),
        this.init();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        beforeInit: function (t) {
          var a = 0.01 * window.innerHeight;
          document.documentElement.style.setProperty("--vh", a + "px"),
            window.addEventListener("resize", function () {
              var e = 0.01 * window.innerHeight;
              if (
                (document.documentElement.style.setProperty("--vh", e + "px"),
                $(t).hasClass("slideshow--auto") &&
                  0 <
                    $(t).find(
                      ".slideshow__slide.is-selected .slideshow__image_tag"
                    ).length)
              ) {
                var o = $(t)
                  .find(".slideshow__slide.is-selected .slideshow__image_tag")
                  .height();
                $(t)
                  .find(".flickity-viewport")
                  .css("height", o + "px");
              }
            });
        },
        init: function () {
          var t = this,
            a = $(t.slideshow),
            e = a.data("autoplay"),
            o = a.data("speed"),
            n = a.find(".slideshow__image"),
            r = new Flickity(t.slideshow, {
              rightToLeft: theme.settings.rtl,
              bgLazyLoad: 1,
              imagesLoaded: !0,
              accessibility: !0,
              prevNextButtons: !0,
              pageDots: !0,
              contain: !0,
              wrapAround: !0,
              setGallerySize: !1,
              autoPlay: !!e && o,
              arrowShape: { x0: 10, x1: 60, y1: 50, x2: 60, y2: 45, x3: 15 },
              on: {
                ready: function () {
                  if (
                    a.hasClass("slideshow--auto") &&
                    0 <
                      a.find(
                        ".slideshow__slide.is-selected .slideshow__image_tag"
                      ).length
                  ) {
                    var c = a
                      .find(
                        ".slideshow__slide.is-selected .slideshow__image_tag"
                      )
                      .height();
                    a.find(".flickity-viewport").css("height", c + "px");
                  }
                  if (theme.settings.animation) {
                    var d = new TimelineLite(),
                      l = a.find(".flickity-slider"),
                      u = a.find(".slider-content-wrapper"),
                      f = a.find(".flickity-button svg"),
                      h = a.find(".flickity-page-dots");
                    d.fromTo(
                      l,
                      2,
                      { scale: 1.2 },
                      { ease: Power4.easeInOut, scale: 1 },
                      0
                    ),
                      d.fromTo(
                        u,
                        2.4,
                        { opacity: 0 },
                        { ease: Power4.easeInOut, opacity: 1 },
                        1
                      ),
                      d.fromTo(
                        [f, h],
                        2,
                        { opacity: 0 },
                        { ease: Power4.easeInOut, opacity: 1 },
                        1.3
                      );
                  }
                },
                change: function (c) {
                  if (0 < $(a.find(".slideshow__slide")[c]).length) {
                    var d = $(a.find(".slideshow__slide")[c])
                      .find(".slideshow__image_tag")
                      .height();
                    a.find(".flickity-viewport").css("height", d + "px");
                  }
                  if (
                    $(a.find(".slideshow__slide")[c]).hasClass(
                      "slideshow__video_background"
                    )
                  ) {
                    var l =
                      "SlideshowVideo-" +
                      $(a.find(".slideshow__slide")[c]).data("block_id");
                    0 < $("#" + l).length && theme.SlideshowVideo.playVideo(l);
                  } else
                    0 < a.find(".slideshow__video_item").length &&
                      a.find(".slideshow__video_item").each(function () {
                        var u = "SlideshowVideo-" + $(this).data("block_id");
                        0 < $("#" + u).length &&
                          theme.SlideshowVideo.pauseVideo(u);
                      });
                },
              },
            });
          r.on("scroll", function () {
            r.slides.forEach(function (c, d) {
              var l = n[d],
                u = 0;
              l &&
                ((u =
                  d === 0
                    ? Math.abs(r.x) > r.slidesWidth
                      ? r.slidesWidth +
                        r.x +
                        r.slides[r.slides.length - 1].outerWidth +
                        c.target
                      : c.target + r.x
                    : d === r.slides.length - 1 &&
                      Math.abs(r.x) + r.slides[d].outerWidth < r.slidesWidth
                    ? c.target - r.slidesWidth + r.x - r.slides[d].outerWidth
                    : c.target + r.x),
                typeof window.mobileCheck != "undefined" &&
                  !window.mobileCheck() &&
                  !theme.settings.rtl &&
                  (l.style.transform = "translateX(" + u * (-1 / 2) + "px)"));
            });
          });
        },
        onSelect: function () {
          typeof theme.roarAdminJs != "undefined" &&
            theme.roarAdminJs.refresh();
        },
      })),
      s
    );
  })()),
  (theme.Slideshow = (function () {
    function s(c) {
      (this.$slideshow = $(c)),
        (this.$wrapper = this.$slideshow.closest("." + r.wrapper)),
        (this.$pause = this.$wrapper.find("." + r.pauseButton));
      var d = this.$slideshow.data("arrows") || !1,
        l = this.$slideshow.data("dots") || !1,
        u = this.$slideshow.data("autoplay") || !1,
        f = parseInt(this.$slideshow.data("speed")) || 7e3,
        h = parseInt(this.$slideshow.data("per_view")) || 1;
      (this.settings = {
        mediaQueryMediumUp: "screen and (min-width: 768px)",
        mediaQuerySmall: "screen and (max-width: 767px)",
        arrows: d,
        dots: l,
        autoplay: u,
        speed: f,
        per_view: h,
        sliderImagesActive: !1,
      }),
        this.initBreakpoints();
    }
    function t(c, d) {
      var l = d.$slider,
        u = d.$list,
        f = this.$wrapper,
        h = this.settings.autoplay;
      u.removeAttr("aria-live"),
        f.on("focusin", function (P) {
          f.has(P.target).length &&
            (u.attr("aria-live", "polite"), h && l.slick("slickPause"));
        }),
        f.on("focusout", function (P) {
          if (f.has(P.target).length && (u.removeAttr("aria-live"), h)) {
            if ($(P.target).hasClass(r.closeVideoBtn)) return;
            l.slick("slickPlay");
          }
        }),
        d.$dots &&
          d.$dots.on("keydown", function (P) {
            P.which === 37 && l.slick("slickPrev"),
              P.which === 39 && l.slick("slickNext"),
              (P.which === 37 || P.which === 39) &&
                d.$dots.find(".slick-active button").focus();
          }),
        l.find("." + r.currentSlide).addClass("slick-anim");
      var b = new TimelineLite(),
        C = l.find(".slideshow__text-text"),
        I = l.find(".slick-arrow svg"),
        T = l.find(".slick-dots");
      b.fromTo(l, 2, { scale: 1.2 }, { ease: Power4.easeInOut, scale: 1 }, 0),
        b.fromTo(
          C,
          2.4,
          { opacity: 0 },
          { ease: Power4.easeInOut, opacity: 1 },
          1
        ),
        b.fromTo(
          [I, T],
          2,
          { opacity: 0 },
          { ease: Power4.easeInOut, opacity: 1 },
          1.3
        );
    }
    function a(c, d, l, u, f) {
      var h = d.$slider,
        b = h.find("." + r.currentSlide),
        C = h.find('.slick-slide[data-slick-index="' + u + '"]');
      if (o(b)) {
        var I = b.find("." + r.video),
          T = I.attr("id");
        theme.SlideshowVideo.pauseVideo(T), I.attr("tabindex", "-1");
      }
      if (o(C)) {
        var P = C.find("." + r.video),
          O = P.attr("id"),
          V = P.hasClass(r.videoBackground);
        V ? theme.SlideshowVideo.playVideo(O) : P.attr("tabindex", "0");
      }
      b.removeClass("slick-anim"),
        h
          .find('.slick-slide[data-slick-index="' + f + '"]')
          .addClass("slick-anim"),
        h.find(".slick-arrow").addClass("disabled");
    }
    function e(c, d) {
      d.$slider.find(".slick-arrow").removeClass("disabled");
    }
    function o(c) {
      return c.find("." + r.video).length;
    }
    function n(c) {
      return "#Slideshow-" + c.data("id");
    }
    this.$slideshow = null;
    var r = {
      wrapper: "slideshow-wrapper",
      slideshow: "slideshow",
      currentSlide: "slick-current",
      video: "slideshow__video",
      videoBackground: "slideshow__video--background",
      closeVideoBtn: "slideshow__video-control--close",
      pauseButton: "slideshow__pause",
      isPaused: "is-paused",
    };
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        initBreakpoints: function () {
          var c = this;
          enquire.register(c.settings.mediaQuerySmall, {
            match: function () {
              c.settings.sliderImagesActive && c.destroyImageSlider(),
                c.initImageSlider();
            },
          }),
            enquire.register(c.settings.mediaQueryMediumUp, {
              match: function () {
                c.settings.sliderImagesActive && c.destroyImageSlider(),
                  c.initImageSlider(!1);
              },
            });
        },
        destroyImageSlider: function () {
          $(this.$slideshow).slick("unslick"),
            (this.settings.sliderImagesActive = !1);
        },
        initImageSlider: function (c) {
          typeof c == "undefined" && (c = !0);
          var d = {
            rtl: theme.settings.rtl,
            accessibility: !0,
            arrows: this.settings.arrows,
            dots: this.settings.dots,
            fade: !this.settings.per_view,
            speed: 1e3,
            delay: 1600,
            draggable: !0,
            autoplay: this.settings.autoplay,
            autoplaySpeed: this.settings.speed,
            slidesToShow: this.settings.per_view,
            slidesToScroll: 1,
            prevArrow:
              '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
            nextArrow:
              '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
          };
          c == !0 &&
            ((d.fade = !1),
            (d.draggable = !0),
            (d.slidesToShow = 1),
            (d.arrows = !1),
            (d.dots = !0)),
            this.$slideshow.on("beforeChange", a.bind(this)),
            this.$slideshow.on("afterChange", e.bind(this)),
            this.$slideshow.on("init", t.bind(this)),
            this.$slideshow.slick(d),
            this.$pause.on("click", this.togglePause.bind(this)),
            (this.settings.sliderImagesActive = !0);
        },
        togglePause: function () {
          var c = n(this.$pause);
          this.$pause.hasClass(r.isPaused)
            ? (this.$pause.removeClass(r.isPaused), $(c).slick("slickPlay"))
            : (this.$pause.addClass(r.isPaused), $(c).slick("slickPause"));
        },
      })),
      s
    );
  })());
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos(),
    theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}
(theme.SlideshowVideo = (function () {
  function s(y) {
    if (
      y.length &&
      ((D[y.attr("id")] = {
        id: y.attr("id"),
        videoId: y.data("id"),
        type: y.data("type"),
        status: y.data("type") === "chrome" ? "closed" : "background",
        videoSelector: y.attr("id"),
        $parentSlide: y.closest("." + A.slide),
        $parentSlideshowWrapper: y.closest("." + A.slideshowWrapper),
        controls: y.data("type") === "background" ? 0 : 1,
        slideshow: y.data("slideshow"),
      }),
      !K)
    ) {
      var x = document.createElement("script");
      x.src = "https://www.youtube.com/iframe_api";
      var z = document.getElementsByTagName("script")[0];
      z.parentNode.insertBefore(x, z);
    }
  }
  function t(y) {
    (Q || G) && (!y || typeof B[y].playVideo != "function" || e(y));
  }
  function a(y) {
    if (K) {
      var x = $.extend({}, Y, D[y]);
      (x.playerVars.controls = x.controls), (B[y] = new YT.Player(y, x)), O();
    }
  }
  function e(y, x) {
    var z = D[y],
      J = B[y],
      W = D[y].$parentSlide;
    if (G) l(z);
    else if (x || (V && U))
      return W.removeClass(A.loading), l(z), void J.playVideo();
    V || n(J, W);
  }
  function o(y) {
    var x = y ? A.supportsAutoplay : A.supportsNoAutoplay;
    $(document.documentElement).addClass(x), y || (G = !0), (V = !0);
  }
  function n(y, x) {
    y.playVideo(),
      r(y)
        .then(function () {
          o(!0);
        })
        .fail(function () {
          o(!1), y.stopVideo();
        })
        .always(function () {
          (V = !0), x.removeClass(A.loading);
        });
  }
  function r(y) {
    var x,
      z,
      J = $.Deferred();
    return (
      (x = setInterval(function () {
        0 >= y.getCurrentTime() ||
          ((U = !0), clearInterval(x), clearTimeout(z), J.resolve());
      }, 500)),
      (z = setTimeout(function () {
        clearInterval(x), J.reject();
      }, 4e3)),
      J
    );
  }
  function c() {
    Q ||
      ((750 > $(window).width() ||
        (typeof window.mobileCheck != "undefined" && window.mobileCheck())) &&
        (G = !0),
      G && o(!1),
      (Q = !0));
  }
  function d(y) {
    switch (y.type) {
      case "background":
        B[y.id].seekTo(0);
        break;
      case "background-chrome":
        B[y.id].seekTo(0), f(y.id);
        break;
      case "chrome":
        f(y.id);
    }
  }
  function l(y) {
    var x = y.$parentSlideshowWrapper,
      z = y.$parentSlide;
    if ((z.removeClass(A.loading), y.status !== "background")) {
      switch (($("#" + y.id).attr("tabindex", "0"), y.type)) {
        case "chrome":
        case "background-chrome":
          x.removeClass(A.paused).addClass(A.playing),
            z.removeClass(A.paused).addClass(A.playing);
      }
      z.find("." + A.closeVideoBtn).focus();
    }
  }
  function u(y) {
    var x = y.$parentSlideshowWrapper,
      z = y.$parentSlide;
    return y.type === "background-chrome"
      ? void f(y.id)
      : (y.status !== "closed" &&
          y.type !== "background" &&
          (x.addClass(A.paused), z.addClass(A.paused)),
        y.type === "chrome" &&
          y.status === "closed" &&
          (x.removeClass(A.paused), z.removeClass(A.paused)),
        x.removeClass(A.playing),
        void z.removeClass(A.playing));
  }
  function f(y) {
    var x = D[y],
      z = x.$parentSlideshowWrapper,
      J = x.$parentSlide,
      W = [A.pause, A.playing].join(" ");
    switch (
      ($("#" + x.id).attr("tabindex", "-1"), (x.status = "closed"), x.type)
    ) {
      case "background-chrome":
        B[y].mute(), P(y);
        break;
      case "chrome":
        B[y].stopVideo(), u(x);
    }
    z.removeClass(W), J.removeClass(W);
  }
  function h(y) {
    var x = y.target.getIframe().id;
    return D[x];
  }
  function b(y) {
    var x = D[y];
    switch ((x.$parentSlide.addClass(A.loading), (x.status = "open"), x.type)) {
      case "background-chrome":
        T(y, x), B[y].unMute(), e(y, !0);
        break;
      case "chrome":
        e(y, !0);
    }
    $(document).on("keydown.videoPlayer", function (z) {
      z.keyCode === 27 && f(y);
    });
  }
  function C() {
    $("." + A.videoBackground).each(function (y, x) {
      I($(x));
    });
  }
  function I(y) {
    var x = y.closest("." + A.slide);
    if (!x.hasClass(A.slickClone)) {
      var z = x.width(),
        J = y.width(),
        W = y.height();
      z / Y.ratio < W
        ? ((J = Math.ceil(W * Y.ratio)),
          y
            .width(J)
            .height(W)
            .css({ left: (z - J) / 2, top: 0 }))
        : ((W = Math.ceil(z / Y.ratio)),
          y
            .width(z)
            .height(W)
            .css({ left: 0, top: (W - W) / 2 })),
        y.prepareTransition().addClass(A.loaded);
    }
  }
  function T(y) {
    $("#" + y)
      .removeAttr("style")
      .removeClass(A.videoBackground)
      .addClass(A.videoChrome),
      D[y].$parentSlideshowWrapper
        .removeClass(A.slideBackgroundVideo)
        .addClass(A.playing),
      D[y].$parentSlide.removeClass(A.slideBackgroundVideo).addClass(A.playing),
      (D[y].status = "open");
  }
  function P(y) {
    var x = $("#" + y)
      .addClass(A.videoBackground)
      .removeClass(A.videoChrome);
    D[y].$parentSlide.addClass(A.slideBackgroundVideo),
      (D[y].status = "background"),
      I(x);
  }
  function O() {
    $(document).on("click.videoPlayer", "." + A.playVideoBtn, function (y) {
      var x = $(y.currentTarget).data("controls");
      b(x);
    }),
      $(document).on("click.videoPlayer", "." + A.closeVideoBtn, function (y) {
        var x = $(y.currentTarget).data("controls");
        f(x);
      }),
      $(window).on(
        "resize.videoPlayer",
        $.debounce(250, function () {
          K && C();
        })
      );
  }
  var V = !1,
    U = !1,
    Q = !1,
    G = !1,
    K = !1,
    D = {},
    B = [],
    Y = {
      ratio: 16 / 9,
      playerVars: {
        iv_load_policy: 3,
        modestbranding: 1,
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        wmode: "opaque",
        branding: 0,
        autohide: 0,
        rel: 0,
      },
      events: {
        onReady: function (y) {
          y.target.setPlaybackQuality("hd1080");
          var x = h(y);
          switch ((c(), $("#" + x.id).attr("tabindex", "-1"), C(), x.type)) {
            case "background-chrome":
            case "background":
              y.target.mute(),
                x.$parentSlide
                  .closest("." + A.slickSlide)
                  .hasClass(A.currentSlide) && e(x.id);
          }
          x.$parentSlide.addClass(A.loaded);
        },
        onStateChange: function (y) {
          var x = h(y);
          switch (y.data) {
            case 0:
              d(x);
              break;
            case 1:
              l(x);
              break;
            case 2:
              u(x);
          }
        },
      },
    },
    A = {
      playing: "video-is-playing",
      paused: "video-is-paused",
      loading: "video-is-loading",
      loaded: "video-is-loaded",
      slideshowWrapper: "slideshow-wrapper",
      slide: "slideshow__slide",
      slideBackgroundVideo: "slideshow__slide--background-video",
      slideDots: "slick-dots",
      videoChrome: "slideshow__video--chrome",
      videoBackground: "slideshow__video--background",
      playVideoBtn: "slideshow__video-control--play",
      closeVideoBtn: "slideshow__video-control--close",
      currentSlide: "slick-current",
      slickSlide: "slick-slide",
      slickClone: "slick-cloned",
      supportsAutoplay: "autoplay",
      supportsNoAutoplay: "no-autoplay",
    };
  return {
    init: s,
    loadVideos: function () {
      for (var y in D)
        if (D.hasOwnProperty(y)) {
          var x = $.extend({}, Y, D[y]);
          (x.playerVars.controls = x.controls), (B[y] = new YT.Player(y, x));
        }
      O(), (K = !0);
    },
    loadVideo: a,
    playVideo: t,
    pauseVideo: function (y) {
      B[y] && typeof B[y].pauseVideo == "function" && B[y].pauseVideo();
    },
    removeEvents: function () {
      $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
    },
  };
})()),
  (function () {
    var s = $("#BlogTagFilter");
    s.length &&
      s.on("change", function () {
        location.href = $(this).val();
      });
  })(),
  (window.theme = theme || {}),
  (theme.customerTemplates = (function () {
    function s() {
      $(document).off("click", "#RecoverPassword"),
        $(document).on("click", "#RecoverPassword", function (n) {
          n.preventDefault(), t();
        }),
        $(document).off("click", "#HideRecoverPasswordLink"),
        $(document).on("click", "#HideRecoverPasswordLink", function (n) {
          n.preventDefault(), t();
        });
    }
    function t() {
      $("#RecoverPasswordForm").toggleClass("hide"),
        $("#CustomerLoginForm").toggleClass("hide");
    }
    function a() {
      var n = $(".reset-password-success");
      n.length && $("#ResetSuccess").removeClass("hide");
    }
    function e() {
      var n = $("#AddressNewForm");
      n.length &&
        (Shopify &&
          new Shopify.CountryProvinceSelector(
            "AddressCountryNew",
            "AddressProvinceNew",
            { hideElement: "AddressProvinceContainerNew" }
          ),
        $(".address-country-option").each(function () {
          var r = $(this).data("form-id");
          new Shopify.CountryProvinceSelector(
            "AddressCountry_" + r,
            "AddressProvince_" + r,
            { hideElement: "AddressProvinceContainer_" + r }
          );
        }),
        $(".address-new-toggle").on("click", function () {
          n.toggleClass("hide");
        }),
        $(".address-edit-toggle").on("click", function () {
          var r = $(this).data("form-id");
          $("#EditAddress_" + r).toggleClass("hide");
        }),
        $(".address-delete").on("click", function () {
          var r = $(this),
            c = r.data("form-id"),
            d = r.data("confirm-message");
          confirm(d || "Are you sure you wish to delete this address?") &&
            Shopify.postLink("/account/addresses/" + c, {
              parameters: { _method: "delete" },
            });
        }));
    }
    function o() {
      var n = window.location.hash;
      n === "#recover" && t();
    }
    return {
      init: function () {
        o(), s(), a(), e();
      },
    };
  })()),
  (theme.Cart = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.settings = { namespace: "#CartSection-" + e, sectionId: e }),
        (this.selectors = {
          quantity: ".item__qty-" + e,
          agree: "#cart__agree-" + e,
          checkout:
            ".cart__checkout-" +
            e +
            ' [name="checkout"], .cart__checkout-' +
            e +
            ' [name="goto_pp"], .cart__checkout-' +
            e +
            ' [name="goto_gc"]',
          remove: ".item__remove-" + e,
          update: ".cart__update-" + e,
        }),
        this._qtyCart(),
        this._checkoutCart(),
        this._removeCart(),
        this._updateCart(),
        this._productsSlider();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _removeCart: function () {
          var t = this;
          $(document).off("click", t.selectors.remove),
            $(document).on("click", t.selectors.remove, function (a) {
              a.preventDefault();
              var e = $(this),
                o = e.attr("href"),
                n = $(t.settings.namespace);
              n.addClass("loading"),
                $.post(o, function () {
                  $.get("/cart?view=popup", function (r) {
                    n.html($(r).find(t.settings.namespace).html()),
                      setTimeout(function () {
                        n.removeClass("loading"), theme.MiniCart.update();
                        var c = new theme.Sections();
                        c.register("cart-gift-popup", theme.CartGift),
                          c.register(
                            "shipping-calculator-popup",
                            theme.ShippingCalculator
                          );
                      }, 100);
                  });
                });
            });
        },
        _updateCart: function () {
          var t = this;
          $(document).off("click", t.selectors.update),
            $(document).on("click", t.selectors.update, function (a) {
              a.preventDefault();
              var e = $(this).closest("form"),
                o = $(t.settings.namespace);
              return (
                $.ajax({
                  type: "POST",
                  url: "/cart/update.js",
                  async: !0,
                  cache: !1,
                  data: e.serialize(),
                  dataType: "json",
                  beforeSend: function () {
                    o.addClass("loading");
                  },
                  success: function () {
                    $.get("/cart?view=popup", function (n) {
                      o.html($(n).find(t.settings.namespace).html()),
                        setTimeout(function () {
                          o.removeClass("loading"), theme.MiniCart.update();
                          var r = new theme.Sections();
                          r.register("cart-gift-popup", theme.CartGift),
                            r.register(
                              "shipping-calculator-popup",
                              theme.ShippingCalculator
                            );
                        }, 100);
                    });
                  },
                }),
                !1
              );
            });
        },
        _qtyCart: function () {
          var t = this;
          $(document).off("click", t.selectors.quantity + " .plus"),
            $(document).on(
              "click",
              t.selectors.quantity + " .plus",
              function () {
                var a = $(this).parent(),
                  e = a.find(".qty"),
                  o = parseInt(e.val());
                ++o, e.val(o);
              }
            ),
            $(document).off("click", t.selectors.quantity + " .minus"),
            $(document).on(
              "click",
              t.selectors.quantity + " .minus",
              function () {
                var a = $(this).parent(),
                  e = a.find(".qty"),
                  o = parseInt(e.val());
                0 < o && (--o, e.val(o));
              }
            );
        },
        _checkoutCart: function () {
          var t = this;
          $(t.selectors.agree).length &&
            ($(document).off("click", t.selectors.checkout),
            $(document).on("click", t.selectors.checkout, function () {
              if ($(t.selectors.agree).length) {
                var a = $(this),
                  e = $(t.selectors.agree);
                if (e.is(":checked")) a.submit();
                else {
                  var o = e.data("message");
                  return alert(o), !1;
                }
              }
            }),
            $(document).on("change", t.selectors.agree, function () {
              var a = $(this);
              a.is(":checked")
                ? $(t.selectors.checkout).removeClass("btn-disabled")
                : $(t.selectors.checkout).addClass("btn-disabled");
            }));
        },
        _productsSlider: function () {
          var t = new theme.Sections();
          t.register("products-slider-sub", theme.ProductsSlider);
        },
        _lineItem: function () {
          theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
          var t = new theme.Sections();
          t.register("line_item", theme.LineItem),
            t.register("countdown-timer", theme.CountdownTimer);
        },
        onLoad: function () {
          this._lineItem();
        },
        onUnload: function () {
          this.$container.off(this.settings.namespace);
        },
      })),
      s
    );
  })()),
  (theme.ShippingCalculator = (function () {
    function ShippingCalculator(s) {
      var t = (this.$container = $(s)),
        a = t.attr("data-section-id");
      (this.selectors = {
        shipping_btn: "#cart__shipping-btn-" + a,
        shipping_calculator: "#shipping__calculator-" + a,
        get_rates: "#shipping__calculator-btn-" + a,
        response: "#shipping__calculator-response-" + a,
        template:
          '<p id ="shipping-rates-feedback-' +
          a +
          '" class="shipping-rates-feedback"></p>',
        address_country: "address_country-" + a,
        address_province: "address_province-" + a,
        address_zip: "address_zip-" + a,
        address_province_label: "address_province_label-" + a,
        address_province_container: "address_province_container-" + a,
      }),
        (this.strings = {
          submitButton: theme.strings.shippingButton,
          submitButtonDisabled: theme.strings.shippingButtonDisabled,
          customerIsLoggedIn: theme.settings.customerIsLoggedIn,
          moneyFormat: theme.settings.moneyFormat,
        }),
        this._init();
    }
    return (
      (ShippingCalculator.prototype = _.assignIn(
        {},
        ShippingCalculator.prototype,
        {
          _disableButtons: function () {
            var s = this.selectors,
              t = this.strings;
            $(s.get_rates)
              .text(t.submitButtonDisabled)
              .attr("disabled", "disabled")
              .addClass("disabled");
          },
          _enableButtons: function () {
            var s = this.selectors,
              t = this.strings;
            $(s.get_rates)
              .removeAttr("disabled")
              .removeClass("disabled")
              .text(t.submitButton);
          },
          _render: function (s) {
            var t = this.selectors,
              a = this.strings,
              e = $(t.template),
              o = $(t.response);
            if (o.length) {
              if (!s.success) e.addClass("error"), e.append(s.errorFeedback);
              else if ((e.addClass("success"), s.rates)) {
                e.append(s.rates);
                var n = s.rates;
                if (n[0]) {
                  var r = n[0];
                  e.append(
                    'Rates start at <span class="money">' + r.price + "</span>."
                  );
                }
              } else e.append("We do not ship to this destination.");
              e.appendTo(o);
            }
          },
          _formatRate: function (s) {
            function t(d, l) {
              return typeof d == "undefined" ? l : d;
            }
            function a(d, l, u, f) {
              if (
                ((l = t(l, 2)),
                (u = t(u, ",")),
                (f = t(f, ".")),
                isNaN(d) || d == null)
              )
                return 0;
              d = (d / 100).toFixed(l);
              var h = d.split("."),
                b = h[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + u),
                C = h[1] ? f + h[1] : "";
              return b + C;
            }
            var e = this.selectors,
              o = this.strings;
            if (typeof Shopify.formatMoney == "function")
              return Shopify.formatMoney(s, o.moneyFormat);
            typeof s == "string" && (s = s.replace(".", ""));
            var n = "",
              r = /\{\{\s*(\w+)\s*\}\}/,
              c = o.moneyFormat;
            switch (c.match(r)[1]) {
              case "amount":
                n = a(s, 2);
                break;
              case "amount_no_decimals":
                n = a(s, 0);
                break;
              case "amount_with_comma_separator":
                n = a(s, 2, ".", ",");
                break;
              case "amount_no_decimals_with_comma_separator":
                n = a(s, 0, ".", ",");
            }
            return c.replace(r, n);
          },
          _onCartShippingRatesUpdate: function (s, t) {
            var a = this,
              e = this.selectors,
              o = this.strings;
            a._enableButtons();
            var n = "";
            if (
              (t.zip && (n += t.zip + ", "),
              t.province && (n += t.province + ", "),
              (n += t.country),
              s.length)
            )
              for (var r = 0; r < s.length; r++)
                s[r].price = a._formatRate(s[r].price);
            a._render({ rates: s, address: n, success: !0 }),
              $(e.response).fadeIn();
          },
          _pollForCartShippingRatesForDestination: function (s) {
            var t = this,
              a = this.selectors,
              e = this.strings,
              o = function () {
                $.ajax("/cart/async_shipping_rates", {
                  dataType: "json",
                  success: function (n, r, c) {
                    c.status === 200
                      ? t._onCartShippingRatesUpdate(n.shipping_rates, s)
                      : setTimeout(o, 500);
                  },
                  error: function (n, r) {
                    t._onError(n, r, t);
                  },
                });
              };
            return o;
          },
          _fullMessagesFromErrors: function (s) {
            var t = this.selectors,
              a = this.strings,
              e = [];
            return (
              $.each(s, function (o, n) {
                $.each(n, function (r, c) {
                  e.push(o + " " + c);
                });
              }),
              e
            );
          },
          _onError: function (XMLHttpRequest, textStatus, self) {
            var selectors = self.selectors,
              strings = self.strings;
            self._enableButtons();
            var feedback = "",
              data = eval("(" + XMLHttpRequest.responseText + ")");
            (feedback = data.message
              ? data.message + "(" + data.status + "): " + data.description
              : "Error : " +
                self._fullMessagesFromErrors(data).join("; ") +
                "."),
              feedback == "Error : country is not supported." &&
                (feedback = "We do not ship to this destination."),
              self._render({ rates: [], errorFeedback: feedback, success: !1 }),
              $(selectors.response).show();
          },
          _getCartShippingRatesForDestination: function (s) {
            var t = this,
              a = this.selectors,
              e = this.strings;
            $.ajax({
              type: "POST",
              url: "/cart/prepare_shipping_rates",
              data: $.param({ shipping_address: s }),
              success: t._pollForCartShippingRatesForDestination(s),
              error: function (o, n) {
                t._onError(o, n, t);
              },
            });
          },
          _init: function () {
            var s = this,
              t = this.selectors,
              a = this.strings;
            if ($(t.shipping_calculator).length) {
              new Shopify.CountryProvinceSelector(
                t.address_country,
                t.address_province,
                { hideElement: t.address_province_container }
              );
              var e = $("#" + t.address_country),
                o = $("#" + t.address_province_label).get(0);
              typeof Countries != "undefined" &&
                (Countries.updateProvinceLabel(e.val(), o),
                e.change(function () {
                  Countries.updateProvinceLabel(e.val(), o);
                })),
                $(t.get_rates).off("click"),
                $(t.get_rates).click(function () {
                  s._disableButtons(), $(t.response).empty().hide();
                  var n = {};
                  (n.zip = $("#" + t.address_zip).val() || ""),
                    (n.country = $("#" + t.address_country).val() || ""),
                    (n.province = $("#" + t.address_province).val() || ""),
                    s._getCartShippingRatesForDestination(n);
                }),
                a.customerIsLoggedIn &&
                  $(t.get_rates + ":eq(0)").trigger("click"),
                $(t.shipping_btn).off("click"),
                $(t.shipping_btn).click(function () {
                  $(t.shipping_calculator).slideToggle();
                });
            }
          },
        }
      )),
      ShippingCalculator
    );
  })()),
  (theme.CartGift = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.selectors = {
        gift: "#gift__wrapping-" + e,
        namespace: "#CartSection-" + e,
        redirect: !0,
      }),
        this.init();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        check: function () {
          var t = this,
            a = this.selectors;
          if ($(a.gift).length) {
            var e = $(a.gift).data("gift_case");
            e === 1 ? t.remove() : (e === 2 || e === 3 || e === 3) && t.set();
          }
        },
        set: function () {
          var t = this,
            a = this.selectors;
          if ($(a.gift).length) {
            var e = $(a.gift).data("product_id"),
              o = {};
            o[e] = 1;
            var n = {};
            n["gift-wrapping"] = !0;
            var r = {};
            (r.updates = o),
              (r.attributes = n),
              $.ajax({
                type: "POST",
                url: "/cart/update.js",
                data: r,
                dataType: "json",
                beforeSend: function () {
                  a.redirect || $(a.namespace).addClass("loading");
                },
                success: function () {
                  if (a.redirect) location.href = "/cart";
                  else {
                    var c = $(a.namespace);
                    $.get("/cart?view=popup", function (d) {
                      c.html($(d).find(a.namespace).html()),
                        setTimeout(function () {
                          c.removeClass("loading"), theme.MiniCart.update();
                          var l = new theme.Sections();
                          l.register(
                            "shipping-calculator-popup",
                            theme.ShippingCalculator
                          );
                        }, 100);
                    });
                  }
                },
              });
          }
        },
        remove: function () {
          var t = this,
            a = this.selectors;
          if ($(a.gift).length) {
            var e = $(a.gift).data("product_id"),
              o = {};
            o[e] = 0;
            var n = {};
            n["gift-wrapping"] = "";
            var r = {};
            (r.updates = o),
              (r.attributes = n),
              $.ajax({
                type: "POST",
                url: "/cart/update.js",
                data: r,
                dataType: "json",
                beforeSend: function () {
                  a.redirect || $(a.namespace).addClass("loading");
                },
                success: function () {
                  if (a.redirect) location.href = "/cart";
                  else {
                    var c = $(a.namespace);
                    $.get("/cart?view=popup", function (d) {
                      c.html($(d).find(a.namespace).html()),
                        setTimeout(function () {
                          c.removeClass("loading"), theme.MiniCart.update();
                          var l = new theme.Sections();
                          l.register(
                            "shipping-calculator-popup",
                            theme.ShippingCalculator
                          );
                        }, 100);
                    });
                  }
                },
              });
          }
        },
        init: function () {
          var t = this,
            a = this.selectors;
          $(a.gift).length &&
            ($(a.gift).data("redirect") == !1 && (this.selectors.redirect = !1),
            t.check(),
            $(document).off("change", a.gift),
            $(document).on("change", a.gift, function () {
              $(this).is(":checked") ? t.set() : t.remove();
            }));
        },
      })),
      s
    );
  })()),
  (theme.Filters = (function () {
    function s(e) {
      var o = (this.$container = $(e));
      (this.$limitSelect = $(a.limitSelection, o)),
        (this.$sortSelect = $(a.sortSelection, o)),
        (this.$selects = $(a.limitSelection, o).add($(a.sortSelection, o))),
        (this.defaultLimit = this._getDefaultLimitValue()),
        (this.defaultSort = this._getDefaultSortValue()),
        this._resizeSelect(this.$selects),
        this.$selects.removeClass("hidden"),
        this.$limitSelect.on("change", this._onLimitChange.bind(this)),
        this.$sortSelect.on("change", this._onSortChange.bind(this)),
        $(document).on(
          "change",
          a.filterSelection,
          this._onFilterChange.bind(this)
        ),
        $(document).on("click", a.filterClear, this._onFilterClear.bind(this)),
        $(document).on("click", a.pageSelection, this._onPageClick.bind(this)),
        $(document).on(
          "click",
          a.loadMoreSelection,
          this._onLoadMoreClick.bind(this)
        ),
        $(document).on("click", a.viewSelection, this._onViewClick.bind(this)),
        this._onLoadMoreInfinite(a.loadMoreSelection),
        this._initFiltersHtml(),
        this._initFiltersActive(),
        this._filterClearAll();
    }
    var t = {
        SORT_BY: "sort_by",
        LIMIT: "limit",
        PAGE: "page",
        VIEW: "view",
        CONSTRAINT: "constraint",
      },
      a = {
        limitSelection: "#PerPage",
        defaultLimit: "#DefaultPerPage",
        sortSelection: "#SortBy",
        defaultSort: "#DefaultSortBy",
        viewSelection: ".shop__view",
        pageSelection: "#site-pagination a.btn",
        loadMoreSelection: "#site-pagination .loadmore",
        filtersSelection: ".sidebar__btn",
        filterSelection: ".advanced-filter .filter",
        filterClear: ".site-widget.filtering .clear",
      };
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _initFiltersHtml: function () {
          $(".shop__filtering").length &&
            $(".shop__filtering-inner")
              .empty()
              .append($(".site-sidebar").html());
        },
        _initFiltersActive: function () {
          if ($(".filters__active").length) {
            var e = $(".filters__active .clear_nav").empty();
            $(".site-sidebar .site-widget.filtering").each(function () {
              var o = $(this);
              if (o.find(".filter-tag.active").length) {
                var n = o.find(".filter-tag.active label").clone();
                e.append(n);
              } else if (
                o.find(".filter-tag select").length &&
                o.find(".filter-tag select").val() != ""
              ) {
                var n =
                  '<label for="' +
                  o.find(".filter-tag input").attr("id") +
                  '">' +
                  o.find(".filter-tag select").val() +
                  "</label>";
                e.append(n);
              }
            }),
              e.find("label").length
                ? $(".filters__active").show()
                : $(".filters__active").hide();
          }
        },
        _filterClearAll: function () {
          var e = this;
          $(".filters__active").length &&
            $(".filters__active").on("click", ".clear_all", function () {
              delete Shopify.queryParams[t.CONSTRAINT], e._filterAjaxClick(!0);
            });
        },
        _onFilterClear: function (e) {
          var o = [];
          Shopify.queryParams[t.CONSTRAINT] &&
            (o = Shopify.queryParams[t.CONSTRAINT].split("+"));
          var n = $(e.currentTarget),
            r = n.closest(".site-widget.filtering"),
            c = r.find("select");
          0 < c.length &&
            c.find("option").each(function () {
              var l = $(this).val();
              if (l) {
                var u = o.indexOf(l);
                0 <= u && o.splice(u, 1);
              }
            });
          var d = r.find("input");
          0 < d.length &&
            d.each(function () {
              var l = $(this).val();
              if (l) {
                var u = o.indexOf(l);
                0 <= u && o.splice(u, 1);
              }
            }),
            o.length
              ? (Shopify.queryParams[t.CONSTRAINT] = o.join("+"))
              : delete Shopify.queryParams[t.CONSTRAINT],
            this._filterAjaxClick(!0);
        },
        _onFilterChange: function (e) {
          var o = $(e.currentTarget),
            n = o.closest(".advanced-filter"),
            r = o.closest(".filter-tag"),
            c = n.data("multi_choice"),
            d = [];
          if (
            (Shopify.queryParams[t.CONSTRAINT] &&
              (d = Shopify.queryParams[t.CONSTRAINT].split("+")),
            c == !1 && !r.hasClass("active"))
          ) {
            var l = n.find(".active input");
            0 < l.length &&
              l.each(function () {
                var b = $(this).val();
                if (b) {
                  var C = d.indexOf(b);
                  0 <= C && d.splice(C, 1);
                }
              });
          }
          var u = n.find("select");
          0 < u.length &&
            u.find("option").each(function () {
              var b = $(this).val();
              if (b) {
                var C = d.indexOf(b);
                0 <= C && d.splice(C, 1);
              }
            });
          var f = o.val();
          if (f) {
            var h = d.indexOf(f);
            0 <= h ? d.splice(h, 1) : d.push(f);
          }
          d.length
            ? (Shopify.queryParams[t.CONSTRAINT] = d.join("+"))
            : delete Shopify.queryParams[t.CONSTRAINT],
            this._filterAjaxClick(!0);
        },
        _onViewClick: function (e) {
          e.preventDefault();
          var o = $(e.currentTarget),
            n = $(a.viewSelection),
            r = o.data("view");
          r == "grid" && (r = r + "-" + o.data("per_row")),
            (Shopify.queryParams[t.VIEW] = r),
            this._filterAjaxClick(),
            n.removeClass("active"),
            o.addClass("active");
        },
        _onLoadMoreInfinite: function (e) {
          var o = $(e),
            n = o.closest(".ajax_load_button");
          if (n.hasClass("ajax_load_hidden")) {
            var r = Math.abs(0);
            $(window).scroll(function () {
              if (
                $("#site-primary .products").length &&
                $("#site-pagination").find("a.next").length
              ) {
                var c =
                    $("#site-primary .products").offset().top +
                    $("#site-primary .products").outerHeight(),
                  d = c - $(window).scrollTop();
                d - r < $(window).height() &&
                  parseInt($(e).attr("data-processing")) == 0 &&
                  $(e).trigger("click");
              }
            });
          }
        },
        _onLoadMoreClick: function (e) {
          e.preventDefault();
          var o = this,
            n = "#site-pagination .loadmore",
            r = "#site-pagination .ajax_load_button",
            c = "#site-primary .products .product",
            d = "#site-pagination";
          if (parseInt($(n).attr("data-processing")) != 1)
            if ($(d).find("a.next").length) {
              $(n).attr("data-processing", 1);
              var l = $(d).find("a.next").attr("href"),
                u = $(n).data("no_more");
              $(r).addClass("loading"),
                $.get(l, function (f) {
                  $(d).empty().html($(f).find(d).html()),
                    $(f)
                      .find(c)
                      .each(function () {
                        $(c).last().after($(this));
                      }),
                    $(r).removeClass("loading"),
                    $(n).attr("data-processing", 0),
                    $(d).find("a.next").length == 0 &&
                      ($(r)
                        .addClass("ajax_load_finished")
                        .removeClass("ajax_load_hidden"),
                      $(n)
                        .show()
                        .html(u)
                        .addClass("disabled")
                        .prop("disabled", !0));
                });
            } else {
              var u = $(n).attr("data-no-more");
              $(r)
                .addClass("ajax_load_finished")
                .removeClass("ajax_load_hidden"),
                $(n).show().html(u).addClass("disabled").prop("disabled", !0);
            }
        },
        _onPageClick: function (e) {
          e.preventDefault();
          var o = $(e.currentTarget),
            n = o.attr("href");
          this._filterGetContent(n);
        },
        _onSortChange: function (e) {
          var o = this.$sortSelect.val() || this.defaultSort;
          (Shopify.queryParams[t.SORT_BY] = o),
            this._filterAjaxClick(),
            this._resizeSelect($(e.target));
        },
        _onLimitChange: function (e) {
          var o = this.$limitSelect.val() || this.defaultLimit;
          (Shopify.queryParams[t.LIMIT] = o),
            this._filterAjaxClick(),
            this._resizeSelect($(e.target));
        },
        _getDefaultLimitValue: function () {
          return $(a.defaultLimit, this.$container).val();
        },
        _getDefaultSortValue: function () {
          return $(a.defaultSort, this.$container).val();
        },
        _resizeSelect: function (e) {
          e.each(function () {
            var o = $(this),
              n = o.find("option:selected").text(),
              r = $("<span>").html(n);
            r.appendTo("body");
            var c = r.width();
            r.remove(), o.width(c + 3);
          });
        },
        _filterAjaxClick: function (e) {
          typeof e == "undefined" && (e = !1), delete Shopify.queryParams.page;
          var o = this._filterCreateUrl();
          this._filterGetContent(o, e);
        },
        _filterCreateUrl: function () {
          var e = $.param(Shopify.queryParams).replace(/%2B/g, "+");
          return location.pathname + "?" + e;
        },
        _filterGetContent: function (e, o) {
          typeof o == "undefined" && (o = !1);
          var n = "#site-primary .product-found",
            r = "#site-primary .products .product",
            c = "#site-pagination",
            d = "#site-secondary .site-sidebar",
            l = this;
          $("body").removeClass("sidebar-open"),
            $(".shop__filtering").slideUp();
          var u = 40;
          $("#shopify-section-header-sticky").length &&
          $("#shopify-section-header-sticky").is(":visible")
            ? (u += $("#shopify-section-header-sticky").outerHeight())
            : $("#shopify-section-header-mobile").length &&
              $("#shopify-section-header-mobile").is(":visible") &&
              (u += $("#shopify-section-header-mobile").outerHeight()),
            $("html, body").animate(
              { scrollTop: $("#site-primary").offset().top - u },
              1200
            ),
            $.ajax({
              type: "GET",
              url: e,
              beforeSend: function () {
                $("body").addClass("loading");
              },
              complete: function () {
                $("body").removeClass("loading");
              },
              success: function (f) {
                if (
                  ($.fn.countdown &&
                    $("#site-primary .products")
                      .find(".product__countdown .is-countdown")
                      .each(function () {
                        $(this).countdown("destroy");
                      }),
                  $(c).empty().html($(f).find(c).html()),
                  o)
                ) {
                  $(d).empty().html($(f).find(d).html()),
                    $("#site-primary .shop__filtering-inner")
                      .empty()
                      .append($(d).html());
                  var h = new theme.Sections();
                  h.register("sidebar-sticky", theme.SidebarSticky);
                }
                $("#site-primary .products")
                  .empty()
                  .attr(
                    "class",
                    $(f).find("#site-primary .products").attr("class")
                  ),
                  0 < $(f).find(r).length
                    ? $(f)
                        .find(r)
                        .each(function () {
                          $("#site-primary .products").append($(this));
                        })
                    : $("#site-primary .products").append(
                        $(f).find("#site-primary .no-products")
                      ),
                  $(n).empty().html($(f).find(n).html()),
                  l._initFiltersActive();
                var b = $(f).filter("title").text();
                History.pushState({ param: Shopify.queryParams }, b, e);
              },
            });
        },
        _lineItem: function () {
          theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
          var e = new theme.Sections();
          e.register("line_item", theme.LineItem),
            e.register("countdown-timer", theme.CountdownTimer);
        },
        onLoad: function () {
          this._lineItem();
        },
        onUnload: function () {
          this.$limitSelect.off("change", this._onLimitChange),
            this.$sortSelect.off("change", this._onSortChange),
            $(document).off("click", a.viewSelection, this._onViewClick),
            $(document).off("click", a.pageSelection, this._onPageClick),
            $(document).off(
              "click",
              a.loadMoreSelection,
              this._onLoadMoreClick
            );
        },
      })),
      s
    );
  })()),
  (theme.SidebarSticky = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.settings = {
        selector: "#site-secondary .site-sidebar",
        primary: "#site-primary",
        toggle: "#site-secondary .site-widget__toggle",
      }),
        this.init(),
        this.update();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        init: function () {
          var t = $(this.settings.selector);
          if (!(992 > $(window).width())) {
            var a = 40,
              e = $(this.settings.primary);
            $(".site-header").hasClass("header-sticky") && (a = 60);
            var o = t.outerHeight() - e.outerHeight();
            -100 > o
              ? t.stick_in_parent({ offset_top: a })
              : 100 < o && e.stick_in_parent({ offset_top: a }),
              $(window).resize(function () {
                992 > $(window).width()
                  ? (t.trigger("sticky_kit:detach"),
                    e.trigger("sticky_kit:detach"))
                  : t.outerHeight() < e.outerHeight()
                  ? t.stick_in_parent({ offset_top: a })
                  : e.stick_in_parent({ offset_top: a });
              });
          }
        },
        update: function () {
          var t = this;
          $(t.settings.toggle).on("change", function () {
            $(document.body).trigger("sticky_kit:recalc");
          });
        },
      })),
      s
    );
  })()),
  (theme.HeaderMobile = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.selectors = {
        headerFixed: ".header__mobile.is-fixed",
        navOpenIcon: ".mobile-nav__open",
        navCloseIcon: ".mobile-nav__close",
        navWrapper: ".mobile-header__nav .mobile__menu",
        megaMenu: "#phantom__menu",
      }),
        this._initHeaderFixed(),
        this._initMenu(),
        this._productsSlider(),
        theme.Search.init(),
        theme.MiniCart.init();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _animMenu: function () {
          var t = new TimelineLite(),
            a = $(".mobile__menu .listitem-0"),
            e = $(".mobile__menu .listitem-0 > .listitem > .site-nav__link");
          theme.settings.rtl
            ? (t.fromTo(a, 0.1, { autoAlpha: 0 }, { autoAlpha: 1 }, 0),
              t.staggerFromTo(
                e,
                2,
                { opacity: 0, y: 150, x: -30, rotation: -10 },
                { opacity: 1, y: 0, x: 0, rotation: 0, ease: Power4.easeInOut },
                0.08,
                -0.8
              ))
            : (t.fromTo(a, 0.1, { autoAlpha: 0 }, { autoAlpha: 1 }, 0),
              t.staggerFromTo(
                e,
                2,
                { opacity: 0, y: 150, x: 30, rotation: 10 },
                { opacity: 1, y: 0, x: 0, rotation: 0, ease: Power4.easeInOut },
                0.08,
                -0.8
              ));
        },
        _initHeaderFixed: function () {
          if ($(this.selectors.headerFixed).length) {
            var n = function () {
                if (t.is(":visible")) {
                  var c = t.outerHeight();
                  t.addClass("finished"), a.css("height", c);
                }
              },
              r = function () {
                var c = $(window).scrollTop(),
                  d = $(a).offset().top + 10;
                d <= c
                  ? $(t).removeClass("unstick").addClass("stick")
                  : $(t).removeClass("stick").addClass("unstick");
              },
              e = n,
              o = r,
              t = $(this.selectors.headerFixed),
              a = t.parent();
            n(),
              $(window).resize(function () {
                n();
              }),
              $(a).offset().top + 10,
              r(),
              $(window).scroll(function () {
                r();
              });
          }
        },
        _initMenu: function () {
          if (typeof $.fn.roarmenu == "undefined") return !1;
          var t = this,
            a = t.selectors;
          if (
            $(a.navWrapper).hasClass("has-megamenu") &&
            $(a.megaMenu).length
          ) {
            var e = $($(a.megaMenu).val());
            e.find(".product__form").remove(),
              e
                .find(".site-nav__dropdown:not(.drilldown)")
                .removeAttr("class")
                .removeAttr("style"),
              e.find(".drilldown").removeAttr("class").addClass("drilldown"),
              e.find(".text-left").removeClass("text-left"),
              e.find(".text-center").removeClass("text-center"),
              e.find(".text-right").removeClass("text-right"),
              $(a.navWrapper).find(".listitem-1").remove(),
              $(a.navWrapper + " .listitem-0").prepend(
                e.find(".site-nav__items > .site-nav__item").removeAttr("class")
              );
          }
          $(a.navWrapper).length &&
            $(a.navWrapper).roarmenu({
              navbar: {
                add: !0,
                close: "mobile-nav__close",
                back: theme.strings.back,
                title: theme.strings.menu,
                titleLink: "anchor",
              },
            }),
            $(document).off("click", a.navOpenIcon),
            $(document).on("click", a.navOpenIcon, function (o) {
              o.preventDefault(),
                $("body").addClass("menu-opened"),
                t._animMenu();
            }),
            $(document).off("click", a.navCloseIcon),
            $(document).on("click", a.navCloseIcon, function (o) {
              o.preventDefault(), $("body").removeClass("menu-opened");
            });
        },
        _productsSlider: function () {
          var t = new theme.Sections();
          t.register("products-slider-sub", theme.ProductsSlider);
        },
        _lineItem: function () {
          theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
          var t = new theme.Sections();
          t.register("line_item", theme.LineItem),
            t.register("countdown-timer", theme.CountdownTimer);
        },
        onLoad: function () {
          this._lineItem();
        },
      })),
      s
    );
  })()),
  (theme.HeaderSection = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      this._initElements(), this._initSticky();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _initElements: function () {
          theme.Search.init(),
            theme.CurrencyPicker.init(),
            theme.LanguagePicker.init(),
            theme.MiniCart.init();
          var t = new theme.Sections();
          t.register("mega-menu", theme.MegaMenu);
        },
        _initSticky: function () {
          function t() {
            var n = $(window).scrollTop(),
              r =
                $("#shopify-section-header").offset().top +
                $("#shopify-section-header").outerHeight() +
                $("#shopify-section-header-topbar").outerHeight() +
                200;
            r <= n && $("#shopify-section-header-sticky").addClass("stick");
          }
          var a = "#shopify-section-header";
          if ($("#shopify-section-header-sticky").length) {
            var e = 0,
              o =
                $(a).offset().top +
                $(a).outerHeight() +
                $("#shopify-section-header-topbar").outerHeight() +
                200;
            $(window).scroll(function () {
              var n = $(this).scrollTop();
              $("#shopify-section-header-sticky").is(":visible") &&
                (o > n
                  ? $("#shopify-section-header-sticky").hasClass("stick") &&
                    ($("#shopify-section-header-sticky")
                      .removeClass("stick")
                      .removeClass("sticky-hide")
                      .addClass("unstick"),
                    (e = n))
                  : !$("#shopify-section-header-sticky").hasClass("stick") &&
                    ($("#shopify-section-header-sticky")
                      .removeClass("unstick")
                      .addClass("stick"),
                    (e = n)));
            }),
              t();
          }
        },
      })),
      s
    );
  })()),
  (theme.MegaMenu = (function () {
    function s() {
      this._initMenu(), this._navigationInit(), this._productsSlider();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _initMenu: function () {
          var t = ".header__menu",
            a = ".header__menu-left",
            e = ".header__menu-right";
          if (
            ($("#phantom__menu").length &&
              $(t).length &&
              $(t).each(function () {
                var n = $("#phantom__menu").val();
                $(this).empty().append(n);
              }),
            $("#phantom__menu").length && $(a).length)
          ) {
            var o = $($("#phantom__menu").val());
            o.find(".site-nav__items > .site-nav__item").each(function () {
              $(this).hasClass("pull-right") && $(this).remove();
            }),
              $(a).each(function () {
                var n = o.clone();
                $(this).empty().append(n);
              });
          }
          if ($("#phantom__menu").length && $(e).length) {
            var o = $($("#phantom__menu").val());
            o.find(".site-nav__items > .site-nav__item").each(function () {
              $(this).hasClass("pull-right") || $(this).remove();
            }),
              $(e).each(function () {
                var r = o.clone();
                $(this).empty().append(r);
              });
          }
        },
        _navigationInit: function () {
          var t = [
            ".site-navigation .site-nav__items > .site-nav--has-dropdown",
            ".my-account-has-drop",
            ".currency__picker .has-drop",
            ".language__picker .has-drop",
          ].join(", ");
          $(t)
            .mouseenter(function () {
              $(this)
                .closest(".site-header-main, .header-sticky__placeholder")
                .attr("data-sticky", "visible"),
                $(".site-overlay").addClass("visible");
            })
            .mouseleave(function () {
              $(".site-overlay").removeClass("visible"),
                $(this)
                  .closest(".site-header-main, .header-sticky__placeholder")
                  .removeAttr("data-sticky", "visible");
            });
        },
        _productsSlider: function () {
          var t = new theme.Sections();
          t.register("products-slider-sub", theme.ProductsSlider);
        },
        _lineItem: function () {
          theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
          var t = new theme.Sections();
          t.register("line_item", theme.LineItem),
            t.register("countdown-timer", theme.CountdownTimer);
        },
        onLoad: function () {
          this._lineItem();
        },
      })),
      s
    );
  })()),
  (theme.VerticalMenu = (function () {
    function s() {
      this.init();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        init: function () {
          var t = ".header__menu-vertical";
          $(".phantom__menu-vertical .site-nav__vertical").length &&
            $(t).length &&
            $(t).each(function () {
              var a = $(".phantom__menu-vertical .site-nav__vertical").clone();
              $(this).empty().append(a);
            });
        },
      })),
      s
    );
  })()),
  (theme.Maps = (function () {
    function s(l) {
      (this.$container = $(l)),
        (this.$map = this.$container.find(c.map)),
        (this.key = this.$map.data("api-key")),
        typeof this.key == "undefined" ||
          (o === "loaded"
            ? this.createMap()
            : (n.push(this),
              o != "loading" &&
                ((o = "loading"),
                typeof window.google == "undefined" &&
                  $.getScript(
                    "https://maps.googleapis.com/maps/api/js?key=" + this.key
                  ).then(function () {
                    (o = "loaded"), t();
                  }))));
    }
    function t() {
      $.each(n, function (l, u) {
        u.createMap();
      });
    }
    function a(l) {
      var u = $.Deferred(),
        f = new google.maps.Geocoder(),
        h = l.data("address-setting");
      return (
        f.geocode({ address: h }, function (b, C) {
          C !== google.maps.GeocoderStatus.OK && u.reject(C), u.resolve(b);
        }),
        u
      );
    }
    var e = { zoom: 19 },
      o = null,
      n = [],
      r = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError,
      },
      c = {
        section: '[data-section-type="map"]',
        map: "[data-map]",
        mapOverlay: "[data-map-overlay]",
      },
      d = {
        mapError: "map-section--load-error",
        errorMsg: "map-section__error errors text-center",
      };
    return (
      (window.gm_authFailure = function () {
        Shopify.designMode &&
          ($(c.section).addClass(d.mapError),
          $(c.map).remove(),
          $(c.mapOverlay).after(
            '<div class="' +
              d.errorMsg +
              '">' +
              theme.strings.authError +
              "</div>"
          ));
      }),
      (s.prototype = _.assignIn({}, s.prototype, {
        createMap: function () {
          var l = this.$map;
          return a(l)
            .then(
              function (u) {
                var f = [];
                (f[0] = {}), (f[1] = {}), (f[2] = {});
                var h = [];
                (h[0] = {}),
                  (h[1] = {}),
                  (h[2] = {}),
                  (h[3] = {}),
                  (h[4] = {}),
                  (h[5] = {}),
                  (h[6] = {}),
                  (h[7] = {}),
                  (h[8] = {}),
                  (h[9] = {}),
                  (h[10] = {}),
                  (h[11] = {}),
                  (h[12] = {});
                var b = [
                    {
                      featureType: "poi",
                      elementType: "labels",
                      stylers: [{ visibility: "off" }],
                    },
                    {
                      featureType: "road.local",
                      elementType: "labels.icon",
                      stylers: [{ visibility: "off" }],
                    },
                    {
                      featureType: "road.arterial",
                      elementType: "labels.icon",
                      stylers: [{ visibility: "off" }],
                    },
                    {
                      featureType: "road",
                      elementType: "geometry.stroke",
                      stylers: [{ visibility: "off" }],
                    },
                    {
                      featureType: "transit",
                      elementType: "geometry.fill",
                      stylers: [
                        { hue: "#dadeef" },
                        { visibility: "on" },
                        { lightness: 1 },
                        { saturation: 7 },
                      ],
                    },
                    { elementType: "labels", stylers: [{ saturation: -100 }] },
                    {
                      featureType: "poi",
                      elementType: "geometry.fill",
                      stylers: [
                        { hue: "#dadeef" },
                        { visibility: "on" },
                        { lightness: 20 },
                        { saturation: 7 },
                      ],
                    },
                    {
                      featureType: "landscape",
                      stylers: [
                        { hue: "#dadeef" },
                        { visibility: "on" },
                        { lightness: 20 },
                        { saturation: 20 },
                      ],
                    },
                    {
                      featureType: "road",
                      elementType: "geometry.fill",
                      stylers: [
                        { hue: "#dadeef" },
                        { visibility: "on" },
                        { lightness: 1 },
                        { saturation: 7 },
                      ],
                    },
                    {
                      featureType: "water",
                      elementType: "geometry",
                      stylers: [
                        { hue: "#dadeef" },
                        { visibility: "on" },
                        { lightness: 1 },
                        { saturation: 7 },
                      ],
                    },
                    h[0],
                    h[1],
                    h[2],
                    h[3],
                    h[4],
                    h[5],
                    h[6],
                    h[7],
                    h[8],
                    h[9],
                    h[10],
                    h[11],
                    h[12],
                    f[0],
                    f[1],
                    f[2],
                  ],
                  C = new google.maps.StyledMapType(b, { name: "Styled Map" }),
                  I = {
                    center: u[0].geometry.location,
                    zoom: e.zoom,
                    mapTypeControlOptions: {
                      mapTypeIds: [google.maps.MapTypeId.ROADMAP, "map_style"],
                    },
                    scrollwheel: !1,
                    panControl: !1,
                    zoomControl: 1,
                    disableDoubleClickZoom: 1,
                    zoomControlOptions: {
                      style: google.maps.ZoomControlStyle.LARGE,
                      position: google.maps.ControlPosition.LEFT_CENTER,
                    },
                    mapTypeControl: !1,
                    scaleControl: !1,
                    streetViewControl: !1,
                    fullscreenControlOptions: {
                      position: google.maps.ControlPosition.RIGHT_BOTTOM,
                    },
                  },
                  T = (this.map = new google.maps.Map(l[0], I));
                T.mapTypes.set("map_style", C), T.setMapTypeId("map_style");
                var P = (this.center = T.getCenter()),
                  O = new google.maps.OverlayView();
                (O.draw = function () {
                  var V = this,
                    U = this.div_;
                  U ||
                    (((U = this.div_ =
                      $(
                        '<div><div class="animated-dot"><div class="pin"></div><div class="pulse"></div></div></div>'
                      )[0]).style.position = "absolute"),
                    (U.style.paddingLeft = "0px"),
                    (U.style.cursor = "pointer"),
                    this.getPanes().overlayImage.appendChild(U));
                }),
                  O.setMap(T),
                  google.maps.event.addDomListener(
                    window,
                    "resize",
                    $.debounce(250, function () {
                      google.maps.event.trigger(T, "resize"),
                        T.setCenter(P),
                        l.removeAttr("style");
                    })
                  );
              }.bind(this)
            )
            .fail(function () {
              var u;
              (u =
                status === "ZERO_RESULTS"
                  ? r.addressNoResults
                  : status === "OVER_QUERY_LIMIT"
                  ? r.addressQueryLimit
                  : status === "REQUEST_DENIED"
                  ? r.authError
                  : r.addressError),
                Shopify.designMode &&
                  l
                    .parent()
                    .addClass(d.mapError)
                    .html('<div class="' + d.errorMsg + '">' + u + "</div>");
            });
        },
        onUnload: function () {
          this.$map.length === 0 ||
            google.maps.event.clearListeners(this.map, "resize");
        },
      })),
      s
    );
  })()),
  (theme.Product = (function () {
    function s(e) {
      var o = (this.$container = $(e)),
        n = o.attr("data-section-id");
      (this.settings = {
        mediaQueryLargeUp: "screen and (min-width: 992px)",
        mediaQueryMedium: "screen and (max-width: 991px)",
        mediaQueryMediumUp: "screen and (min-width: 768px)",
        mediaQuerySmall: "screen and (max-width: 767px)",
        enableHistoryState: o.data("enable-history-state") || !1,
        namespace: ".ProductSection-" + n,
        sectionId: n,
        sectionType: o.data("section-type"),
        zoomEnabled: !1,
        sliderThumbsActive: !1,
        sliderImagesActive: !1,
        swatchColor: o.data("product_swatch_color"),
        swatchColorAdvanced: o.data("product_swatch_color_advanced"),
        swatchSize: o.data("product_swatch_size"),
      }),
        (this.selectors = {
          container: o,
          inComing: ".InComing-" + n,
          addToCart: ".AddToCart-" + n,
          addToCartText: ".AddToCartText-" + n,
          comparePrice: ".ComparePrice-" + n,
          originalPrice: ".ProductPrice-" + n,
          SKU: ".product-single__sku",
          originalSelectorId: ".ProductSelect-" + n,
          productImage: ".ProductImage-" + n,
          productImages: ".product-single__photos-" + n,
          productImageWraps: ".product-single__photo-" + n,
          productVideo: ".product-single__video-" + n,
          productVideoWrap: ".product-single__video-wrapper",
          productPrices: ".product-single__price-" + n,
          productThumbs: ".product-single__thumbnails-" + n,
          productNav: ".product-single__nav-" + n,
          sizeChart: ".sizechart_btn",
          productContent: ".product-single__content",
          productQuantity: ".product-form__item--quantity",
          productTabs: ".product-single__tabs",
          productReviews: ".product-single__review",
          productGalleryTrigger: ".product-single__photo.photoswipe-enabled",
          productVideoTrigger: ".product-single__show-video",
          recentlyViewed: ".recently-viewed-" + n,
          cartAgree: "#product-cart__agree-" + n,
          cartCheckout: "#product-buy__1click-" + n,
          stockCountdown: "#product-single__stock-" + n,
          visitorCounter: "#product-single__visitor-" + n,
          totalSold: "#product-single__sold-" + n,
          singleOptionSelector: ".single-option-selector-" + n,
          singleOptionSelectorId: "#SingleOptionSelector-" + n,
          singleOptionSwatchesWrapper: ".wrapper-swatches-" + n,
          singleOptionSwatchesRadio: ".swatch-radio-" + n,
          productThumbImages: ".product-single__thumbnail--" + n,
          productThumbImagesWrapper: ".product-single__thumbnails-" + n,
          productThumbListItem: ".product-single__thumbnails-item",
          productMediaWrapper: "[data-product-single-media-wrapper]",
          productMediaTypeVideo:
            ":not(.slick-cloned)[data-product-media-type-video]",
          productMediaTypeModel: "[data-product-media-type-model]",
        }),
        (this.classes = {
          hidden: "classes-hide",
          visibilityHidden: "visibility-hidden",
          activeClass: "active-thumb",
          jsZoomEnabled: "js-zoom-enabled",
        }),
        $(".ProductJson-" + n, o).html() &&
          ((this.productSingleObject = JSON.parse(
            $(".ProductJson-" + n, o).html()
          )),
          (this.productSwatchSingleObject = JSON.parse(
            $(".ProductSwatchJson-" + n, o).html()
          )),
          (this.productMoreSingleObject = JSON.parse(
            $(".ProductMoreJson-" + n, o).html()
          )),
          (this.settings.zoomEnabled = $(
            this.selectors.productImageWraps
          ).hasClass("zoom-enabled")),
          this._updateProductObject(),
          this._initBreakpoints(),
          this._initVariants(),
          this._initSwatches(),
          this._initMediaSwitch(),
          this._initReviews(),
          this._initQuantity(),
          this._productInView(),
          this.settings.sectionType == "product-template" &&
            (this._initGalleryZoom(),
            this._initVideoZoom(),
            this._initTabs(),
            this._stickyDetails(),
            this._recordRecentlyViewed(),
            this._sizeChart(),
            this._checkoutCart(),
            this._initStockCountdown(),
            this._visitorCounter(),
            this._totalSold(),
            this._productNav(),
            this._productsSlider()),
          this._initProductVideo(),
          this._initModelViewerLibraries(),
          this._initShopifyXrLaunch());
    }
    function t(e) {
      var o = $(e).data("zoom");
      $(e).zoom({
        duration: 500,
        url: o,
        onZoomIn: function () {
          $(this).addClass("active");
        },
        onZoomOut: function () {
          $(this).removeClass("active");
        },
      });
    }
    function a(e) {
      $(e).trigger("zoom.destroy");
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _initMediaSwitch: function () {
          if ($(this.selectors.productThumbImages).length) {
            $.fn.visible = function (o) {
              var n = $(this),
                r = $(window),
                c = r.scrollTop(),
                d = c + r.height(),
                l = n.offset().top,
                u = l + n.height(),
                f = o === !0 ? u : l,
                h = o === !0 ? l : u;
              return h <= d && f >= c;
            };
            var e = this;
            $(this.selectors.productThumbImages)
              .on("click", function (o) {
                o.preventDefault();
                var n = $(this),
                  r = n.data("thumbnail-id");
                e._switchMedia(r), e._setActiveThumbnail(r);
              })
              .on("keyup", e._handleMediaFocus.bind(e)),
              $(e.selectors.productThumbs).on(
                "beforeChange",
                function (o, n, r, c) {
                  var d = $(e.selectors.productThumbs)
                    .find(".slick-slide")
                    .eq([c]);
                  if (d.find(".product-single__thumbnail").length) {
                    var l = d.find(".product-single__thumbnail"),
                      u = l.data("thumbnail_id");
                    $(e.selectors.productVideo).data("thumbnail_prev", u),
                      $(e.selectors.productVideoWrap).hide(),
                      $(e.selectors.productImages).show(),
                      e._pauseVideo();
                  }
                }
              ),
              $(e.selectors.productImages).on(
                "afterChange",
                function (o, n, r) {
                  var c = $(e.selectors.productImages)
                      .find(".slick-slide")
                      .eq([r]),
                    d = c.data("media-id");
                  e._switchMedia(d);
                }
              ),
              $(e.selectors.productVideo).on("click", function () {
                var o = $(this),
                  n = o.data("thumbnail_prev");
                if (o.hasClass("played")) {
                  var r = $(
                    e.selectors.productThumbImages +
                      "[data-thumbnail_id='" +
                      n +
                      "']"
                  )[0];
                  r.click();
                } else $(e.selectors.productThumbs).find(".slick-slide").removeClass("slick-current"), $(e.selectors.productImages).hide(), $(e.selectors.productVideoWrap).show(), e._playVideo(n);
              }),
              $(window).scroll(function () {
                $(e.selectors.productImageWraps).each(function (o, n) {
                  var r = $(n);
                  r.visible(!0) && r.addClass("come-in");
                });
              });
          }
        },
        _setActiveThumbnail: function (e) {
          typeof e == "undefined" &&
            (e = $(
              this.selectors.productMediaWrapper +
                ":not(." +
                this.classes.hidden +
                ")",
              this.$container
            ).data("media-id"));
          var o = $(
              this.selectors.productThumbListItem + ":not(.slick-cloned)",
              this.$container
            ),
            n = o.find(
              this.selectors.productThumbImages +
                "[data-thumbnail-id='" +
                e +
                "']"
            );
          if (
            ($(this.selectors.productThumbImages)
              .removeClass(this.classes.activeClass)
              .removeAttr("aria-current"),
            n.addClass(this.classes.activeClass),
            n.attr("aria-current", !0),
            !!o.hasClass("slick-slide"))
          ) {
            var r = n.parent().data("slick-index");
            $(this.selectors.productThumbImagesWrapper).slick(
              "slickGoTo",
              r,
              !0
            );
          }
        },
        _initProductVideo: function () {
          var e = this.settings.sectionId;
          $(this.selectors.productMediaTypeVideo, this.$container).each(
            function () {
              var o = $(this);
              theme.ProductVideo.init(o, e);
            }
          );
        },
        _initModelViewerLibraries: function () {
          var e = $(this.selectors.productMediaTypeModel, this.$container);
          1 > e.length || theme.ProductModel.init(e, this.settings.sectionId);
        },
        _initShopifyXrLaunch: function () {
          var e = this;
          $(document).on("shopify_xr_launch", function () {
            var o = $(
              e.selectors.productMediaWrapper +
                ":not(." +
                e.classes.hidden +
                ")",
              e.$container
            );
            o.trigger("xrLaunch");
          });
        },
        _updateMedia: function (e) {
          var o = e.variant,
            n = o.featured_media.id,
            r = this.settings.sectionId + "-" + n;
          this._switchMedia(r), this._setActiveThumbnail(r);
        },
        _switchMedia: function (e) {
          var o = $(
              this.selectors.productMediaWrapper +
                ":not(." +
                this.classes.hidden +
                ")",
              this.$container
            ),
            n = $(
              this.selectors.productMediaWrapper +
                "[data-media-id='" +
                e +
                "']",
              this.$container
            ),
            r = $(
              this.selectors.productMediaWrapper +
                ":not([data-media-id='" +
                e +
                "'])",
              this.$container
            );
          o.trigger("mediaHidden"),
            n.trigger("mediaVisible"),
            n.removeClass(this.classes.hidden).trigger("mediaVisible"),
            r.addClass(this.classes.hidden);
        },
        _handleMediaFocus: function (e) {
          if (e.keyCode === slate.utils.keyboardKeys.ENTER) {
            var o = $(e.currentTarget).data("thumbnail-id");
            $(
              this.selectors.productMediaWrapper +
                "[data-media-id='" +
                o +
                "']",
              this.$container
            ).focus();
          }
        },
        _initImageSlider: function (e) {
          typeof e == "undefined" && (e = !0);
          var o = this,
            n = !1;
          $(o.selectors.productImages).data("adaptive_height") == "1" &&
            (n = !0);
          var r = {
            infinite: !1,
            adaptiveHeight: n,
            rtl: theme.settings.rtl,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: !0,
            dots: !0,
            arrows: !0,
            prevArrow:
              '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev2"></use></svg></button>',
            nextArrow:
              '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next2"></use></svg></button>',
            asNavFor: o.selectors.productThumbs,
            responsive: [{ breakpoint: 767, settings: { adaptiveHeight: !0 } }],
          };
          if (
            (e == !1
              ? $(o.selectors.productImages).data("center_mode") == !0 &&
                ((r.centerMode = !0),
                (r.centerPadding = "25%"),
                (r.fade = !1),
                (r.arrows = !0))
              : ((r.slidesToShow = 1),
                (r.fade = !1),
                (r.dots = !0),
                (r.arrows = !1)),
            $(o.selectors.productImages)
              .closest(".product-single__photos")
              .find(".carousel-status").length)
          ) {
            var c = $(o.selectors.productImages)
              .closest(".product-single__photos")
              .find(".carousel-status");
            $(o.selectors.productImages).on(
              "beforeChange",
              function (d, l, u, f) {
                c.html(
                  "<span>" +
                    (f + 1) +
                    "</span>/<span>" +
                    l.$slides.length +
                    "</span>"
                );
              }
            );
          }
          theme.settings.animation &&
            $(o.selectors.productImages).on("init", function (d, l) {
              var u = new TimelineLite(),
                f = l.$slider,
                h = f.parent();
              u.fromTo(
                f,
                1,
                { opacity: 0 },
                { ease: Power4.easeInOut, opacity: 1 },
                0
              ),
                u.fromTo(
                  h,
                  2,
                  { scale: 1.1, opacity: 0 },
                  { ease: Power4.easeInOut, scale: 1, opacity: 1 },
                  0.3
                );
            }),
            (o.settings.sliderImagesActive = !0),
            $(o.selectors.productImages).slick(r);
        },
        _initThumbnailSlider: function (e) {
          typeof e == "undefined" && (e = !0);
          var o = this,
            n = !1;
          e == !1 &&
            $(o.selectors.productThumbs).data("vertical") == !0 &&
            (n = !0);
          var r = {
            rtl: theme.settings.rtl,
            slidesToShow: 4,
            slidesToScroll: 1,
            vertical: n,
            verticalSwiping: n,
            asNavFor: o.selectors.productImages,
            focusOnSelect: !0,
            arrows: !1,
          };
          theme.settings.animation &&
            $(o.selectors.productThumbs).on("init", function (c, d) {
              var l = new TimelineLite(),
                u = d.$slider;
              l.fromTo(
                u.find(".slick-list"),
                1.4,
                { y: 20, opacity: 0 },
                {
                  ease: Power4.easeInOut,
                  y: 0,
                  opacity: 1,
                  onStart: function () {
                    setTimeout(function () {
                      u.addClass("shadow");
                    }, 600);
                  },
                },
                1
              );
            }),
            (o.settings.sliderThumbsActive = !0),
            $(o.selectors.productThumbs).slick(r);
        },
        _destroyImageSlider: function () {
          $(this.selectors.productImages).slick("unslick"),
            (this.settings.sliderImagesActive = !1);
        },
        _destroyThumbnailSlider: function () {
          $(this.selectors.productThumbs).slick("unslick"),
            (this.settings.sliderThumbsActive = !1);
        },
        _initImageSwitch: function () {
          if ($(this.selectors.productThumbImages).length) {
            $.fn.visible = function (o) {
              var n = $(this),
                r = $(window),
                c = r.scrollTop(),
                d = c + r.height(),
                l = n.offset().top,
                u = l + n.height(),
                f = o === !0 ? u : l,
                h = o === !0 ? l : u;
              return h <= d && f >= c;
            };
            var e = this;
            $(document).off("click", e.selectors.productThumbImages),
              $(document).on(
                "click",
                e.selectors.productThumbImages,
                function (o) {
                  o.preventDefault();
                }
              ),
              $(e.selectors.productThumbs).on(
                "beforeChange",
                function (o, n, r, c) {
                  var d = $(e.selectors.productThumbs)
                    .find(".slick-slide")
                    .eq([c]);
                  if (d.find(".product-single__thumbnail").length) {
                    var l = d.find(".product-single__thumbnail"),
                      u = l.data("thumbnail_id");
                    $(e.selectors.productVideo).data("thumbnail_prev", u),
                      $(e.selectors.productVideoWrap).hide(),
                      $(e.selectors.productImages).show(),
                      e._pauseVideo();
                  }
                }
              ),
              $(e.selectors.productVideo).on("click", function () {
                var o = $(this),
                  n = o.data("thumbnail_prev");
                if (o.hasClass("played")) {
                  var r = $(
                    e.selectors.productThumbImages +
                      "[data-thumbnail_id='" +
                      n +
                      "']"
                  )[0];
                  r.click();
                } else $(e.selectors.productThumbs).find(".slick-slide").removeClass("slick-current"), $(e.selectors.productImages).hide(), $(e.selectors.productVideoWrap).show(), e._playVideo(n);
              }),
              $(window).scroll(function () {
                $(e.selectors.productImageWraps).each(function (o, n) {
                  var r = $(n);
                  r.visible(!0) && r.addClass("come-in");
                });
              });
          }
        },
        _switchImage: function (e) {
          if (this.settings.sectionType == "product-quickview") {
            var o = $(this.selectors.productImage, this.selectors.container);
            return void o
              .attr("data-bgset", theme.roarJs.bgSet(e))
              .removeClass("lazyloaded")
              .addClass("lazyload");
          }
          if ($(this.selectors.productThumbImages).length) {
            var n = $(
              this.selectors.productThumbImages +
                "[data-thumbnail_id='" +
                e.id +
                "']"
            )[0];
            n.click();
          }
        },
        _initBreakpoints: function () {
          var e = this;
          enquire.register(e.settings.mediaQueryMedium, {
            match: function () {
              e.settings.sliderThumbsActive && e._destroyThumbnailSlider(),
                e._initThumbnailSlider();
            },
          }),
            enquire.register(e.settings.mediaQueryLargeUp, {
              match: function () {
                e.settings.sliderThumbsActive && e._destroyThumbnailSlider(),
                  e._initThumbnailSlider(!1);
              },
            }),
            enquire.register(e.settings.mediaQuerySmall, {
              match: function () {
                e.settings.sliderImagesActive && e._destroyImageSlider(),
                  e._initImageSlider(),
                  e.settings.zoomEnabled &&
                    $(e.selectors.productImageWraps).each(function () {
                      a(this);
                    });
              },
            }),
            enquire.register(e.settings.mediaQueryMediumUp, {
              match: function () {
                e.settings.sliderImagesActive && e._destroyImageSlider(),
                  e._initImageSlider(!1),
                  e.settings.zoomEnabled &&
                    $(e.selectors.productImageWraps).each(function () {
                      t(this);
                    });
              },
            });
        },
        _productNav: function () {
          var e = this;
          if ($(e.selectors.productNav).length) {
            var o = $(e.selectors.productNav),
              n = $(".product-template__end"),
              r = function () {
                var c = o.offset().top / 3,
                  d = n.offset().top - 400,
                  l = $(window).scrollTop();
                c < l ? o.addClass("visible") : o.removeClass("visible"),
                  d < l && o.removeClass("visible");
              };
            r(), $(window).scroll(r), $(window).resize(r);
          }
        },
        _productInView: function () {
          return (
            typeof ScrollReveal != "undefined" &&
            theme.settings.animation != !1 &&
            ((window.sr = ScrollReveal()),
            void sr.reveal(".product-single__inview:not(.no-anim)", {
              mobile: !0,
              beforeReveal: function (e) {
                (e.visuelRevealTL = new TimelineLite()),
                  $(e).addClass("anim"),
                  e.visuelRevealTL
                    .fromTo(
                      e,
                      2,
                      { y: 40, opacity: 0 },
                      { ease: Power4.easeInOut, y: 0, opacity: 1 },
                      0
                    )
                    .call(function () {
                      $(e).removeClass("anim").addClass("no-anim");
                    });
              },
            }))
          );
        },
        _updateProductObject: function () {
          var e = this;
          $.each(e.productMoreSingleObject.variants, function (o, n) {
            $.each(n, function (r, c) {
              e.productSingleObject.variants[o][r] = c;
            });
          });
        },
        _totalSold: function () {
          if ($(this.selectors.totalSold).length) {
            var e = $(this.selectors.totalSold),
              o = e.data("qty_min"),
              n = e.data("qty_max"),
              r = e.data("time_min"),
              c = e.data("time_max");
            (o = Math.ceil(o)),
              (n = Math.floor(n)),
              (r = Math.ceil(r)),
              (c = Math.floor(c));
            var d = Math.floor(Math.random() * (n - o + 1)) + o;
            (d = parseInt(d)),
              d <= o && (d = o),
              d > n && (d = n),
              e.html(e.html().replace("/count/", d));
            var l = Math.floor(Math.random() * (c - r + 1)) + r;
            (l = parseInt(l)),
              l <= r && (l = r),
              l > c && (l = c),
              e.html(e.html().replace("/time/", l)),
              e.addClass("active"),
              e.find("img").first().length &&
                setInterval(function () {
                  e.find("img")
                    .first()
                    .fadeIn(function () {
                      $(this).css("visibility", "visible");
                    })
                    .delay(1600)
                    .fadeIn(function () {
                      $(this).css("visibility", "hidden");
                    })
                    .delay(400);
                }, 2e3);
          }
        },
        _visitorCounter: function () {
          if ($(this.selectors.visitorCounter).length) {
            var e = $(this.selectors.visitorCounter),
              o = 1,
              n = e.data("max"),
              r = e.data("interval"),
              c = o,
              d = n;
            (c = Math.ceil(c)), (d = Math.floor(d));
            var l = Math.floor(Math.random() * (d - c + 1)) + c,
              u = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"],
              h = "",
              b = "",
              f = ["10", "20", "15"],
              h = "",
              b = "",
              C = "";
            setInterval(function () {
              if (
                ((h = Math.floor(Math.random() * u.length)),
                (b = u[h]),
                (l = parseInt(l) + parseInt(b)),
                o >= l)
              ) {
                C = Math.floor(Math.random() * f.length);
                var I = f[C];
                l += I;
              }
              (1 > l || l > n) &&
                (l = Math.floor(Math.random() * (d - c + 1)) + c),
                e.find("strong").first().text(parseInt(l)),
                e.addClass("active");
            }, 1e3 * r);
          }
        },
        _initStockCountdown: function () {
          if ($(this.selectors.stockCountdown).length) {
            var e = this,
              o = $(e.selectors.stockCountdown);
            if (o.hasClass("is-fake")) {
              var h = function (T, P) {
                  return Math.floor(Math.random() * (P - T + 1) + T);
                },
                b = function () {
                  o
                    .find(".stock-countdown-message")
                    .first()
                    .html(theme.strings.onlyLeft.replace("{{ count }}", c)),
                    (d = setTimeout(function () {
                      c--,
                        1 > c && (c = h(n, r)),
                        o.find(".stock-countdown-message strong").text(c),
                        C(),
                        c < n && clearTimeout(d);
                    }, 3e3)),
                    (l = setInterval(function () {
                      c--,
                        1 > c && (c = h(n, r)),
                        o.find(".stock-countdown-message strong").text(c),
                        C(),
                        c < n && clearInterval(l);
                    }, 102e3));
                },
                C = function () {
                  var T = (100 * c) / 60;
                  o.find(".progress-bar span").css("width", T + "%");
                },
                e = h,
                u = b,
                f = C,
                n = o.data("min"),
                r = o.data("max"),
                c = h(n, r),
                d = null,
                l = null;
              b(), o.hasClass("is-visible") && o.removeClass("hide");
            }
          }
        },
        _updateStockCountdown: function (e) {
          var o = $(this.selectors.stockCountdown);
          o.hasClass("is-fake")
            ? o.removeClass("hide")
            : (o
                .find(".stock-countdown-message")
                .first()
                .html(theme.strings.onlyLeft.replace("{{ count }}", e)),
              o.find(".progress-bar span").first().css("width", "100%"),
              o.removeClass("hide"),
              setTimeout(function () {
                o.find(".progress-bar span").first().css("width", "28%");
              }, 500));
        },
        _checkoutCart: function () {
          var e = this;
          $(e.selectors.cartAgree).length &&
            ($(document).on(
              "DOMNodeInserted",
              e.selectors.cartCheckout,
              function () {
                var o = $(this);
                setTimeout(function () {
                  var n = o.find(".shopify-payment-button__button");
                  n.length &&
                    (o.hide(),
                    setTimeout(function () {
                      var r = $(e.selectors.cartAgree);
                      r.is(":checked")
                        ? n.removeClass("btn-disabled")
                        : n.addClass("btn-disabled"),
                        o.fadeIn();
                    }, 300));
                }, 0);
              }
            ),
            $(document).on("change", e.selectors.cartAgree, function () {
              var o = $(this),
                n = $(e.selectors.cartCheckout).find(
                  ".shopify-payment-button__button"
                );
              o.is(":checked")
                ? n.removeClass("btn-disabled")
                : n.addClass("btn-disabled");
            }));
        },
        _pauseVideo: function () {
          var e = $(this.selectors.productVideoWrap).find("video")[0];
          e && e.played && (e.pause(), e.load()),
            $(this.selectors.productVideo).removeClass("played");
        },
        _playVideo: function (e) {
          var o = this,
            n = $(o.selectors.productVideoWrap).find("video")[0];
          if (n) {
            n.play();
            var r = 1;
            n.addEventListener(
              "ended",
              function () {
                if (2 > r) n.play(), r++;
                else {
                  var c = $(
                    o.selectors.productThumbImages +
                      "[data-thumbnail_id='" +
                      e +
                      "']"
                  )[0];
                  c.click();
                }
              },
              !1
            );
          }
          $(o.selectors.productVideo).addClass("played");
        },
        _initVideoZoom: function () {
          function e() {
            var r = [
              {
                html: $(
                  o.selectors.productVideoWrap + " .product-single__video"
                ).html(),
              },
            ];
            return r;
          }
          var o = this,
            n = $(".pswp")[0];
          $(document).off("click", o.selectors.productVideoTrigger),
            $(document).on(
              "click",
              o.selectors.productVideoTrigger,
              function (r) {
                r.preventDefault();
                var c = $(this).parent(),
                  d = new PhotoSwipe(n, PhotoSwipeUI_Default, e(), {
                    index: 0,
                    closeOnScroll: !1,
                    bgOpacity: 0.1,
                    tapToClose: !0,
                    tapToToggleControls: !1,
                  });
                d.init(),
                  $("body").addClass("blurred"),
                  $(".pswp__item").fadeTo(1e3, 1),
                  d.listen("close", function () {
                    $(".pswp__item .pswp__video").each(function () {
                      $(this).attr("src", $(this).attr("src"));
                    }),
                      $(".pswp__item").fadeOut("slow", 0),
                      $("body").removeClass("blurred");
                  });
              }
            );
        },
        _initGalleryZoom: function () {
          function e() {
            var r = [];
            return (
              $(
                o.selectors.productImages +
                  " .product-single__photo-container:not(.slick-cloned) .feature-row__image"
              ).each(function () {
                var c = $(this).data("large_image"),
                  d = $(this).data("large_image_width"),
                  l = $(this).data("large_image_height");
                r.push({ src: c, w: d, h: l, title: !1 });
              }),
              r
            );
          }
          var o = this,
            n = $(".pswp")[0];
          $(document).off("click", o.selectors.productGalleryTrigger),
            $(document).on(
              "click",
              o.selectors.productGalleryTrigger,
              function (r) {
                r.preventDefault();
                var c = $(this).parent(),
                  d = $(this).data("index"),
                  l = new PhotoSwipe(n, PhotoSwipeUI_Default, e(), {
                    index: d,
                    closeOnScroll: !1,
                    bgOpacity: 0.1,
                    tapToClose: !0,
                    tapToToggleControls: !1,
                  });
                l.init(),
                  l.listen("imageLoadComplete", function () {
                    $(".pswp__item").fadeTo(1e3, 1),
                      $("body").addClass("blurred");
                  }),
                  l.listen("close", function () {
                    $(".pswp__item").fadeOut("slow", 0),
                      $("body").removeClass("blurred");
                  });
              }
            );
        },
        _initQuantity: function () {
          function e(n) {
            var r = 0;
            $(n)
              .closest(o.selectors.productContent)
              .find(o.selectors.productQuantity + " .quantity")
              .each(function () {
                r += parseInt($(this).val());
              }),
              0 < r
                ? $(o.selectors.addToCart).prop("disabled", !1)
                : $(o.selectors.addToCart).prop("disabled", !0);
          }
          var o = this;
          $(document).off("click", o.selectors.productQuantity + " .plus"),
            $(document).on(
              "click",
              o.selectors.productQuantity + " .plus",
              function () {
                var n = $(this)
                    .closest(o.selectors.productQuantity)
                    .find(".quantity"),
                  r = parseInt(n.val());
                ++r, n.val(r), e(this);
              }
            ),
            $(document).off("click", o.selectors.productQuantity + " .minus"),
            $(document).on(
              "click",
              o.selectors.productQuantity + " .minus",
              function () {
                var n = $(this)
                    .closest(o.selectors.productQuantity)
                    .find(".quantity"),
                  r = parseInt(n.val());
                0 < r && (--r, n.val(r), e(this));
              }
            );
        },
        _stickyDetails: function () {
          var e = $(this.selectors.productContent);
          !e.data("sticky") ||
            992 > $(window).width() ||
            e.each(function () {
              var o = $(this).parent(),
                n = $(this),
                r = o
                  .closest(".product-single")
                  .find(".product-single__photos"),
                c = n.outerHeight() - r.outerHeight();
              -100 > c
                ? n.stick_in_parent({ offset_top: 20 })
                : 100 < c && r.stick_in_parent({ offset_top: 20 }),
                $(window).resize(function () {
                  992 > $(window).width()
                    ? (n.trigger("sticky_kit:detach"),
                      r.trigger("sticky_kit:detach"))
                    : n.outerHeight() < r.outerHeight()
                    ? n.stick_in_parent({ offset_top: 20 })
                    : r.stick_in_parent({ offset_top: 20 });
                });
            });
        },
        _initTabs: function () {
          var e = $(this.selectors.productTabs),
            o = ".product-tabs__title";
          (e.hasClass("tabs-layout-tabs") ||
            e.hasClass("tabs-layout-accordion")) &&
            ($(document).off("click", o),
            $(document).on("click", o, function (n) {
              n.preventDefault();
              var r = $(this),
                c = r.attr("href"),
                d = $(o, e),
                l = $(".product-tabs__panel", e);
              $(".product-tabs", e).is(":visible")
                ? (d.removeClass("active"),
                  l.removeClass("active"),
                  r.addClass("active"),
                  $(c).addClass("active"))
                : (r.hasClass("active")
                    ? (r.removeClass("active"), $(c).removeClass("active"))
                    : (d.removeClass("active"),
                      l.removeClass("active"),
                      r.addClass("active"),
                      $(c).addClass("active")),
                  l.each(function () {
                    $(this).hasClass("active")
                      ? $(this).slideDown(250)
                      : $(this).slideUp(250);
                  }));
            }));
        },
        _initReviews: function () {
          if (!$(this.selectors.productTabs).length) return !1;
          var e = this.selectors.productTabs;
          $(document).off("click", this.selectors.productReviews),
            $(document).on("click", this.selectors.productReviews, function () {
              if (
                $(e).hasClass("tabs-layout-tabs") ||
                $(e).hasClass("tabs-layout-accordion")
              ) {
                var o = $(e + " #tab-reviews").prev();
                $(".product-tabs", e).is(":visible") &&
                  (o = $(e + " .reviews_tab .product-tabs__title")),
                  o.hasClass("active") || o.trigger("click");
              }
              var n = $(e + " #tab-reviews").parent();
              $(".product-tabs", e).is(":visible") && (n = $(e)),
                setTimeout(function () {
                  $("html, body").animate(
                    { scrollTop: n.offset().top },
                    500,
                    "swing"
                  );
                }, 250);
            });
        },
        _initSwatches: function () {
          function e(l, u, f) {
            if (1 < l.options.length)
              for (var h = 0; h < l.options.length; h++)
                h != u &&
                  $(d + "-" + h + " option").each(function (b, C) {
                    var I = "unavailable",
                      T = $(C).attr("value"),
                      P = $(C).attr("data-swatch");
                    for (j = 0; j < l.variants.length; j++) {
                      var O = l.variants[j];
                      if (O.options[u] == f && O.options[h] == T) {
                        I = O.available == !0 ? "available" : "sold_out";
                        break;
                      }
                    }
                    var V = $(C)
                      .closest(r)
                      .find(".swatch-element." + P);
                    V.removeClass("available"),
                      V.removeClass("sold_out"),
                      V.removeClass("unavailable"),
                      V.addClass(I);
                  });
            else
              for (var h = 0; h < l.options.length; h++)
                $(d + "-" + h + " option").each(function (C, I) {
                  var T = "unavailable",
                    P = $(I).attr("value"),
                    O = $(I).attr("data-swatch");
                  for (j = 0; j < l.variants.length; j++) {
                    var V = l.variants[j];
                    if (V.options[h] == P) {
                      T = V.available == !0 ? "available" : "sold_out";
                      break;
                    }
                  }
                  console.log(O + " - " + T);
                  var U = $(I)
                    .closest(r)
                    .find(".swatch-element." + O);
                  U.removeClass("available"),
                    U.removeClass("sold_out"),
                    U.removeClass("unavailable"),
                    U.addClass(T);
                });
          }
          var o = $(this.selectors.singleOptionSwatchesRadio);
          if (o.length != 0) {
            var n = this,
              r = this.selectors.singleOptionSwatchesWrapper,
              c = this.productSingleObject,
              d = this.selectors.singleOptionSelectorId;
            o.unbind("click"),
              o.on("click", function (l) {
                l.preventDefault();
                var u = $(this).data("value"),
                  f = $(this).closest(r).find("select"),
                  h = f.val();
                if (h != u) {
                  f.val(u).trigger("change"),
                    $(this)
                      .closest(r)
                      .find(".swatch-radio")
                      .removeClass("selected"),
                    $(this)
                      .closest(r)
                      .find("label")
                      .removeClass("label-selected"),
                    $(this).parent().addClass("label-selected"),
                    $(this).closest(r).find(".option-select-value").length &&
                      $(this).closest(r).find(".option-select-value").html(u);
                  var b = this,
                    C = $(this).data("swatch"),
                    I = $(this).data("poption"),
                    T = $(this).data("value");
                  e(c, I, T, C, b);
                }
              });
          }
        },
        _initVariants: function () {
          var e = {
            $container: this.$container,
            enableHistoryState:
              this.$container.data("enable-history-state") || !1,
            singleOptionSelector: this.selectors.singleOptionSelector,
            originalSelectorId: this.selectors.originalSelectorId,
            product: this.productSingleObject,
          };
          (this.variants = new slate.Variants(e)),
            this.$container.on(
              "variantChange" + this.settings.namespace,
              this._updateAddToCart.bind(this)
            ),
            this.$container.on(
              "variantImageChange" + this.settings.namespace,
              this._updateMedia.bind(this)
            ),
            this.$container.on(
              "variantPriceChange" + this.settings.namespace,
              this._updatePrice.bind(this)
            ),
            this.$container.on(
              "variantSKUChange" + this.settings.namespace,
              this._updateSKU.bind(this)
            );
        },
        _updateAddToCart: function (e) {
          var o = e.variant;
          o
            ? ($(this.selectors.productPrices).removeClass("visibility-hidden"),
              o.available
                ? ($(this.selectors.addToCart, this.selectors.container).prop(
                    "disabled",
                    !1
                  ),
                  0 >= o.inventory_quantity &&
                  o.inventory_management == "shopify"
                    ? $(
                        this.selectors.addToCartText,
                        this.selectors.container
                      ).text(theme.strings.preOrder)
                    : $(
                        this.selectors.addToCartText,
                        this.selectors.container
                      ).text(theme.strings.addToCart),
                  $(this.selectors.productQuantity).removeClass("btn-disabled"),
                  $(this.selectors.inComing, this.selectors.container).addClass(
                    "hide"
                  ),
                  0 < o.inventory_quantity &&
                  o.inventory_management == "shopify"
                    ? this._updateStockCountdown(o.inventory_quantity)
                    : $(this.selectors.stockCountdown).removeClass("hide"),
                  $(this.selectors.totalSold).removeClass("hide"))
                : ($(this.selectors.addToCart, this.selectors.container).prop(
                    "disabled",
                    !0
                  ),
                  $(
                    this.selectors.addToCartText,
                    this.selectors.container
                  ).text(theme.strings.soldOut),
                  $(this.selectors.productQuantity).addClass("btn-disabled"),
                  o.incoming
                    ? $(this.selectors.inComing, this.selectors.container)
                        .html(
                          theme.strings.inComing.replace(
                            "{{ date }}",
                            o.next_incoming_date
                          )
                        )
                        .removeClass("hide")
                    : $(
                        this.selectors.inComing,
                        this.selectors.container
                      ).addClass("hide"),
                  $(this.selectors.stockCountdown).addClass("hide"),
                  $(this.selectors.totalSold).addClass("hide")))
            : ($(this.selectors.addToCart, this.selectors.container).prop(
                "disabled",
                !0
              ),
              $(this.selectors.addToCartText, this.selectors.container).text(
                theme.strings.unavailable
              ),
              $(this.selectors.productQuantity).addClass("btn-disabled"),
              $(this.selectors.productPrices).addClass("visibility-hidden"),
              $(this.selectors.inComing, this.selectors.container).addClass(
                "hide"
              ),
              $(this.selectors.stockCountdown).addClass("hide"),
              $(this.selectors.totalSold).addClass("hide"));
        },
        _updateImages: function (e) {
          var o = e.variant;
          this._switchImage(o.featured_image);
        },
        _updatePrice: function (e) {
          var o = e.variant;
          $(this.selectors.originalPrice, this.selectors.container).html(
            theme.CurrencyPicker.formatMoney(o.price)
          ),
            o.compare_at_price > o.price
              ? $(this.selectors.comparePrice, this.selectors.container)
                  .html(theme.CurrencyPicker.formatMoney(o.compare_at_price))
                  .removeClass("hide")
              : $(
                  this.selectors.comparePrice,
                  this.selectors.container
                ).addClass("hide");
        },
        _updateSKU: function (e) {
          var o = e.variant;
          $(this.selectors.SKU).html(o.sku);
        },
        _recordRecentlyViewed: function () {
          var e = localStorage.getItem("roarStorage_recentlyViewed") || "[]";
          try {
            e = JSON.parse(e);
          } catch (r) {
            localStorage.removeItem("roarStorage_recentlyViewed"),
              (e = JSON.parse("[]"));
          }
          var o = this.productSingleObject.id;
          e.includes(o) || e.unshift(o);
          var n = e.filter(function (r) {
            return r != null;
          });
          try {
            localStorage.setItem(
              "roarStorage_recentlyViewed",
              JSON.stringify(n.slice(0, 180))
            );
          } catch (r) {}
        },
        _sizeChart: function () {
          var e = this,
            o = $("body"),
            n = $(".sizechart-modal");
          $(document).off("click", e.selectors.sizeChart),
            $(document).on("click", e.selectors.sizeChart, function (r) {
              r.preventDefault(),
                n.addClass("opened"),
                o.addClass("sizechart-opened");
            }),
            $(document).off("click", ".sizechart_overlay, .sizechart_close"),
            $(document).on(
              "click",
              ".sizechart_overlay, .sizechart_close",
              function (r) {
                r.preventDefault(),
                  n.removeClass("opened"),
                  o.removeClass("sizechart-opened");
              }
            ),
            $(document).keyup(function (r) {
              r.which == "27" &&
                (n.removeClass("opened"), o.removeClass("sizechart-opened"));
            }),
            $("body").append(n);
        },
        _productsSlider: function () {
          var e = new theme.Sections();
          e.register("products-slider-sub", theme.ProductsSlider);
        },
        _lineItem: function () {
          theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
          var e = new theme.Sections();
          e.register("line_item", theme.LineItem),
            e.register("countdown-timer", theme.CountdownTimer);
        },
        onLoad: function () {
          this._lineItem();
        },
        onUnload: function () {
          this.$container.off(this.settings.namespace),
            theme.ProductVideo.removeSectionVideos(this.settings.sectionId),
            theme.ProductModel.removeSectionModels(this.settings.sectionId);
        },
      })),
      s
    );
  })()),
  (theme.ProductModel = (function () {
    function s(c) {
      if (!c) {
        if (!window.ShopifyXR)
          return void document.addEventListener(
            "shopify_xr_initialized",
            function () {
              s();
            }
          );
        for (var d in e)
          if (e.hasOwnProperty(d)) {
            var l = e[d];
            if (l.loaded) continue;
            var u = $("#ModelJson-" + d);
            window.ShopifyXR.addModels(JSON.parse(u.html())), (l.loaded = !0);
          }
        window.ShopifyXR.setupXRElements();
      }
    }
    function t(c) {
      if (!c) {
        for (var d in o)
          if (o.hasOwnProperty(d)) {
            var l = o[d];
            l.modelViewerUi ||
              (l.modelViewerUi = new Shopify.ModelViewerUI(l.$element)),
              a(l);
          }
      }
    }
    function a(c) {
      var d = n[c.sectionId];
      c.$container.on("mediaVisible", function () {
        d.$element.attr("data-shopify-model3d-id", c.modelId),
          theme.Helpers.isTouch() || c.modelViewerUi.play();
      }),
        c.$container
          .on("mediaHidden", function () {
            d.$element.attr("data-shopify-model3d-id", d.defaultId),
              c.modelViewerUi.pause();
          })
          .on("xrLaunch", function () {
            c.modelViewerUi.pause();
          });
    }
    var e = {},
      o = {},
      n = {},
      r = {
        mediaGroup: "[data-product-single-media-group]",
        xrButton: "[data-shopify-xr]",
      };
    return {
      init: function (c, d) {
        (e[d] = { loaded: !1 }),
          c.each(function (l) {
            var u = $(this),
              f = u.data("media-id"),
              h = $(u.find("model-viewer")[0]),
              b = h.data("model-id");
            if (l === 0) {
              var C = u.closest(r.mediaGroup).find(r.xrButton);
              n[d] = { $element: C, defaultId: b };
            }
            o[f] = { modelId: b, sectionId: d, $container: u, $element: h };
          }),
          window.Shopify.loadFeatures([
            { name: "shopify-xr", version: "1.0", onLoad: s },
            { name: "model-viewer-ui", version: "1.0", onLoad: t },
          ]),
          theme.LibraryLoader.load("modelViewerUiStyles");
      },
      removeSectionModels: function (c) {
        for (var d in o)
          if (o.hasOwnProperty(d)) {
            var l = o[d];
            l.sectionId === c && (o[d].modelViewerUi.destroy(), delete o[d]);
          }
        delete e[c];
      },
    };
  })()),
  (theme.ProductVideo = (function () {
    function s(u) {
      return u ? void n() : void o(c.html5);
    }
    function t() {
      window.YT.Player && o(c.youtube);
    }
    function a(u) {
      if (!u.player) {
        var f = u.container.closest(d.productMediaWrapper),
          h = f.data(l.enableVideoLooping);
        switch (u.host) {
          case c.html5:
            u.player = new Shopify.Plyr(u.element, { loop: { active: h } });
            break;
          case c.youtube:
            var b = f.data(l.videoId);
            u.player = new YT.Player(u.element, {
              videoId: b,
              events: {
                onStateChange: function (C) {
                  C.data === 0 && h && C.target.seekTo(0);
                },
              },
            });
        }
        f.on("mediaHidden xrLaunch", function () {
          u.player &&
            (u.host === c.html5 && u.player.pause(),
            u.host === c.youtube &&
              u.player.pauseVideo &&
              u.player.pauseVideo());
        }),
          f.on("mediaVisible", function () {
            theme.Helpers.isTouch() ||
              !u.player ||
              (u.host === c.html5 && u.player.play(),
              u.host === c.youtube &&
                u.player.playVideo &&
                u.player.playVideo());
          });
      }
    }
    function e(u) {
      return u.tagName === "VIDEO"
        ? c.html5
        : u.tagName === "IFRAME" &&
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
            u.src
          )
        ? c.youtube
        : null;
    }
    function o(u) {
      for (var f in r)
        if (r.hasOwnProperty(f)) {
          var h = r[f];
          h.host === u && h.ready();
        }
    }
    function n() {
      for (var u in r)
        if (r.hasOwnProperty(u)) {
          var f = r[u];
          if (f.nativeVideo) continue;
          f.host === c.html5 &&
            (f.element.setAttribute("controls", "controls"),
            (f.nativeVideo = !0));
        }
    }
    var r = {},
      c = { html5: "html5", youtube: "youtube" },
      d = { productMediaWrapper: "[data-product-single-media-wrapper]" },
      l = { enableVideoLooping: "enable-video-looping", videoId: "video-id" };
    return {
      init: function (u, f) {
        if (u.length) {
          var h = u.find("iframe, video")[0],
            b = u.data("mediaId");
          if (h) {
            r[b] = {
              mediaId: b,
              sectionId: f,
              host: e(h),
              container: u,
              element: h,
              ready: function () {
                a(this);
              },
            };
            var C = r[b];
            switch (C.host) {
              case c.html5:
                window.Shopify.loadFeatures([
                  { name: "video-ui", version: "1.0", onLoad: s },
                ]),
                  theme.LibraryLoader.load("plyrShopifyStyles");
                break;
              case c.youtube:
                theme.LibraryLoader.load("youtubeSdk", t);
            }
          }
        }
      },
      hosts: c,
      loadVideos: o,
      removeSectionVideos: function (u) {
        for (var f in r)
          if (r.hasOwnProperty(f)) {
            var h = r[f];
            h.sectionId === u && (h.player && h.player.destroy(), delete r[f]);
          }
      },
    };
  })()),
  (theme.LineItem = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.settings = {
        enableHistoryState: !1,
        namespace: ".ProductSection-" + e,
        sectionId: e,
        swatchColor: !0,
        swatchColorAdvanced: !0,
        swatchSize: !0,
      }),
        (this.selectors = {
          container: a,
          productImage: ".ProductImage-" + e,
          productColor: ".ProductColor-" + e,
          addToCart: ".AddToCart-" + e,
          addToCartText: ".AddToCartText-" + e,
          comparePrice: ".ComparePrice-" + e,
          originalPrice: ".ProductPrice-" + e,
          productPrices: ".product-single__price-" + e,
          originalSelectorId: ".ProductSelect-" + e,
          singleOptionSwatchesWrapper: ".wrapper-swatches-" + e,
          singleOptionSelector: ".single-option-selector-" + e,
          singleOptionSelectorId: "#SingleOptionSelector-" + e,
          singleOptionSwatches: "tawcvs-swatches-" + e,
          singleOptionSwatchesRadio: ".swatch-radio-" + e,
        }),
        !$(".ProductJson-" + e, a).html() ||
          a.data("section-state") ||
          ((this.productSingleObject = JSON.parse(
            $(".ProductJson-" + e, a).html()
          )),
          (this.productSwatchSingleObject = JSON.parse(
            $(".ProductSwatchJson-" + e, a).html()
          )),
          (this.productMoreSingleObject = JSON.parse(
            $(".ProductMoreJson-" + e, a).html()
          )),
          this._updateProductObject(),
          this._initVariants(),
          this._initSwatches(),
          a.data("section-state", !0));
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _updateProductObject: function () {
          var t = this;
          $.each(t.productMoreSingleObject.variants, function (a, e) {
            $.each(e, function (o, n) {
              t.productSingleObject.variants[a][o] = n;
            });
          });
        },
        _initSwatches: function () {
          function t(c, d, l) {
            if (1 < c.options.length)
              for (var u = 0; u < c.options.length; u++)
                u != d &&
                  $(r + "-" + u + " option").each(function (f, h) {
                    var b = "unavailable",
                      C = $(h).attr("value"),
                      I = $(h).attr("data-swatch");
                    for (j = 0; j < c.variants.length; j++) {
                      var T = c.variants[j];
                      if (T.options[d] == l && T.options[u] == C) {
                        b = T.available == !0 ? "available" : "sold_out";
                        break;
                      }
                    }
                    var P = $(h)
                      .closest(o)
                      .find(".swatch-element." + I);
                    P.removeClass("available"),
                      P.removeClass("sold_out"),
                      P.removeClass("unavailable"),
                      P.addClass(b);
                  });
            else
              for (var u = 0; u < c.options.length; u++)
                $(r + "-" + u + " option").each(function (h, b) {
                  var C = "unavailable",
                    I = $(b).attr("value"),
                    T = $(b).attr("data-swatch");
                  for (j = 0; j < c.variants.length; j++) {
                    var P = c.variants[j];
                    if (P.options[u] == I) {
                      C = P.available == !0 ? "available" : "sold_out";
                      break;
                    }
                  }
                  var O = $(b)
                    .closest(o)
                    .find(".swatch-element." + T);
                  O.removeClass("available"),
                    O.removeClass("sold_out"),
                    O.removeClass("unavailable"),
                    O.addClass(C);
                });
          }
          var a = $(this.selectors.singleOptionSwatchesRadio);
          if (a.length != 0) {
            var e = this,
              o = this.selectors.singleOptionSwatchesWrapper,
              n = this.productSingleObject,
              r = this.selectors.singleOptionSelectorId;
            a.unbind("click"),
              a.on("click", function (c) {
                c.preventDefault();
                var d = $(this).data("value"),
                  l = $(this).closest(o).find("select"),
                  u = l.val();
                if (u != d) {
                  l.val(d).trigger("change"),
                    $(this)
                      .closest(o)
                      .find(".swatch-radio")
                      .removeClass("selected"),
                    $(this)
                      .closest(o)
                      .find("label")
                      .removeClass("label-selected"),
                    $(this).parent().addClass("label-selected"),
                    $(this).closest(o).find(".option-select-value").length &&
                      $(this).closest(o).find(".option-select-value").html(d);
                  var f = this,
                    h = $(this).data("swatch"),
                    b = $(this).data("poption"),
                    C = $(this).data("value");
                  t(n, b, C, h, f);
                }
              });
          }
        },
        _initVariants: function () {
          var t = {
            $container: this.$container,
            enableHistoryState: !1,
            singleOptionSelector: this.selectors.singleOptionSelector,
            originalSelectorId: this.selectors.originalSelectorId,
            product: this.productSingleObject,
          };
          (this.variants = new slate.Variants(t)),
            this.$container.on(
              "variantChange" + this.settings.namespace,
              this._updateAddToCart.bind(this)
            ),
            this.$container.on(
              "variantImageChange" + this.settings.namespace,
              this._updateImages.bind(this)
            ),
            this.$container.on(
              "variantPriceChange" + this.settings.namespace,
              this._updatePrice.bind(this)
            );
        },
        _updateAddToCart: function (t) {
          var a = t.variant;
          a
            ? ($(this.selectors.productPrices).removeClass("visibility-hidden"),
              a.available
                ? ($(this.selectors.addToCart, this.selectors.container).prop(
                    "disabled",
                    !1
                  ),
                  0 >= a.inventory_quantity &&
                  a.inventory_management == "shopify"
                    ? $(
                        this.selectors.addToCartText,
                        this.selectors.container
                      ).text(theme.strings.preOrder)
                    : $(
                        this.selectors.addToCartText,
                        this.selectors.container
                      ).text(theme.strings.addToCart))
                : ($(this.selectors.addToCart, this.selectors.container).prop(
                    "disabled",
                    !0
                  ),
                  $(
                    this.selectors.addToCartText,
                    this.selectors.container
                  ).text(theme.strings.soldOut)))
            : ($(this.selectors.addToCart, this.selectors.container).prop(
                "disabled",
                !0
              ),
              $(this.selectors.addToCartText, this.selectors.container).text(
                theme.strings.unavailable
              ),
              $(this.selectors.productPrices).addClass("visibility-hidden"));
        },
        _updateImages: function (t) {
          var a = t.variant;
          this._switchImage(a.featured_image), this._switchColor(a);
        },
        _updatePrice: function (t) {
          var a = t.variant;
          $(this.selectors.originalPrice, this.selectors.container).html(
            theme.CurrencyPicker.formatMoney(a.price)
          ),
            a.compare_at_price > a.price
              ? $(this.selectors.comparePrice, this.selectors.container)
                  .html(theme.CurrencyPicker.formatMoney(a.compare_at_price))
                  .removeClass("hide")
              : $(
                  this.selectors.comparePrice,
                  this.selectors.container
                ).addClass("hide");
        },
        _switchImage: function (t) {
          var a = $(this.selectors.productImage);
          a.attr("data-bgset", theme.roarJs.bgSet(t))
            .removeClass("lazyloaded")
            .addClass("lazyload");
        },
        _switchColor: function (t) {
          var a = $(this.selectors.productColor + " .swatch-item");
          a.length &&
            (a.removeClass("active"),
            a.each(function () {
              $(this).data("variant_id") == t.id && $(this).addClass("active");
            }));
        },
        onUnload: function () {
          this.$container.off(this.settings.namespace);
        },
      })),
      s
    );
  })()),
  (theme.Instagram = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.settings = {
        template:
          '<div class="item"><a href="{{href}}" target="_blank"><span class="meta d-flex align-items-center justify-content-center"><span class="likes">{{likes}}</span><span class="comments">{{comments}}</span></span><img class="lazyload" src="{{src}}" data-srcset="{{srcset}}" /></a></div>',
        accessToken: a.data("access_token"),
        count: a.data("count"),
        selector: "#instagram-" + e,
      }),
        this.settings.accessToken == "" ||
          this.settings.count == 0 ||
          this.init();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        init: function () {
          var t = this,
            a = t._buildUrl();
          $.get(a, function (e) {
            if (
              typeof e == "object" &&
              e.meta.code == 200 &&
              0 < e.data.length
            ) {
              var o = e.data,
                n = "";
              for (i = 0, len = o.length; i < len; i++) {
                var r = "",
                  c = o[i],
                  d = c.images.thumbnail.url,
                  l =
                    c.images.thumbnail.url +
                    " 150w, " +
                    c.images.low_resolution.url +
                    " 320w, " +
                    c.images.standard_resolution.url +
                    " 480w";
                (r = t._makeTemplate(t.settings.template, {
                  href: c.link,
                  src: d,
                  srcset: l,
                  likes: c.likes.count,
                  comments: c.comments.count,
                })),
                  (n += r);
              }
              $(t.settings.selector).append(n);
            }
          });
        },
        _buildUrl: function () {
          var t, a, e;
          return (
            (t = "https://api.instagram.com/v1"),
            (a = "users/self/media/recent"),
            (e = t + "/" + a),
            (e += "?access_token=" + this.settings.accessToken),
            (e += "&count=" + this.settings.count),
            e
          );
        },
        _makeTemplate: function (t, a) {
          var e, o, n, r, c;
          for (o = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, e = t; o.test(e); )
            (r = e.match(o)[1]),
              (c = (n = this._getObjectProperty(a, r)) == null ? "" : n),
              (e = e.replace(o, function () {
                return "" + c;
              }));
          return e;
        },
        _getObjectProperty: function (t, a) {
          var e, o;
          for (a = a.replace(/\[(\w+)\]/g, ".$1"), o = a.split("."); o.length; )
            if (((e = o.shift()), t != null && e in t)) t = t[e];
            else return null;
          return t;
        },
      })),
      s
    );
  })()),
  (theme.CountdownTimer = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.settings = { selector: ".countdown-" + e + ":not(.is-countdown)" }),
        this.regional(),
        this.init();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        regional: function () {
          return (
            typeof $.fn.countdown != "undefined" &&
            (($.countdown.regionalOptions.roar = {
              labels: [
                "Years",
                "Months",
                "Weeks",
                theme.strings.days,
                theme.strings.hours,
                theme.strings.minutes,
                theme.strings.seconds,
              ],
              labels1: [
                "Year",
                "Month",
                "Week",
                theme.strings.day,
                theme.strings.hour,
                theme.strings.minute,
                theme.strings.second,
              ],
              compactLabels: ["y", "m", "w", "d"],
              whichLabels: null,
              digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
              timeSeparator: ":",
              isRTL: theme.settings.rtl,
            }),
            void $.countdown.setDefaults($.countdown.regionalOptions.roar))
          );
        },
        init: function () {
          if (typeof $.fn.countdown == "undefined") return !1;
          var t = $(this.settings.selector);
          t.each(function () {
            var a = $(this);
            if (a.data("end_date") != "") {
              var e = a.data("end_date").split("-"),
                o = new Date(e[2], parseInt(e[0]) - 1, e[1]),
                n = new Date();
              a.countdown({
                until: o,
                alwaysExpire: !0,
                onExpiry: function () {
                  a.hide();
                },
              });
            }
          });
        },
      })),
      s
    );
  })()),
  (theme.NewsletterPopup = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.settings = { selector: "#newsletter-popup-" + e }), this.init();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        init: function () {
          try {
            var r = function () {
                $(document.body)
                  .removeClass("newsletter-opened")
                  .removeClass("newsletter2-opened"),
                  $(document.body).trigger("roarNewsletter_closed", [t]);
              },
              n = r,
              t = $(this.settings.selector),
              a = t.data("period"),
              e = t.data("delay"),
              o = t.data("version");
            if (
              0 < a &&
              document.cookie.match(
                /^(.*;)?\s*roarStorage_newsletter\s*=\s*[^;]+(.*)?$/
              )
            )
              return;
            $(window).on("load", function () {
              setTimeout(function () {
                o == "popup2"
                  ? $(document.body).addClass("newsletter2-opened")
                  : $(document.body).addClass("newsletter-opened");
              }, 1e3 * e);
            }),
              $(document.body).on("roarNewsletter_closed", function () {
                var c = new Date(),
                  d = c.getTime();
                c.setTime(c.getTime() + 1e3 * (60 * (60 * (24 * a)))),
                  (document.cookie =
                    "roarStorage_newsletter=" +
                    d +
                    ";expires=" +
                    c.toGMTString() +
                    ";path=/");
              }),
              $(document.body).on(
                "click",
                ".newsletter-popup-section .close_icon, .newsletter-popup2-section .close_icon, .newsletter-popup-backdrop",
                function (c) {
                  c.preventDefault(), r();
                }
              ),
              $(document).on("keyup", function (c) {
                c.keyCode === 27 && r();
              });
          } catch (r) {}
        },
      })),
      s
    );
  })()),
  (theme.LookbookSection = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.settings = { init: !1 }),
        (this.selectors = {
          lookbookId: "#lookbook__id-" + e + " .roarlookbook",
          lookbookContent: "#lookbook__content-" + e,
        }),
        this.init();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        init: function () {
          var t = this;
          $(document).on(
            "DOMNodeInserted",
            t.selectors.lookbookId,
            function () {
              if (t.settings.init == !1) {
                t.settings.init = !0;
                var a = $(this);
                setTimeout(function () {
                  a.closest(".slideshow__slide").addClass("slide-active"),
                    a
                      .find(".media__blank-preview")
                      .append($(t.selectors.lookbookContent));
                }, 0);
              }
            }
          );
        },
        onLoad: function () {
          roarLookbook.buildLookbook();
        },
      })),
      s
    );
  })()),
  (theme.ProductsSlider = (function () {
    function ProductsSlider(s) {
      var t = (this.$container = $(s)),
        a = t.attr("data-section-id");
      (this.settings = {
        finished: !1,
        cache: {},
        grid_num: 4,
        grid_row: 1,
        max_pages: 1,
        next_page: 1,
        cat_id: !1,
        storage_id: !1,
        storage_data: [],
        atts: {},
      }),
        (this.selectors = {
          slider: ".slick-slider-" + a + ":not(.slick-initialized)",
        }),
        this._initSlider();
    }
    return (
      (ProductsSlider.prototype = _.assignIn({}, ProductsSlider.prototype, {
        _isEditor: function () {
          return (
            window !== window.parent &&
            0 <= window.top.location.pathname.indexOf("/admin") &&
            0 <= window.top.location.pathname.indexOf("/editor")
          );
        },
        _initSlider: function (evt) {
          var self = this,
            that = $(self.selectors.slider);
          if (
            ((self.settings.atts = eval("({" + that.data("atts") + "})")),
            (self.settings.max_pages = that.data("max_pages")),
            (self.settings.cat_id = that.data("cat_id")),
            (self.settings.storage_id = that.data("storage_id")),
            (self.settings.storage_data = []),
            typeof self.settings.cat_id != "undefined" ||
              typeof self.settings.storage_id != "undefined")
          ) {
            var parent = that.closest(".products-slider");
            if (
              ((self.settings.grid_num = that.data("grid_num")),
              (self.settings.grid_row = that.data("grid_row")),
              typeof self.settings.storage_id != "undefined" &&
                self.settings.storage_id.length)
            ) {
              var storageName = "roarStorage_" + self.settings.storage_id,
                items = localStorage.getItem(storageName) || "[]";
              try {
                items = JSON.parse(items);
              } catch (s) {
                localStorage.removeItem(storageName),
                  (items = JSON.parse("[]"));
              }
              var productId = 0;
              (productId =
                typeof window.ShopifyAnalytics == "undefined"
                  ? weketingShop.productJson.id
                  : window.ShopifyAnalytics.meta.product.id),
                items.includes(productId) &&
                  items.splice(items.indexOf(productId), 1),
                (self.settings.storage_data = items);
              var howManyToShow = Math.min(
                self.settings.storage_data.length,
                180
              );
              howManyToShow &&
                (howManyToShow <=
                  self.settings.grid_num * self.settings.grid_row &&
                  $(".slick-arrows", parent).remove(),
                self._buildSlider());
            }
            2 > self.settings.max_pages ||
              ($(".slick-prev", parent)
                .off("click")
                .on("click", function (s) {
                  s.preventDefault(),
                    self._isEditor() ||
                      (--self.settings.next_page,
                      0 >= self.settings.next_page &&
                        (self.settings.next_page = self.settings.max_pages),
                      self._buildSlider());
                }),
              $(".slick-next", parent)
                .off("click")
                .on("click", function (s) {
                  s.preventDefault(),
                    self._isEditor() ||
                      (++self.settings.next_page,
                      self.settings.next_page > self.settings.max_pages &&
                        (self.settings.next_page = 1),
                      self._buildSlider());
                }),
              $(window).scroll(function () {
                var s = $(".slick-arrows", parent),
                  t = $(".slick-prev", parent),
                  a = $(".slick-next", parent),
                  e = $(window).height() / 2,
                  o = $(window).outerWidth(!0),
                  n = parent.outerWidth(!0),
                  r = $(window).scrollTop(),
                  c = parent.offset().top - e,
                  d = parent.offset().left - 50,
                  l = n + parent.offset().left + 50 - a.outerWidth(),
                  u = t.outerHeight(),
                  f = parent.height() - u,
                  h = "left";
                theme.settings.rtl && (h = "right"),
                  1024 >= $(window).width() && ((d += 35), (l -= 35)),
                  t.css(h, d + "px"),
                  a.css(h, l + "px"),
                  r < c || r > c + f
                    ? s.removeClass("show-arrow")
                    : s.addClass("show-arrow");
              }));
          }
        },
        _buildSlider: function () {
          var s = this,
            t = !1,
            a = 1e3;
          typeof s.settings.cache[s.settings.next_page] == "undefined" &&
            ((t =
              typeof s.settings.cat_id == "undefined"
                ? s._ajaxStorage()
                : s._ajaxCollection()),
            (a = 0));
          var e = $(s.selectors.slider).closest(".products-slider");
          e.addClass("loading"),
            $.when(t).done(function () {
              setTimeout(function () {
                s._buildProducts(), s._lineItem();
              }, a),
                setTimeout(function () {
                  e.removeClass("loading");
                }, a + 250);
            });
        },
        _ajaxCollection: function () {
          var s = this,
            t = $(s.selectors.slider).closest(".products-slider");
          if (!t.hasClass("loading") && !t.hasClass("finished")) {
            var s = this;
            return $.ajax({
              url: "/collections/" + s.settings.cat_id,
              type: "GET",
              dataType: "html",
              data: {
                view: "custom",
                limit: s.settings.grid_num + "*" + s.settings.grid_row,
                page: s.settings.next_page,
                type:
                  s.settings.atts.image_ratio +
                  "*" +
                  1 * s.settings.atts.image_ratio_crop +
                  "*" +
                  1 * s.settings.atts.image_second +
                  "*" +
                  s.settings.atts.image_overlay +
                  "*" +
                  s.settings.atts.product_hover +
                  "*" +
                  1 * s.settings.atts.vendor +
                  "*" +
                  1 * s.settings.atts.review +
                  "*" +
                  1 * s.settings.atts.quickview +
                  "*" +
                  1 * s.settings.atts.wishlist +
                  "*" +
                  1 * s.settings.atts.compare,
                cache: !1,
              },
              success: function (e) {
                if ($(e).find(".product").length) {
                  if (
                    ((s.settings.cache[s.settings.next_page] = e),
                    $(e).data("is_next") == !1)
                  ) {
                    s.settings.finished = !0;
                    for (var o = 1; o <= s.settings.next_page; o++)
                      typeof s.settings.cache[o] == "undefined" &&
                        (s.settings.finished = !1);
                  }
                  s._buildProducts();
                } else s.settings.finished = !0;
                s.settings.finished && t.addClass("finished");
              },
            });
          }
        },
        _ajaxStorage: function () {
          var s = this,
            t = $(s.selectors.slider).closest(".products-slider");
          if (!t.hasClass("loading") && !t.hasClass("finished")) {
            var s = this,
              a = s.settings.grid_num * s.settings.grid_row,
              e = (s.settings.next_page - 1) * a,
              o = s.settings.storage_data.splice(e, a),
              n = o
                .map(function (c) {
                  return "id:" + c;
                })
                .join(" OR ");
            return $.ajax({
              url: "/search",
              data: { view: "viewed", type: "product", q: n },
              dataType: "html",
              type: "GET",
              success: function (c) {
                if ($(c).find(".product").length) {
                  if (
                    ((s.settings.cache[s.settings.next_page] = c),
                    t.closest(".products-slider_hide").removeClass("hide"),
                    s.settings.storage_data.length == 0)
                  ) {
                    s.settings.finished = !0;
                    for (var d = 1; d <= s.settings.next_page; d++)
                      typeof s.settings.cache[d] == "undefined" &&
                        (s.settings.finished = !1);
                  }
                  s._buildProducts();
                } else s.settings.finished = !0;
                s.settings.finished && t.addClass("finished");
              },
            });
          }
        },
        _buildProducts: function () {
          var s = this,
            t = $(s.selectors.slider).closest(".products-slider"),
            a = $(s.settings.cache[s.settings.next_page]),
            e = t.find(".products");
          $.fn.countdown &&
            e.find(".product__countdown .is-countdown").each(function () {
              $(this).countdown("destroy");
            }),
            e.empty(),
            0 < a.find(".product").length &&
              (a
                .find(".product__image")
                .removeClass("lazyloaded")
                .removeClass("lazyloading")
                .addClass("lazyload"),
              a.find(".product").each(function () {
                e.append($(this));
              }));
        },
        _lineItem: function () {
          theme.roarJs.initReviews(),
            theme.roarJs.splitText(),
            theme.roarJs.animationProduct(),
            theme.roarJs.fixtooltipHover();
          var s = new theme.Sections();
          s.register("line_item", theme.LineItem),
            s.register("countdown-timer", theme.CountdownTimer);
        },
        onLoad: function () {
          this._lineItem();
        },
      })),
      ProductsSlider
    );
  })()),
  (theme.ProductTabs = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = a.attr("data-section-id");
      (this.selectors = {
        container: ".tabs__container",
        title: ".tabs__title",
        panel: ".tabs__panel",
      }),
        this._initTabs(),
        this._productsSlider();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _initTabs: function () {
          var t = this;
          $(document).off("click", t.selectors.title),
            $(document).on("click", t.selectors.title, function (a) {
              a.preventDefault();
              var e = $(this),
                o = e.closest(t.selectors.container),
                n = $(e.attr("href")),
                r = n.find(".slick-slider"),
                c = o.find(t.selectors.title),
                d = o.find(t.selectors.panel);
              c.removeClass("active"),
                d.removeClass("active"),
                e.addClass("active"),
                n.addClass("active"),
                r.hasClass("slick-initialized") && r.slick("setPosition");
            });
        },
        _productsSlider: function () {
          var t = new theme.Sections();
          t.register("products-slider-sub", theme.ProductsSlider);
        },
        _lineItem: function () {
          theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
          var t = new theme.Sections();
          t.register("line_item", theme.LineItem),
            t.register("countdown-timer", theme.CountdownTimer);
        },
        onLoad: function () {
          this._lineItem();
        },
      })),
      s
    );
  })()),
  (theme.RichBanner = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = (this.sectionId = a.attr("data-section-id"));
      (this.selectors = {
        bannerId: "#shopify-section-" + e,
        bannerNamspace: "#rich-banners-" + e,
        bannerAnime: "#rich-banners-" + e + " .has--anime-fx",
        bannerTilter: "#rich-banners-" + e + " .has--tilt-effect",
        bannerSlider:
          "#rich-banners-" + e + " .rich-banner--group.is-slick_slider",
      }),
        (this.settings = {
          mediaQueryMediumUp: "screen and (min-width: 768px)",
          mediaQuerySmall: "screen and (max-width: 767px)",
          sliderActive: !1,
        }),
        this._initBreakpoints(),
        this._initAnime(),
        this._initTilter();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        _initBreakpoints: function () {
          var t = this;
          enquire.register(this.settings.mediaQuerySmall, {
            match: function () {
              t.settings.sliderActive && t._destroySlider(), t._initSlider();
            },
          }),
            enquire.register(this.settings.mediaQueryMediumUp, {
              match: function () {
                t.settings.sliderActive && t._destroySlider(),
                  t._initSlider(!1);
              },
            });
        },
        _destroySlider: function () {
          var t = this;
          $(t.selectors.bannerSlider).each(function () {
            var a = $(this),
              e = a.find(".rich-banner--slider.slick-initialized");
            e.slick("unslick"), (t.settings.sliderActive = !1);
          });
        },
        _initSlider: function (t) {
          var a = this;
          $(a.selectors.bannerSlider).each(function () {
            var e = $(this);
            typeof t == "undefined" && (t = !0);
            var o = e.find(".rich-banner--slider:not(.slick-initialized)"),
              n = {
                rtl: theme.settings.rtl,
                dots: !1,
                arrows: !0,
                slidesToScroll: 1,
                slidesToShow: e.data("per_slide"),
                autoplay: e.data("autoplay"),
                autoplaySpeed: e.data("interval"),
                variableWidth: e.data("variable_width"),
                centerMode: e.data("variable_width"),
                appendArrows: $(".slick-arrows", o.parent()),
                prevArrow:
                  '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
                nextArrow:
                  '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
              };
            t == !0 && (n.slidesToShow = e.data("per_slide_mb")),
              o.slick(n),
              (a.settings.sliderActive = !0);
          });
        },
        _initTilter: function () {
          $(this.selectors.bannerTilter).each(function () {
            var t = $(this);
            t.on("mousemove", function (a) {
              var e = $(this).offset().left,
                o = $(this).offset().top,
                n = a.pageX - e,
                r = a.pageY - o,
                c = $(this).width() / 2 - n,
                d = $(this).height() / 2 - r;
              $(this).css(
                "transform",
                "perspective(500px) rotateX(" +
                  d / 40 +
                  "deg) rotateY(" +
                  -(c / 40) +
                  "deg) translateZ(10px)"
              ),
                0 < Math.sign(c) ? -Math.abs(c) : Math.abs(c),
                $(this).removeClass("tilt-leave");
            }),
              t.on("mouseleave", function () {
                $(this).addClass("tilt-leave");
              });
          });
        },
        _initAnime: function () {
          $(this.selectors.bannerAnime).each(function () {
            var t = $(this),
              a = { used: t.data("fx"), type: t.data("fx_type") };
            a.used &&
              (a.type == "dominos"
                ? anime
                    .timeline({ loop: !0 })
                    .add({
                      targets: t.find(".fx__dominos .letter").toArray(),
                      rotateY: [-90, 0],
                      duration: 1300,
                      delay: function (e, o) {
                        return 45 * o;
                      },
                    })
                    .add({
                      targets: t.find(".fx__dominos").toArray(),
                      opacity: 0,
                      duration: 1e3,
                      easing: "easeOutExpo",
                      delay: 1e3,
                    })
                : a.type == "vertical-lines"
                ? anime
                    .timeline({ loop: !0 })
                    .add({
                      targets: t.find(".fx__vertical-lines .letter").toArray(),
                      scale: [0.3, 1],
                      opacity: [0, 1],
                      translateZ: 0,
                      easing: "easeOutExpo",
                      duration: 600,
                      delay: function (e, o) {
                        return 70 * (o + 1);
                      },
                    })
                    .add({
                      targets: t.find(".fx__vertical-lines .line").toArray(),
                      scaleX: [0, 1],
                      opacity: [0.5, 1],
                      easing: "easeOutExpo",
                      duration: 700,
                      offset: "-=875",
                      delay: function (e, o, n) {
                        return 80 * (n - o);
                      },
                    })
                    .add({
                      targets: t.find(".fx__vertical-lines").toArray(),
                      opacity: 0,
                      duration: 1e3,
                      easing: "easeOutExpo",
                      delay: 1e3,
                    })
                : a.type == "fading"
                ? anime
                    .timeline({ loop: !0 })
                    .add({
                      targets: t.find(".fx__fading .letter").toArray(),
                      opacity: [0, 1],
                      easing: "easeInOutQuad",
                      duration: 2250,
                      delay: function (e, o) {
                        return 150 * (o + 1);
                      },
                    })
                    .add({
                      targets: t.find(".fx__fading").toArray(),
                      opacity: 0,
                      duration: 1e3,
                      easing: "easeOutExpo",
                      delay: 1e3,
                    })
                : a.type == "intro"
                ? anime
                    .timeline({ loop: !0 })
                    .add({
                      targets: t.find(".fx__intro .letter").toArray(),
                      translateX: [40, 0],
                      translateZ: 0,
                      opacity: [0, 1],
                      easing: "easeOutExpo",
                      duration: 1200,
                      delay: function (e, o) {
                        return 500 + 30 * o;
                      },
                    })
                    .add({
                      targets: t.find(".fx__intro .letter").toArray(),
                      translateX: [0, -30],
                      opacity: [1, 0],
                      easing: "easeInExpo",
                      duration: 1100,
                      delay: function (e, o) {
                        return 100 + 30 * o;
                      },
                    })
                : a.type == "surprising"
                ? anime
                    .timeline({ loop: !0 })
                    .add({
                      targets: t.find(".fx__surprising .word").toArray(),
                      scale: [14, 1],
                      opacity: [0, 1],
                      easing: "easeOutCirc",
                      duration: 800,
                      delay: function (e, o) {
                        return 800 * o;
                      },
                    })
                    .add({
                      targets: t.find(".fx__surprising").toArray(),
                      opacity: 0,
                      duration: 1e3,
                      easing: "easeOutExpo",
                      delay: 1e3,
                    })
                : anime
                    .timeline({ loop: !0 })
                    .add({
                      targets: t.find(".fx__typing .line").toArray(),
                      scaleY: [0, 1],
                      opacity: [0.5, 1],
                      easing: "easeOutExpo",
                      duration: 700,
                    })
                    .add({
                      targets: t.find(".fx__typing .line").toArray(),
                      translateX: [
                        0,
                        t.find(".fx__typing .letters").first().width(),
                      ],
                      easing: "easeOutExpo",
                      duration: 700,
                      delay: 100,
                    })
                    .add({
                      targets: t.find(".fx__typing .letter").toArray(),
                      opacity: [0, 1],
                      easing: "easeOutExpo",
                      duration: 600,
                      offset: "-=775",
                      delay: function (e, o) {
                        return 34 * (o + 1);
                      },
                    })
                    .add({
                      targets: t.find(".fx__typing").toArray(),
                      opacity: 0,
                      duration: 1e3,
                      easing: "easeOutExpo",
                      delay: 1e3,
                    }));
          });
        },
        _lineItem: function () {
          theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
          var t = new theme.Sections();
          t.register("line_item", theme.LineItem),
            t.register("countdown-timer", theme.CountdownTimer);
        },
        onLoad: function () {
          this._lineItem();
        },
        onUnload: function () {
          this.$container.off(this.bannerNamspace);
        },
      })),
      s
    );
  })()),
  (theme.CollectionsSlider = (function () {
    function s(t) {
      var a = (this.$container = $(t)),
        e = (this.sectionId = a.attr("data-section-id"));
      (this.selectors = {
        container: "#CollectionsSlider-" + e,
        carousel: "#CollectionsSlider-" + e + " .slider_large",
        carousel_small: "#CollectionsSlider-" + e + " .slider_small",
        carousel_content:
          "#CollectionsSlider-" + e + " .slider_content-wrapper",
      }),
        this.beforeInit(),
        this.init();
    }
    return (
      (s.prototype = _.assignIn({}, s.prototype, {
        beforeInit: function () {
          var t = 0.01 * window.innerHeight;
          if (
            (document.documentElement.style.setProperty("--vh", t + "px"),
            window.addEventListener("resize", function () {
              var a = 0.01 * window.innerHeight;
              document.documentElement.style.setProperty("--vh", a + "px");
            }),
            typeof Flickity.prototype._createPrevNextCells == "undefined")
          ) {
            var a = function (o, n, r) {
                o &&
                  o.getCellElements().forEach(function (c) {
                    c.classList[n](r);
                  });
              },
              t = a;
            Flickity.createMethods.push("_createPrevNextCells"),
              (Flickity.prototype._createPrevNextCells = function () {
                this.on("select", this.setPrevNextCells);
              }),
              (Flickity.prototype.setPrevNextCells = function () {
                a(this.previousSlide, "remove", "is-previous"),
                  a(this.nextSlide, "remove", "is-next");
                var o = fizzyUIUtils.modulo(
                    this.selectedIndex - 1,
                    this.slides.length
                  ),
                  n = fizzyUIUtils.modulo(
                    this.selectedIndex + 1,
                    this.slides.length
                  );
                (this.previousSlide = this.slides[o]),
                  (this.nextSlide = this.slides[n]),
                  a(this.previousSlide, "add", "is-previous"),
                  a(this.nextSlide, "add", "is-next");
              });
          }
        },
        init: function () {
          var t = this,
            a = $(t.selectors.carousel),
            e = $(t.selectors.carousel_small),
            o = $(t.selectors.carousel_content),
            n = Math.floor(e.find(".slideshow__slide").length) - 1,
            r = a.data("autoplay"),
            c = a.data("speed"),
            d = a.find(".slideshow__image"),
            l = e.find(".slideshow__image");
          theme.settings.rtl && (n = 1);
          var u = new Flickity(t.selectors.carousel_content, {
              rightToLeft: theme.settings.rtl,
              prevNextButtons: !0,
              pageDots: !0,
              wrapAround: !0,
              autoPlay: !!r && c,
              draggable: !1,
              setGallerySize: !1,
              sync: t.selectors.carousel,
              arrowShape:
                "M3.1,28.9 28.6,3.4 32.9,7.7 14.7,25.9 68.1,25.9 68.1,32 14.7,32 32.9,50.2 28.6,54.5 z",
              on: { ready: function () {} },
            }),
            f = new Flickity(t.selectors.carousel_small, {
              rightToLeft: theme.settings.rtl,
              bgLazyLoad: 1,
              imagesLoaded: !0,
              prevNextButtons: !1,
              pageDots: !1,
              wrapAround: !0,
              autoPlay: !!r && c,
              draggable: !1,
              setGallerySize: !1,
              initialIndex: n,
              on: {
                ready: function () {
                  var I = new TimelineLite(),
                    T = e.find(".flickity-slider");
                  I.fromTo(
                    T,
                    2,
                    { scale: 1.2 },
                    { ease: Power4.easeInOut, scale: 1 },
                    0
                  );
                },
              },
            });
          f.on("scroll", function () {
            f.slides.forEach(function (I, T) {
              var P = l[T],
                O = 0;
              P &&
                ((O =
                  T === 0
                    ? Math.abs(f.x) > f.slidesWidth
                      ? f.slidesWidth +
                        f.x +
                        f.slides[f.slides.length - 1].outerWidth +
                        I.target
                      : I.target + f.x
                    : T === h.slides.length - 1 &&
                      Math.abs(f.x) + f.slides[T].outerWidth < f.slidesWidth
                    ? I.target - f.slidesWidth + f.x - f.slides[T].outerWidth
                    : I.target + f.x),
                typeof window.mobileCheck != "undefined" &&
                  !window.mobileCheck() &&
                  !theme.settings.rtl &&
                  (P.style.transform = "translateX(" + O * (-1 / 2) + "px)"));
            });
          });
          var h = new Flickity(t.selectors.carousel, {
            rightToLeft: theme.settings.rtl,
            bgLazyLoad: 1,
            imagesLoaded: !0,
            accessibility: !1,
            prevNextButtons: !1,
            pageDots: !1,
            contain: !0,
            wrapAround: !0,
            setGallerySize: !1,
            sync: t.selectors.carousel_content,
            autoPlay: !!r && c,
            arrowShape: { x0: 10, x1: 60, y1: 50, x2: 60, y2: 45, x3: 15 },
            on: {
              ready: function () {
                var I = new TimelineLite(),
                  T = a.find(".flickity-slider"),
                  P = a.find(".slider-content-wrapper"),
                  O = a.find(".flickity-button svg"),
                  V = a.find(".flickity-page-dots");
                I.fromTo(
                  T,
                  2,
                  { scale: 1.2 },
                  { ease: Power4.easeInOut, scale: 1 },
                  0
                ),
                  I.fromTo(
                    P,
                    2.4,
                    { opacity: 0 },
                    { ease: Power4.easeInOut, opacity: 1 },
                    1
                  ),
                  I.fromTo(
                    [O, V],
                    2,
                    { opacity: 0 },
                    { ease: Power4.easeInOut, opacity: 1 },
                    1.3
                  );
              },
            },
          });
          $(document).on(
            "click",
            t.selectors.carousel_content +
              " .flickity-prev-next-button.previous",
            function () {
              f.previous();
            }
          ),
            $(document).on(
              "click",
              t.selectors.carousel_content + " .flickity-prev-next-button.next",
              function () {
                f.next();
              }
            );
          var b = null,
            C = null;
          h.on("dragMove", function (I, T, P) {
            (b = h.selectedIndex),
              (C = t.getSwipeDirection(P)),
              r && f.stopPlayer();
          }),
            h.on("dragEnd", function () {
              h.selectedIndex !== b && (C === "left" ? f.next() : f.previous());
            }),
            $(t.selectors.container).on("mouseenter", function () {
              h.stopPlayer(), f.stopPlayer(), u.stopPlayer();
            }),
            h.on("scroll", function () {
              h.slides.forEach(function (I, T) {
                var P = d[T],
                  O = 0;
                P &&
                  ((O =
                    T === 0
                      ? Math.abs(h.x) > h.slidesWidth
                        ? h.slidesWidth +
                          h.x +
                          h.slides[h.slides.length - 1].outerWidth +
                          I.target
                        : I.target + h.x
                      : T === h.slides.length - 1 &&
                        Math.abs(h.x) + h.slides[T].outerWidth < h.slidesWidth
                      ? I.target - h.slidesWidth + h.x - h.slides[T].outerWidth
                      : I.target + h.x),
                  typeof window.mobileCheck != "undefined" &&
                    !window.mobileCheck() &&
                    !theme.settings.rtl &&
                    (P.style.transform = "translateX(" + O * (-1 / 2) + "px)"));
              });
            });
        },
        getSwipeDirection: function (t) {
          var a = null;
          return (a = 0 < t.x ? "right" : "left"), a;
        },
        onSelect: function () {
          typeof theme.roarAdminJs != "undefined" &&
            theme.roarAdminJs.refresh();
        },
        onLoad: function () {},
        onUnload: function () {},
      })),
      s
    );
  })());
var roarLookbook = {
  getSizedImageUrl: function (s, t) {
    var a = document.createElement("a");
    if (((a.href = s), a.hostname != "cdn.shopify.com" || t == null)) return s;
    if (t == "master") return roarLookbook.removeProtocol(s);
    var e = s.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (e != null) {
      var a = s.split(e[0]),
        o = e[0];
      return roarLookbook.removeProtocol(a[0] + "_" + t + o);
    }
    return null;
  },
  removeProtocol: function (s) {
    return s.replace(/http(s)?:/, "");
  },
  isProductUrl: function (s) {
    var t = window.location.hostname,
      a = document.createElement("a");
    return (a.href = s), a.hostname == t;
  },
  isImageUrl: function (s) {
    return new Promise(function (t) {
      var a = new Image();
      $(a)
        .load(function () {
          t(!0);
        })
        .error(function () {
          t(!1);
        })
        .attr("src", s);
    });
  },
  buildLookbook: function () {
    $(".roarlookbook").each(function () {
      var s = $(this);
      if (!s.hasClass("roarlookbook_init")) {
        var t = s.find(".image-preview"),
          a = roarLookbook.isImageUrl(t.attr("src"));
        a.then(function () {
          var e = s.find(".media__blank-preview");
          s.addClass("roarlookbook_init"), e.addClass("sfx-fadeIn");
        });
      }
    });
  },
  resetHotspots: function (s) {
    var t = $(".hotspot", s),
      a = s.attr("data-lookbook");
    t.each(function () {
      var e = $(this),
        o = e.attr("data-id"),
        n = $("#" + a + "-" + o, s);
      n.fadeOut("fast", function () {
        n.remove(), e.removeClass("hotspot_init");
      });
    });
  },
  hotspotPopup: function () {
    $(".roarlookbook").on("click", ".hotspot", function () {
      var s = $(this);
      if (s.hasClass("hotspot_init")) {
        var t = s.closest(".roarlookbook");
        roarLookbook.resetHotspots(t);
      } else {
        var t = s.closest(".roarlookbook"),
          a = s.attr("data-id"),
          e = s.closest(".roarlookbook").attr("data-lookbook") + "-" + a,
          o = "#" + s.closest(".roarlookbook").attr("data-lookbook") + "-" + a,
          n = s.attr("data-title"),
          r = s.attr("data-image"),
          c = s.attr("data-price"),
          d = s.attr("data-url"),
          l = "";
        if (n == "" && d == "") return !1;
        if (
          (s.addClass("hotspot_loading"),
          roarLookbook.resetHotspots(t),
          (l += '<div id="' + e + '" class="hotspot-widget hotspot-loading">'),
          (l += '<div class="hotspot-content">'),
          (l += '<span class="hotspot-close">\xD7</span>'),
          (l += '<div class="hotspot-inner">'),
          r != "")
        ) {
          var u =
            '<img src="' +
            roarLookbook.getSizedImageUrl(r, "80x") +
            '" src="' +
            roarLookbook.getSizedImageUrl(r, "300x") +
            '" data-srcset="' +
            roarLookbook.getSizedImageUrl(r, "300x") +
            " 1x, " +
            roarLookbook.getSizedImageUrl(r, "600x") +
            ' 2x" alt="" />';
          l += d == "" ? u : '<a href="' + d + '">' + u + "</a>";
        }
        if (
          (n != "" &&
            ((l += "<h3>"),
            (l += d == "" ? n : '<a href="' + d + '">' + n + "</a>"),
            (l += "</h3>")),
          c != "" &&
            ((l +=
              '<div class="price"><span class="money">' + c + "</span></div>"),
            roarLookbook.isProductUrl(d) &&
              ((l += '<div class="hotspot-btns">'),
              (l +=
                '<div class="hotspot-btn"><a href="' +
                d +
                '">' +
                theme.apps.details +
                "</a></div>"),
              (l +=
                '<div class="hotspot-btn"><a class="roar_add_to_cart" href="' +
                d +
                '?add-to-cart=true">' +
                theme.apps.buyNow +
                "</a></div>"),
              (l += "</div>"))),
          (l += "</div>"),
          (l += "</div>"),
          (l += "</div>"),
          $(o).length || t.append(l),
          $(o).find("img").length)
        ) {
          var f = $(o).find("img");
          f.attr("src", f.attr("data-src"))
            .removeAttr("data-src")
            .attr("srcset", f.attr("data-srcset"))
            .removeAttr("data-srcset");
        }
        var h = roarLookbook.isImageUrl(r);
        h.then(function () {
          setTimeout(function () {
            var b = $(o),
              C = s.offset().left,
              I = s.offset().top,
              T = b.outerWidth(),
              P = b.outerHeight(),
              O = t.offset().left,
              V = t.offset().top,
              U = t.outerWidth() - (C + T),
              Q = "hotspot-right";
            C > T + 5
              ? ((C = C - T - 5), (Q = "hotspot-left"))
              : (C = C + s.outerWidth() + 5),
              (I = I + s.outerHeight() / 2 - P / 2),
              b
                .css({ left: C - O, top: I - V })
                .removeClass("hotspot-left")
                .removeClass("hotspot-right")
                .addClass(Q),
              s.removeClass("hotspot_loading").addClass("hotspot_init"),
              b.removeClass("hotspot-loading").fadeIn("fast");
          }, 600);
        });
      }
    }),
      $(document).on("click", ".hotspot-close", function () {
        var s = $(this),
          t = s.closest(".hotspot-widget"),
          a = t.attr("id"),
          e = a.split("-"),
          o = e[1];
        $('.roarlookbook .hotspot[data-id="' + o + '"]').removeClass(
          "hotspot_init"
        ),
          t.fadeOut("fast", function () {
            t.remove();
          });
      }),
      $(".roarlookbook").on("click", ".image-preview", function () {
        var s = $(this).closest(".roarlookbook");
        roarLookbook.resetHotspots(s);
      }),
      $(window).resize(function () {
        $(".roarlookbook .hotspot_init").length &&
          $(".roarlookbook .hotspot_init").each(function () {
            var s = $(this);
            s.removeClass("hotspot_init").trigger("click");
          });
      });
  },
  addToCart: function () {
    $(document).on("click", ".roar_add_to_cart", function (s) {
      s.preventDefault();
      var t = $(this),
        a = t.closest(".roarlookbook"),
        e = t.attr("href");
      $.ajax({
        type: "GET",
        url: e,
        beforeSend: function () {},
        success: function (o) {
          var n = $(o).find('form[action="/cart/add"]');
          n.appendTo(a).submit().remove();
        },
        dataType: "html",
      });
    });
  },
  init: function () {
    $(".roarlookbook").length &&
      (roarLookbook.buildLookbook(),
      roarLookbook.hotspotPopup(),
      roarLookbook.addToCart());
  },
};
(theme.roarJs = (function () {
  function s() {
    $(document).off("click", ".section__anchor"),
      $(document).on("click", ".section__anchor", function (p) {
        p.preventDefault();
        var m = $(this).closest(".container-section"),
          v = m.offset().top + m.outerHeight();
        $(".header-sticky__placeholder").length &&
          !$(".header-sticky__placeholder").hasClass("hide") &&
          (v -= $(".header-sticky__placeholder").outerHeight()),
          $("html, body").animate({ scrollTop: v }, 500, "swing");
      });
  }
  function t() {
    var p = [
      {},
      {
        movement: {
          imgWrapper: {
            translation: { x: 10, y: 10, z: 30 },
            rotation: { x: 0, y: -10, z: 0 },
            reverseAnimation: { duration: 200, easing: "easeOutQuad" },
          },
          lines: {
            translation: { x: 10, y: 10, z: [0, 70] },
            rotation: { x: 0, y: 0, z: -2 },
            reverseAnimation: { duration: 2e3, easing: "easeOutExpo" },
          },
          caption: {
            rotation: { x: 0, y: 0, z: 2 },
            reverseAnimation: { duration: 200, easing: "easeOutQuad" },
          },
          overlay: {
            translation: { x: 10, y: -10, z: 0 },
            rotation: { x: 0, y: 0, z: 2 },
            reverseAnimation: { duration: 2e3, easing: "easeOutExpo" },
          },
          shine: {
            translation: { x: 100, y: 100, z: 0 },
            reverseAnimation: { duration: 200, easing: "easeOutQuad" },
          },
        },
      },
      {
        movement: {
          imgWrapper: {
            rotation: { x: -5, y: 10, z: 0 },
            reverseAnimation: { duration: 900, easing: "easeOutCubic" },
          },
          caption: {
            translation: { x: 30, y: 30, z: [0, 40] },
            rotation: { x: [0, 15], y: 0, z: 0 },
            reverseAnimation: { duration: 1200, easing: "easeOutExpo" },
          },
          overlay: {
            translation: { x: 10, y: 10, z: [0, 20] },
            reverseAnimation: { duration: 1e3, easing: "easeOutExpo" },
          },
          shine: {
            translation: { x: 100, y: 100, z: 0 },
            reverseAnimation: { duration: 900, easing: "easeOutCubic" },
          },
        },
      },
      {
        movement: {
          imgWrapper: {
            rotation: { x: -5, y: 10, z: 0 },
            reverseAnimation: { duration: 50, easing: "easeOutQuad" },
          },
          caption: {
            translation: { x: 20, y: 20, z: 0 },
            reverseAnimation: { duration: 200, easing: "easeOutQuad" },
          },
          overlay: {
            translation: { x: 5, y: -5, z: 0 },
            rotation: { x: 0, y: 0, z: 6 },
            reverseAnimation: { duration: 1e3, easing: "easeOutQuad" },
          },
          shine: {
            translation: { x: 50, y: 50, z: 0 },
            reverseAnimation: { duration: 50, easing: "easeOutQuad" },
          },
        },
      },
      {
        movement: {
          imgWrapper: {
            translation: { x: 0, y: -8, z: 0 },
            rotation: { x: 3, y: 3, z: 0 },
            reverseAnimation: { duration: 1200, easing: "easeOutExpo" },
          },
          lines: {
            translation: { x: 15, y: 15, z: [0, 15] },
            reverseAnimation: { duration: 1200, easing: "easeOutExpo" },
          },
          overlay: {
            translation: { x: 0, y: 8, z: 0 },
            reverseAnimation: { duration: 600, easing: "easeOutExpo" },
          },
          caption: {
            translation: { x: 10, y: -15, z: 0 },
            reverseAnimation: { duration: 900, easing: "easeOutExpo" },
          },
          shine: {
            translation: { x: 50, y: 50, z: 0 },
            reverseAnimation: { duration: 1200, easing: "easeOutExpo" },
          },
        },
      },
      {
        movement: {
          lines: {
            translation: { x: -5, y: 5, z: 0 },
            reverseAnimation: { duration: 1e3, easing: "easeOutExpo" },
          },
          caption: {
            translation: { x: 15, y: 15, z: 0 },
            rotation: { x: 0, y: 0, z: 3 },
            reverseAnimation: {
              duration: 1500,
              easing: "easeOutElastic",
              elasticity: 700,
            },
          },
          overlay: {
            translation: { x: 15, y: -15, z: 0 },
            reverseAnimation: { duration: 500, easing: "easeOutExpo" },
          },
          shine: {
            translation: { x: 50, y: 50, z: 0 },
            reverseAnimation: { duration: 500, easing: "easeOutExpo" },
          },
        },
      },
      {
        movement: {
          imgWrapper: {
            translation: { x: 5, y: 5, z: 0 },
            reverseAnimation: { duration: 800, easing: "easeOutQuart" },
          },
          caption: {
            translation: { x: 10, y: 10, z: [0, 50] },
            reverseAnimation: { duration: 1e3, easing: "easeOutQuart" },
          },
          shine: {
            translation: { x: 50, y: 50, z: 0 },
            reverseAnimation: { duration: 800, easing: "easeOutQuart" },
          },
        },
      },
      {
        movement: {
          lines: {
            translation: { x: 40, y: 40, z: 0 },
            reverseAnimation: { duration: 1500, easing: "easeOutElastic" },
          },
          caption: {
            translation: { x: 20, y: 20, z: 0 },
            rotation: { x: 0, y: 0, z: -5 },
            reverseAnimation: { duration: 1e3, easing: "easeOutExpo" },
          },
          overlay: {
            translation: { x: -30, y: -30, z: 0 },
            rotation: { x: 0, y: 0, z: 3 },
            reverseAnimation: { duration: 750, easing: "easeOutExpo" },
          },
          shine: {
            translation: { x: 100, y: 100, z: 0 },
            reverseAnimation: { duration: 750, easing: "easeOutExpo" },
          },
        },
      },
    ];
    (function () {
      var m = 0;
      [].slice
        .call(document.querySelectorAll(".tilter"))
        .forEach(function (v, w) {
          (m = w % 30 == 0 ? m + 1 : m), new TiltFx(v, p[m - 1]);
        });
    })();
  }
  function a() {
    $("#site-loader").length &&
      (NProgress.configure({
        template: '<div class="bar" role="bar"></div>',
        parent: "#site-loader",
        showSpinner: !1,
        easing: "ease",
        minimum: 0.3,
        speed: 500,
      }),
      NProgress.start(),
      $(window).on("pagehide", function (p) {
        p.persisted &&
          ($("#site-container").addClass("loading").removeClass("loaded"),
          $("#site-loader").removeClass("loaded"));
      }),
      $(window).load(function () {
        $("#site-container").addClass("loaded").removeClass("loading"),
          $("#site-loader").addClass("loaded"),
          NProgress.done();
      }));
  }
  function e() {
    var p = (function (m) {
      try {
        for (
          var v, w = m + "=", S = document.cookie.split(";"), g = 0;
          g < S.length;
          g++
        ) {
          for (v = S[g]; v.charAt(0) == " "; ) v = v.substring(1, v.length);
          if (v.indexOf(w) == 0) return v.substring(w.length, v.length);
        }
        return null;
      } catch (k) {
        return null;
      }
    })("roarStorage_isAnAdult");
    p ? $("#age__check").remove() : $("#age__check").addClass("active"),
      $(document).off("click", "#age__check .btn-birthdate"),
      $(document).on("click", "#age__check .btn-birthdate", function () {
        var m = new Date();
        m.setTime(m.getTime() + 12096e5);
        var v = "; expires=" + m.toGMTString();
        (document.cookie = "roarStorage_isAnAdult=true;" + v + "; path=/"),
          $("#age__check").remove();
      });
  }
  function o() {
    function p() {
      var m = new TimelineLite(),
        v = $(".site-sidebar .widget-area"),
        w = $(".site-sidebar .site-widget");
      theme.settings.rtl
        ? (m.fromTo(
            v,
            1,
            { autoAlpha: 0 },
            { autoAlpha: 1, ease: Power0.easeInOut },
            0.1
          ),
          m.staggerFromTo(
            w,
            0.5,
            { opacity: 0, skewX: -10, x: 40 },
            { opacity: 1, skewX: 0, x: 0 },
            0.1,
            0.2
          ))
        : (m.fromTo(
            v,
            1,
            { autoAlpha: 0 },
            { autoAlpha: 1, ease: Power0.easeInOut },
            0.1
          ),
          m.staggerFromTo(
            w,
            0.5,
            { opacity: 0, skewX: 10, x: -40 },
            { opacity: 1, skewX: 0, x: 0 },
            0.1,
            0.2
          ));
    }
    $(document).off(
      "click",
      ".sidebar__btn, .sidebar__close, .sidebar__overlay"
    ),
      $(document).on(
        "click",
        ".sidebar__btn, .sidebar__close, .sidebar__overlay",
        function () {
          $("body").hasClass("sidebar-open")
            ? $("body").removeClass("sidebar-open")
            : ($("body").addClass("sidebar-open"), p());
        }
      ),
      $(document).off("click", ".filters__btn"),
      $(document).on("click", ".filters__btn", function () {
        $(".shop__filtering").slideToggle();
      });
  }
  function n() {
    $(document).off("click", ".header__toggle"),
      $(document).on("click", ".header__toggle", function () {
        $(this).toggleClass("active"), $(".collection-header ul").slideToggle();
      });
  }
  function r() {
    $(document).off("click", ".alert-message"),
      $(document).on("click", ".alert-message", function () {
        $(this).hide();
        var p = 0,
          m = theme.settings.afterAddition;
        $("body").hasClass("quickview-opened") &&
          ((m = "message"),
          (p = 300),
          $(".cd-quick-view .cd-close").trigger("click")),
          $(this).hasClass("cart_message") &&
            m == "message" &&
            setTimeout(function () {
              theme.MiniCart.open();
            }, p);
      });
  }
  function c(p, m, v) {
    typeof v == "undefined" && (v = !1), $(".alert-message").remove();
    var w =
      '<div class="alert alert-' +
      (p == "check" ? "success" : "error") +
      ' alert-message"><div class="alert__icon"><i class="ris ri-' +
      p +
      '"></i></div><div class="alert__content">' +
      m +
      "</div></div>";
    v == !0 &&
      (w =
        '<div class="alert alert-message cart_message"><div class="alert__background" style="background-image:url(' +
        p +
        ');"></div><div class="alert__description">' +
        m +
        "</div></div>"),
      $("body").append(w);
  }
  function d() {
    return (
      !!$(".product__colors .swatch-item").length &&
      ($(document).off("click", ".product__colors .swatch-item"),
      void $(document).on(
        "click",
        ".product__colors .swatch-item",
        function (p) {
          p.preventDefault();
          var m = $(this);
          if (!m.hasClass("active")) {
            var v = m
                .closest(".product__item")
                .find(".product__image-featured"),
              w = m.data("bgset");
            v
              .attr("data-bgset", w)
              .removeClass("lazyloaded")
              .addClass("lazyload"),
              m
                .closest(".product__colors")
                .find(".swatch-item")
                .removeClass("active"),
              m.addClass("active");
          }
        }
      ))
    );
  }
  function l() {
    return (
      !!$(".quickview_btn").length &&
      ($(document).off("click", ".quickview_btn"),
      $(document).on("click", ".quickview_btn", function (p) {
        p.preventDefault();
        var m = $(this),
          v = m.data("collection_handle"),
          w = m.data("product_handle"),
          S = m.closest(".product__item"),
          g = S.find(".product__image"),
          k = g.css("background-image").replace(/^url\(['"](.+)['"]\)/, "$1");
        $.ajax({
          url:
            "/collections/" +
            v +
            "/products/" +
            w +
            "?view=quickview&cache=false",
          beforeSend: function () {
            m.addClass("adding");
          },
          complete: function () {
            m.removeClass("adding");
          },
          success: function (L) {
            $(".cd-quick-view .cd-content").empty().html(L),
              setTimeout(function () {
                $(".cd-quick-view").addClass("opened");
              }, 300),
              setTimeout(function () {
                $("body").addClass("blurred").addClass("quickview-opened");
              }, 500),
              theme.roarJs.productInfoAnimation($(".cd-quick-view"));
            var M = new theme.Sections();
            M.register("product-quickview", theme.Product),
              Shopify.PaymentButton.init();
          },
        });
      }),
      $(document).off("click", ".cd-close, .cd-overlay"),
      $(document).on("click", ".cd-close, .cd-overlay", function () {
        $("body").removeClass("blurred").removeClass("quickview-opened"),
          $(".cd-quick-view").removeClass("opened"),
          theme.ProductVideo.removeSectionVideos("product-quickview-template"),
          theme.ProductModel.removeSectionModels("product-quickview-template");
      }),
      void $(document).keyup(function (p) {
        p.which == "27" &&
          $(".cd-quick-view").hasClass("opened") &&
          $(".cd-close").trigger("click");
      }))
    );
  }
  function u() {
    $(document).off("click", ".products-grid .product .options_btn"),
      $(document).on(
        "click",
        ".products-grid .product .options_btn",
        function (p) {
          p.preventDefault();
          var m = $(this).closest(".product");
          m.addClass("opened");
        }
      ),
      $(document).off("click", ".products-grid .product .close_btn"),
      $(document).on(
        "click",
        ".products-grid .product .close_btn",
        function (p) {
          p.preventDefault();
          var m = $(this).closest(".product");
          m.removeClass("opened");
        }
      );
  }
  function f() {
    $(document).off(
      "click",
      ".addcart_btn:not(.added), .product-form__cart-submit"
    ),
      $(document).on(
        "click",
        ".addcart_btn:not(.added), .product-form__cart-submit",
        function (p) {
          p.preventDefault();
          var m = $(this),
            v = m.closest("form"),
            w = $("body");
          return theme.settings.cartAjax == !0
            ? ($.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: !0,
                cache: !1,
                data: v.serialize(),
                dataType: "json",
                beforeSend: function () {
                  m.addClass("adding");
                },
                success: function (S) {
                  if (theme.settings.afterAddition == "redirect")
                    return (window.location = "/cart"), !1;
                  var g = theme.MiniCart.update();
                  g.promise().done(function () {
                    var k = 0;
                    m.hasClass("progress-btn") && (k = 500),
                      m.addClass("active"),
                      setTimeout(function () {
                        m
                          .removeClass("adding")
                          .text(m.data("added"))
                          .addClass("added"),
                          k &&
                            setTimeout(function () {
                              m.removeClass("active").removeClass("added");
                            }, 2e3);
                      }, k);
                    var L = theme.settings.afterAddition,
                      M = 0;
                    k && (M = k + 800),
                      (w.hasClass("compare-opened") ||
                        w.hasClass("quickview-opened")) &&
                        ((M = 0), (L = "message")),
                      setTimeout(function () {
                        switch (L) {
                          case "minicart":
                            theme.MiniCart.open();
                            break;
                          case "message":
                            var E = S;
                            if (E.id !== void 0) {
                              var R = theme.Images.getSizedImageUrl(
                                  E.image,
                                  "200x"
                                ),
                                q = E.title,
                                H = theme.strings.productAdded.replace(
                                  "{{ product_name }}",
                                  q
                                );
                              c(R, H, !0);
                            } else {
                              var H = E.message + ": " + E.description;
                              c("alert", H);
                            }
                        }
                      }, M);
                  });
                },
              }),
              !1)
            : (v.submit(), !1);
        }
      ),
      $(document).off("click", ".product-form__cart-submit--grouped"),
      $(document).on(
        "click",
        ".product-form__cart-submit--grouped",
        function (p) {
          p.preventDefault();
          var m = $(this),
            v = m
              .closest(".product-single__content")
              .find(".product-single__grouped .product-form__input");
          return (
            v.length &&
              ((Shopify.queue = []),
              v.each(function () {
                0 < parseInt($(this).val()) &&
                  Shopify.queue.push({
                    variantId: $(this).data("variant_id"),
                    quantity: parseInt($(this).val()),
                  });
              }),
              (Shopify.moveAlong = function () {
                if (Shopify.queue.length) {
                  var w = Shopify.queue.shift();
                  Shopify.addItem(
                    w.variantId,
                    w.quantity,
                    w.properties,
                    Shopify.moveAlong
                  );
                } else
                  m.removeClass("adding"),
                    theme.MiniCart.update(),
                    theme.settings.afterAddition == "redirect"
                      ? (location.href = "/cart")
                      : theme.settings.afterAddition == "minicart" &&
                        theme.MiniCart.open();
              }),
              (Shopify.addItem = function (w, S, g, k) {
                var L = { quantity: S, id: w };
                g != !1 && (L.properties = g),
                  $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: L,
                    success: function () {
                      typeof k == "function" && k();
                    },
                    error: function () {},
                  });
              }),
              Shopify.queue.length &&
                (m.addClass("adding"), Shopify.moveAlong())),
            !1
          );
        }
      );
  }
  function h() {
    return (
      !!$(".addwishlist_btn").length &&
      ($(document).off("click", ".addwishlist_btn:not(.added)"),
      void $(document).on(
        "click",
        ".addwishlist_btn:not(.added)",
        function (p) {
          p.preventDefault();
          var m = $(this),
            v = parseInt(m.data("customer_id"));
          if (0 < v) {
            var w = m.data("shop_domain"),
              S = parseInt(m.data("product_id")),
              g = m.data("product_handle").toString();
            if (w.length && g.length && S) {
              var k = document.createElement("form");
              k.setAttribute("action", "/contact"),
                k.setAttribute("method", "POST"),
                k.setAttribute("style", "display:none");
              var L = document.createElement("input");
              L.setAttribute("type", "hidden"),
                L.setAttribute("name", "customer"),
                L.setAttribute("value", v);
              var M = document.createElement("input");
              M.setAttribute("type", "hidden"),
                M.setAttribute("name", "shop"),
                M.setAttribute("value", w);
              var E = document.createElement("input");
              E.setAttribute("type", "hidden"),
                E.setAttribute("name", "id"),
                E.setAttribute("value", S);
              var R = document.createElement("input");
              R.setAttribute("type", "hidden"),
                R.setAttribute("name", "handle"),
                R.setAttribute("value", g);
              var q = document.createElement("input");
              q.setAttribute("type", "hidden"),
                q.setAttribute("name", "action"),
                q.setAttribute("value", "add_wishlist"),
                k.appendChild(L),
                k.appendChild(M),
                k.appendChild(E),
                k.appendChild(R),
                k.appendChild(q),
                $("body").append(k);
              var H = $(k).serialize();
              $.ajax({
                type: "POST",
                url: "/a/wishlist",
                async: !0,
                cache: !1,
                data: H,
                dataType: "json",
                beforeSend: function () {
                  m.addClass("adding");
                },
                complete: function () {
                  m.removeClass("adding");
                },
                success: function (X) {
                  if (
                    (c("check", theme.strings.wishlistAdded),
                    m.addClass("added").find(".tooltip").text(m.data("added")),
                    $(k).remove(),
                    X.code == 1)
                  ) {
                    var Z = parseInt(X.json);
                    Z
                      ? $(".wishlist__count").removeClass("hide").text(Z)
                      : $(".wishlist__count").addClass("hide").text(0);
                  }
                },
              });
            }
          } else window.location = "/account/login";
        }
      ))
    );
  }
  function b() {
    return (
      !!$(".removewishlist_btn").length &&
      ($(document).off("click", ".removewishlist_btn"),
      void $(document).on("click", ".removewishlist_btn", function () {
        var p = $(this),
          m = parseInt(p.data("customer_id"));
        if (0 < m) {
          var v = p.data("shop_domain"),
            w = parseInt(p.data("product_id"));
          if (v.length && w) {
            var S = document.createElement("form");
            S.setAttribute("action", "/contact"),
              S.setAttribute("method", "POST"),
              S.setAttribute("style", "display:none");
            var g = document.createElement("input");
            g.setAttribute("type", "hidden"),
              g.setAttribute("name", "customer"),
              g.setAttribute("value", m);
            var k = document.createElement("input");
            k.setAttribute("type", "hidden"),
              k.setAttribute("name", "shop"),
              k.setAttribute("value", v);
            var L = document.createElement("input");
            L.setAttribute("type", "hidden"),
              L.setAttribute("name", "product"),
              L.setAttribute("value", w);
            var M = document.createElement("input");
            M.setAttribute("type", "hidden"),
              M.setAttribute("name", "action"),
              M.setAttribute("value", "remove_wishlist"),
              S.appendChild(g),
              S.appendChild(k),
              S.appendChild(L),
              S.appendChild(M),
              $("body").append(S);
            var E = $(S).serialize();
            $.ajax({
              type: "POST",
              url: "/a/wishlist",
              async: !0,
              cache: !1,
              data: E,
              dataType: "json",
              beforeSend: function () {
                $(".wishlist__table").addClass("loading");
              },
              complete: function () {
                $(".wishlist__table").removeClass("loading");
              },
              success: function (R) {
                if (($(S).remove(), R.code == 1)) {
                  var q = parseInt(R.json);
                  q
                    ? p.closest("tr").slideUp("fast", function () {
                        $(this).remove(),
                          c("check", theme.strings.wishlistRemoved),
                          $(".wishlist__count").removeClass("hide").text(q);
                      })
                    : location.reload();
                }
              },
            });
          }
        } else window.location = "/account/login";
      }))
    );
  }
  function C() {
    return (
      !!$(".page-wishlist .ajax_load_button .loadmore").length &&
      ($(document).off("click", ".page-wishlist .ajax_load_button .loadmore"),
      void $(document).on(
        "click",
        ".page-wishlist .ajax_load_button .loadmore",
        function () {
          var p = ".page-wishlist .ajax_load_button",
            m = ".page-wishlist .wishlist__item",
            v = ".page-wishlist .pagination";
          if ($(v).find("a.next").length) {
            $(".page-wishlist .ajax_load_button .loadmore").attr(
              "data-processing",
              1
            );
            var w = $(v).find("a.next").attr("href"),
              S = $(".page-wishlist .ajax_load_button .loadmore").data(
                "no_more"
              );
            $(p).addClass("loading"),
              $.get(w, function (g) {
                $(v).empty().html($(g).find(v).html()),
                  $(g)
                    .find(m)
                    .each(function () {
                      $(m).last().after($(this));
                    }),
                  $(p).removeClass("loading"),
                  $(".page-wishlist .ajax_load_button .loadmore").attr(
                    "data-processing",
                    0
                  ),
                  $(v).find("a.next").length == 0 &&
                    ($(p)
                      .addClass("ajax_load_finished")
                      .removeClass("ajax_load_hidden"),
                    $(".page-wishlist .ajax_load_button .loadmore")
                      .show()
                      .html(S)
                      .addClass("disabled")
                      .prop("disabled", !0));
              });
          } else {
            var S = $(".page-wishlist .ajax_load_button .loadmore").attr(
              "data-no-more"
            );
            $(p).addClass("ajax_load_finished").removeClass("ajax_load_hidden"),
              $(".page-wishlist .ajax_load_button .loadmore")
                .show()
                .html(S)
                .addClass("disabled")
                .prop("disabled", !0);
          }
        }
      ))
    );
  }
  function I(p) {
    var m = $("body");
    m.addClass("compare-opened");
    var v = $(".compare__modal");
    v.removeClass("opened"),
      p && p.length && v.find(".compare__content").empty().html(p),
      v.addClass("opened"),
      $(".compare__list tr").each(function () {
        $(this).css("height", $(this).outerHeight());
      }),
      $(".compare__list").clone().appendTo(".compare__left"),
      $(".compare__left td").remove();
  }
  function T() {
    var p = $("body");
    p.removeClass("compare-opened");
    var m = $(".compare__modal");
    m.removeClass("opened");
  }
  function P() {
    var p = localStorage.getItem("roarStorage_compare") || "[]";
    try {
      p = JSON.parse(p);
    } catch (v) {
      localStorage.removeItem("roarStorage_compare"), (p = JSON.parse("[]"));
    }
    var m = p.filter(function (v) {
      return v != null;
    });
    return 10 < m.length ? m.slice(0, 10) : m;
  }
  function O(p) {
    var m = 10 < p.length ? p.slice(0, 10) : p;
    try {
      localStorage.setItem("roarStorage_compare", JSON.stringify(m));
    } catch (v) {}
    return m;
  }
  function V() {
    var p = P(),
      m = $(".compare__link"),
      v = $(".compare__count");
    if (0 < v.length) {
      var w = p.length;
      v.text(w),
        0 < w
          ? (v.removeClass("hide"), m.removeClass("deactive"))
          : (v.addClass("hide"), m.addClass("deactive"));
    }
  }
  function U() {
    var p = P();
    p.length &&
      $(".addcompare_btn").each(function () {
        var m = $(this),
          v = m.data("product_id");
        p.includes(v) &&
          m.addClass("added").find(".tooltip").text(m.data("added"));
      }),
      V(),
      $(document).off("click", ".compare__close"),
      $(document).on("click", ".compare__close", function () {
        T();
      }),
      $(document).keyup(function (m) {
        m.which == "27" && $(".compare__modal").hasClass("opened") && T();
      }),
      $(document).off("click", ".compare__link"),
      $(document).on("click", ".compare__link", function () {
        var m = $(this),
          v = P(),
          w = v
            .map(function (S) {
              return "id:" + S;
            })
            .join(" OR ");
        $.ajax({
          url: "/search",
          data: { view: "compare", type: "product", q: w },
          dataType: "html",
          type: "GET",
          beforeSend: function () {
            m.addClass("loading");
          },
          complete: function () {
            m.removeClass("loading");
          },
          success: function (S) {
            I(S), V();
          },
        });
      });
  }
  function Q() {
    $(document).off("click", ".addcompare_btn"),
      $(document).on("click", ".addcompare_btn", function (p) {
        p.preventDefault();
        var m = $(this),
          v = P(),
          w = m.data("product_id");
        v.includes(w) || v.unshift(w),
          10 <= v.length && c("alert", theme.strings.compareLimit);
        var S = O(v),
          g = S.map(function (k) {
            return "id:" + k;
          }).join(" OR ");
        $.ajax({
          url: "/search",
          data: { view: "compare", type: "product", q: g },
          dataType: "html",
          type: "GET",
          beforeSend: function () {
            m.removeClass("added").addClass("adding");
          },
          complete: function () {
            m.removeClass("adding");
          },
          success: function (k) {
            I(k),
              m.addClass("added").find(".tooltip").text(m.data("added")),
              V();
          },
        });
      });
  }
  function G() {
    $(document).off("click", ".removecompare_btn"),
      $(document).on("click", ".removecompare_btn", function (p) {
        p.preventDefault();
        var g = $(this),
          m = g.data("product_id"),
          v = ".product__" + m,
          w = P();
        w.includes(m) && w.splice(w.indexOf(m), 1);
        var S = O(w);
        S.length ? $(".compare__list " + v).remove() : T();
        var g = $(v + " .addcompare_btn");
        g.removeClass("added").find(".tooltip").text(g.data("tooltip")), V();
      });
  }
  function K() {
    $(".slick__gallery").each(function () {
      var p = $(this);
      p.slick({
        rtl: theme.settings.rtl,
        prevArrow:
          '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
        nextArrow:
          '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
      });
    }),
      $(".soundcloud__audio").each(function () {
        var p = $(this),
          m = p.data("video");
        $.ajax({
          async: !0,
          crossDomain: !0,
          url: "https://soundcloud.com/oembed",
          method: "GET",
          headers: {},
          data: { format: "json", url: m },
        }).done(function (v) {
          p.replaceWith(v.html);
        });
      });
  }
  function D() {
    $(document).off("click", ".password-login"),
      $(document).on("click", ".password-login", function (p) {
        p.preventDefault(),
          $("body").addClass("password-opened"),
          setTimeout(function () {
            $(".password-modal input").focus();
          }, 250);
      }),
      $(document).off(
        "click",
        ".password-modal .modal__close, .password__overlay"
      ),
      $(document).on(
        "click",
        ".password-modal .modal__close, .password__overlay",
        function () {
          $("body").removeClass("password-opened");
        }
      ),
      $(document).keyup(function (p) {
        p.keyCode == 27 && $("body").removeClass("password-opened");
      }),
      $(".password-modal").find(".errors").length &&
        ($("body").addClass("password-opened"),
        setTimeout(function () {
          $(".password-modal input").focus();
        }, 250));
  }
  function B() {
    function p(v, w) {
      for (var S = 0; S < w.length; S++)
        if (v.match((".*" + w[S].trim() + ".*").replace(" ", ".*"))) return !0;
      return !1;
    }
    var m = ["/cart?", "/search?", "/collections/"];
    $(document).ajaxComplete(function (v, w, S) {
      var g = S.url;
      if (p(g, m)) {
        theme.roarJs.initReviews(),
          theme.roarJs.splitText(),
          theme.roarJs.animationProduct(),
          theme.roarJs.fixtooltipHover();
        var k = new theme.Sections();
        k.register("line_item", theme.LineItem),
          k.register("countdown-timer", theme.CountdownTimer);
      }
    });
  }
  function Y() {
    $(".lookbook-section.is-slick_slider .lookbook-listing").length &&
      $(".lookbook-section.is-slick_slider .lookbook-listing").each(
        function () {
          var p = $(this),
            m = {
              rtl: theme.settings.rtl,
              centerMode: !0,
              centerPadding: "20%",
              slidesToShow: 1,
              appendArrows: $(".slick-arrows", p.parent()),
              prevArrow:
                '<button class="slick-prev" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-prev"></use></svg></button>',
              nextArrow:
                '<button class="slick-next" type="button"><svg class="svg-icon"><use xlink:href="#global__symbols-next"></use></svg></button>',
            },
            v = p.find(".lookbook__item").length,
            w = setInterval(function () {
              var S = p.find("img.image-preview").length;
              v <= S &&
                (p.imagesLoaded(function () {
                  setTimeout(function () {
                    p.slick(m);
                  }, 500);
                }),
                clearInterval(w));
            }, 300);
        }
      );
  }
  function A() {
    function p() {
      var m = $(".page-header").outerHeight(),
        v = $(window).height(),
        w = $("#site-footer").height();
      0 < v - m - w
        ? ($("#site-content").css({ "min-height": v - m - w - 1 }),
          $("#site-container").css({ "margin-bottom": w - 1 }))
        : $("#site-container").css({ "margin-bottom": w - 1 });
    }
    $("#site-footer").hasClass("is-reveal") &&
      (p(),
      $(window).resize(function () {
        p();
      }));
  }
  function y() {
    var p = $(".progress-section"),
      m = $(".progress-page");
    if (m.length && p.length) {
      p.append(m),
        $(".scrolltotop").on("click", function () {
          return $("html, body").animate({ scrollTop: 0 }, 800), !1;
        }),
        $(window).scroll(function () {
          var k = $(window).scrollTop();
          300 <= k ? m.addClass("is-active") : m.removeClass("is-active");
        });
      var v = 0;
      $(window).scroll(function () {
        var k = $(window).scrollTop();
        k > v ? m.addClass("is-visible") : k < v && m.removeClass("is-visible"),
          (v = k);
      });
      var w = document.querySelector(".progress-page path"),
        S = w.getTotalLength();
      (w.style.transition = w.style.WebkitTransition = "none"),
        (w.style.strokeDasharray = S + " " + S),
        (w.style.strokeDashoffset = S),
        w.getBoundingClientRect(),
        (w.style.transition = w.style.WebkitTransition =
          "stroke-dashoffset 10ms linear");
      var g = function () {
        var k = $(window).scrollTop(),
          L = $(document).height() - $(window).height();
        w.style.strokeDashoffset = S - (k * S) / L;
      };
      g(), $(window).scroll(g);
    }
  }
  function x() {
    return (
      typeof $.fn.imagesLoaded != "undefined" &&
      theme.settings.animation != !1 &&
      void $(".page-header-bg").imagesLoaded({ background: !0 }, function () {
        $(".page-header-bg-wrapper").addClass("loaded");
        var p = new TimelineLite(),
          m = $(".site-header__main"),
          v = $(".site-header__top"),
          w = $(".page-title"),
          S = $(".term-description"),
          g = $(".breadcrumbs"),
          k = $(".page-categories, .page-meta_list"),
          L = $(".page-delimiter"),
          M = $(".back-btn svg"),
          E = $(".content-area"),
          R = $(".site-pagination"),
          q = $("#site-footer"),
          H = $("body");
        H.addClass("run-anim"),
          p
            .fromTo(
              [m, v],
              1,
              { autoAlpha: 0, opacity: 0 },
              { ease: Power4.easeInOut, autoAlpha: 1, opacity: 1 },
              0.2
            )
            .call(function () {
              H.removeClass("run-anim");
            }),
          p.fromTo(
            w,
            1.2,
            { y: 100, opacity: 0 },
            { ease: Power4.easeInOut, y: 0, opacity: 1 },
            0.3
          ),
          p.fromTo(
            S,
            1.4,
            { scale: 1.4, opacity: 0 },
            { ease: Power4.easeInOut, scale: 1, opacity: 1 },
            0.2
          ),
          p.fromTo(
            M,
            1,
            { x: 20, opacity: 0 },
            { ease: Power4.easeInOut, x: 0, opacity: 1 },
            0.5
          ),
          $("body").hasClass("template-collection")
            ? p.fromTo(
                g,
                1.2,
                { y: 40, opacity: 0 },
                { ease: Power4.easeInOut, y: 0, opacity: 1 },
                0.25
              )
            : $("body").hasClass("template-product")
            ? p.fromTo(
                g,
                1.2,
                { y: 40, opacity: 0 },
                { ease: Power4.easeInOut, y: 0, opacity: 1 },
                0.6
              )
            : p.fromTo(
                g,
                1.2,
                { y: 40, opacity: 0 },
                { ease: Power4.easeInOut, y: 0, opacity: 1 },
                0.25
              ),
          p.fromTo(
            k,
            1.4,
            { y: -40, opacity: 0 },
            { ease: Power4.easeInOut, y: 0, opacity: 1 },
            0.25
          ),
          p.fromTo(
            L,
            1,
            { opacity: 0, width: 0 },
            { opacity: 1, width: 70 },
            0.8
          ),
          p.fromTo([E, R], 1, { opacity: 0 }, { opacity: 1 }, 0.8),
          p.fromTo(q, 1, { opacity: 0 }, { opacity: 1 }, 1.5);
      })
    );
  }
  function z() {
    return (
      !(
        typeof ParallaxScroll == "undefined" ||
        typeof window.mobileCheck == "undefined" ||
        window.mobileCheck() ||
        theme.settings.animation == !1
      ) && void ParallaxScroll.init()
    );
  }
  function J() {
    function p(m) {
      function v() {
        (L = k.scrollTop()), (g.allowScrollUpdate = !0);
      }
      function w(N) {
        g.options.debug === !0 && console.log(N);
      }
      function S(N) {
        return N && {}.toString.call(N) === "[object Function]";
      }
      var g = this,
        k = $(window),
        L = k.scrollTop(),
        M = !0,
        E = k.width(),
        R = k.height(),
        q = null,
        H = null,
        X = null,
        Z = !1;
      (g.init = function (N) {
        return (
          (g.options = $.extend(
            {
              target: null,
              tween: null,
              ease: Linear.easeNone,
              min: 0,
              max: 1,
              minSize: 0,
              speed: 0.3,
              defaultProgress: 1,
              debug: !1,
              onMin: null,
              onMax: null,
              onOutside: null,
              onInside: null,
              onUpdate: null,
            },
            N
          )),
          g.options.target === null || 1 > g.options.target.length
            ? (console.warn("Extra Scroll Animator: no target specified"), !1)
            : g.options.tween === null
            ? (console.warn("Extra Scroll Animator: no tween specified"), !1)
            : ((g.allowScrollUpdate = !0), g.update(), void g.repaint())
        );
      }),
        (g.updatePosition = function (N) {
          if (M) {
            var F,
              te = N !== void 0 && N ? 0 : g.options.speed,
              ee = g.options.target.data("coords");
            ee &&
              ((F = 1 - (L - ee.max) / (ee.min - ee.max)),
              0 >= F && q !== !0
                ? ((q = !0),
                  S(g.options.onMin) && g.options.onMin(),
                  g.options.target.trigger("extra:scrollanimator:min"))
                : 0 < F && q !== !1 && (q = !1),
              1 <= F && H !== !0
                ? ((H = !0),
                  S(g.options.onMax) && g.options.onMax(),
                  g.options.target.trigger("extra:scrollanimator:max"))
                : 1 >= F && H !== !1 && (H = !1),
              (q === !0 || H === !0) && X !== !1
                ? ((X = !1),
                  S(g.options.onOutside) && g.options.onOutside(),
                  g.options.target.trigger("extra:scrollanimator:outside"))
                : 1 >= F &&
                  0 <= F &&
                  X !== !0 &&
                  ((X = !0),
                  S(g.options.onInside) && g.options.onInside(),
                  g.options.target.trigger("extra:scrollanimator:inside")),
              X === !1 && (H ? (F = 1) : (F = 0)),
              (F = Math.max(0, Math.min(F))),
              w(F),
              TweenLite.to(g.options.tween, te, {
                progress: F,
                ease: g.options.ease,
              }));
          }
        }),
        (g.update = function () {
          (E = k.width()), (R = k.height());
          var N = {},
            F = g.options.target.offset().top,
            te = g.options.target.height(),
            ee = g.options.min,
            le = g.options.max;
          (N.min = F - R + R * ee),
            (N.max = F - R + te + R * le),
            g.options.target.data("coords", N),
            g.options.tween.paused(!0),
            g.options.tween.progress(g.options.defaultProgress),
            E < g.options.minSize
              ? k.off("scroll", v)
              : (k.on("scroll", v), g.updatePosition(!0)),
            S(g.options.onUpdate) && g.options.onUpdate(N),
            g.options.target.trigger("extra:scrollanimator:update", [N]);
        }),
        k.on("extra:resize", g.update),
        k.on("extra:scrollanimator:resize", g.update),
        k.on("extra:scrollanimator:tick", g.updatePosition),
        (g.repaint = function () {
          return M
            ? (g.allowScrollUpdate &&
                (g.updatePosition(), (g.allowScrollUpdate = !1)),
              void window.requestAnimationFrame(g.repaint))
            : void 0;
        }),
        g.init(m),
        (g.updateTween = function (N) {
          g.options.tween && g.options.tween.kill(),
            (g.options.tween = N),
            g.options.tween.paused(!0),
            g.options.tween.progress(g.options.defaultProgress),
            (g.allowScrollUpdate = !0),
            g.update();
        }),
        (g.pause = function () {
          Z ||
            (k.off("scroll", v),
            k.off("extra:resize", g.update),
            (M = !1),
            (Z = !0));
        }),
        (g.resume = function () {
          Z &&
            (E < g.options.minSize ? k.off("scroll", v) : k.on("scroll", v),
            k.on("extra:resize", g.update),
            (M = !0),
            (Z = !1),
            g.repaint());
        }),
        (g.destroy = function () {
          (M = !1),
            k.off("scroll", v),
            k.off("extra:resize", g.update),
            k.off("extra:scrollanimator:tick", g.updatePosition),
            g.options.tween &&
              (g.options.tween.paused(!0),
              g.options.tween.progress(g.options.defaultProgress),
              g.options.tween.kill()),
            (g.allowScrollUpdate = !1);
        });
    }
    (window.initPrllx = function (m) {
      if ($(".site-main .article__image").length) {
        var m = $(".site-main"),
          v = m.find(".article__image");
        v.each(function () {
          var S,
            g,
            k = $(this),
            L = k.children(),
            M = k.find(".prllx"),
            E = L.width();
          (S = new TimelineLite({ onUpdate: function () {} })),
            S.set(M, { y: -1 * M.attr("data-prllx") }).to(
              M,
              1,
              {
                y: M.attr("data-prllx"),
                overwrite: "all",
                ease: Power0.easeNone,
              },
              "-=0.5"
            ),
            (g = new p({
              target: k,
              tween: S,
              defaultProgress: 0,
              speed: 0,
              min: -0.2,
              max: 1.3,
            })),
            k.on("extra:scrollanimator:update", function (R) {
              R.stopPropagation();
            });
        });
      }
    }),
      (window.initSkrollr = function () {
        if (
          $(".site-main .skrollable").length == 0 ||
          typeof skrollr == "undefined"
        )
          return !1;
        $(".section__bground.skrollable")
          .css("height", "120%")
          .closest(".container-section")
          .addClass("overflow-hidden"),
          skrollr.init({
            forceHeight: !1,
            smoothScrolling: !1,
            mobileCheck: function () {
              return !1;
            },
          });
      }),
      $(window).on("load", function () {
        typeof window.mobileCheck == "undefined" ||
          window.mobileCheck() ||
          (window.initPrllx(), window.initSkrollr());
      });
  }
  function W() {
    return (
      $(".blog-main .article__listing").length != 0 &&
      typeof ScrollReveal != "undefined" &&
      theme.settings.animation != !1 &&
      ((window.sr = ScrollReveal()),
      void sr.reveal(".blog-main .article__listing", {
        opacity: 0,
        duration: 1600,
        mobile: !0,
        viewFactor: 0,
      }))
    );
  }
  function ie() {
    if (typeof window.mobileCheck == "undefined") return !1;
    if (
      992 < $(window).width() &&
      !window.mobileCheck() &&
      0 < $(".products-grid.layout-2").length
    ) {
      var p = $(
        ".products-grid.layout-2 .category__title:not(.split-text), .products-grid.layout-2 .product__link:not(.split-text), .product-single__notify label:not(.split-text)"
      );
      p.each(function () {
        var m = $(this),
          v = new SplitText(m, { type: "lines" });
        m.addClass("split-text").find("div").wrapInner("<span></span>");
      });
    }
  }
  function oe(p) {
    if (theme.settings.animation == !1) return !1;
    var m = new TimelineLite(),
      v = $(".product-single__title", p),
      w = $(".product-single .product__labels", p),
      S = $(".product-single .sidebar-container", p),
      g = $(".product-single__top .box-share-master-container", p),
      k = $(".product-single__right, .product-single__tools", p),
      L = $(".product-single__nav", p),
      M = $(".product-single__middle", p),
      E = $(".product-single__bottom", p);
    m.fromTo(
      v,
      1.6,
      { y: 100, opacity: 0 },
      { ease: Power4.easeInOut, y: 0, opacity: 1 },
      0.7
    ),
      m.fromTo(
        M,
        2,
        { y: 40, opacity: 0 },
        { ease: Power4.easeInOut, y: 0, opacity: 1 },
        0.8
      ),
      m.fromTo(
        E,
        2,
        { y: 40, opacity: 0 },
        { ease: Power4.easeInOut, y: 0, opacity: 1 },
        1
      ),
      m.fromTo(
        [w, g, k, L, S],
        2,
        { opacity: 0 },
        { ease: Power4.easeInOut, opacity: 1 },
        0.7
      );
  }
  function se() {
    return (
      typeof ScrollReveal != "undefined" &&
      theme.settings.animation != !1 &&
      ((window.sr = ScrollReveal()),
      void sr.reveal(
        ".products-grid .product:not(.active)",
        {
          opacity: 0,
          viewFactor: 0.2,
          afterReveal: function (p) {
            if (
              typeof window.mobileCheck == "undefined" ||
              theme.settings.animation == !1
            )
              return !1;
            p.classList.add("active");
            var m = $(p).find(
                ".product__link div span, .category__title div span"
              ),
              v = $(p).find(".product__review, .more-products"),
              w = $(p).find(".product__price");
            (p.visuelRevealTL = new TimelineLite()),
              992 < $(window).width() &&
                !window.mobileCheck() &&
                0 < $(".products-grid.layout-2").length &&
                (p.visuelRevealTL.fromTo(
                  m,
                  1,
                  {
                    ease: Power4.easeOut,
                    x: 30,
                    y: 100,
                    skewX: 60,
                    opacity: 0,
                  },
                  { ease: Power4.easeOut, x: 0, y: 0, skewX: 0, opacity: 1 },
                  0
                ),
                v !== null &&
                  p.visuelRevealTL.fromTo(
                    v,
                    2,
                    { y: 10, opacity: 0 },
                    { ease: Power4.easeOut, y: 0, opacity: 1 },
                    0.4
                  ),
                w !== null &&
                  p.visuelRevealTL.fromTo(
                    w,
                    2,
                    { y: 10 },
                    { ease: Power4.easeOut, y: 0, opacity: 1 },
                    0.2
                  ));
          },
          beforeReveal: function (p) {
            p.classList.add("active");
            var m = $(p).find(".product__image, .category__image");
            m !== null &&
              ((p.visuelRevealTL = new TimelineLite()),
              p.visuelRevealTL.fromTo(
                m,
                2,
                { scale: 1.1 },
                { ease: Power4.easeOut, scale: 1 },
                0
              ));
          },
        },
        150
      ))
    );
  }
  function ne() {
    z(), J(), x(), oe($(".product-template__container")), W(), ie(), se();
  }
  function re() {
    return (
      $(".social-sharing").length != 0 &&
      typeof $.fn.socialShare != "undefined" &&
      void $(".social-sharing").each(function () {
        var p = $(this);
        p.socialShare({
          name: p.data("name"),
          title: p.data("title"),
          mediaUrl: p.data("share_img"),
          social: p.data("share_elem"),
          animation: "launchpadReverse",
          blur: !0,
        });
      })
    );
  }
  function ce() {
    $("body").on("click", ".barberry-show-categories", function (p) {
      p.preventDefault();
      var m = $(this),
        v = m.closest(".page-categories-wrapper");
      if (m.hasClass("opened")) {
        var w = new TimelineLite(),
          S = v.find(".barberry-categories"),
          g = v.find(".barberry-categories .category_item");
        w.fromTo(
          S,
          1,
          { "max-height": 1e3, autoAlpha: 1 },
          { autoAlpha: 0, "max-height": 0, ease: Power3.easeInOut },
          0
        ),
          setTimeout(function () {
            m.removeClass("opened"), S.removeClass("opened");
          }, 700);
      } else {
        var w = new TimelineLite(),
          S = v.find(".barberry-categories"),
          g = v.find(".barberry-categories .category_item");
        w.fromTo(
          S,
          1,
          { "max-height": 0, autoAlpha: 0 },
          { "max-height": 1e3, autoAlpha: 1, ease: Power4.easeIn },
          0
        ),
          w.staggerFromTo(
            g,
            1,
            { opacity: 0, scale: 2, skewX: 30 },
            { opacity: 1, scale: 1, skewX: 0, ease: Power4.easeOut },
            0.1,
            0.3
          ),
          setTimeout(function () {
            S.addClass("opened"), m.addClass("opened");
          }, 500);
      }
    });
  }
  function de() {
    $("[data-roarslider]").each(function () {
      var p = $(this),
        m = "revapi" + p.data("roarslider");
      document.addEventListener(
        m,
        function () {
          p.addClass("loaded");
        },
        !1
      );
    });
  }
  function ae() {
    $(".products .product .product__item").hover(
      function () {
        setTimeout(
          function () {
            $(this).addClass("phover");
          }.bind(this),
          200
        );
      },
      function () {
        setTimeout(
          function () {
            $(this).removeClass("phover");
          }.bind(this),
          200
        );
      }
    );
  }
  return {
    init: function () {
      a(),
        e(),
        re(),
        ne(),
        ce(),
        roarLookbook.init(),
        Y(),
        de(),
        s(),
        t(),
        K(),
        o(),
        n(),
        l(),
        d(),
        f(),
        u(),
        h(),
        b(),
        C(),
        U(),
        Q(),
        G(),
        r(),
        D(),
        B(),
        A(),
        y(),
        ae();
    },
    bgSet: function (p) {
      if (p) {
        var m = p.width / p.height,
          v = "";
        return (
          [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2048].forEach(
            function (w) {
              p.width > w &&
                (v +=
                  theme.Images.getSizedImageUrl(p.src, w + "x") +
                  " " +
                  w +
                  "w " +
                  Math.round(w / m) +
                  "h,");
            }
          ),
          (v +=
            theme.Images.getSizedImageUrl(p.src, "master") +
            " " +
            p.width +
            "w " +
            p.height +
            "h"),
          v
        );
      }
    },
    backHistory: function () {
      history.go(-1);
    },
    initReviews: function () {
      typeof jQuery != "undefined" &&
        typeof SPR != "undefined" &&
        (SPR.registerCallbacks(),
        SPR.initRatingHandler(),
        SPR.initDomEls(),
        SPR.loadProducts(),
        SPR.loadBadges());
    },
    splitText: ie,
    animationProduct: se,
    productInfoAnimation: oe,
    fixtooltipHover: ae,
  };
})()),
  $(document).ready(function () {
    var s = new theme.Sections();
    s.register("cart-template", theme.Cart),
      s.register("cart-gift", theme.CartGift),
      s.register("shipping-calculator", theme.ShippingCalculator),
      s.register("collection-template", theme.Filters),
      s.register("sidebar-sticky", theme.SidebarSticky),
      s.register("product-template", theme.Product),
      s.register("header-mobile", theme.HeaderMobile),
      s.register("header-section", theme.HeaderSection),
      s.register("map", theme.Maps),
      s.register("slideshow-section", theme.SlideshowSection),
      s.register("line_item", theme.LineItem),
      s.register("instagram", theme.Instagram),
      s.register("countdown-timer", theme.CountdownTimer),
      s.register("products-slider", theme.ProductsSlider),
      s.register("product-tabs", theme.ProductTabs),
      s.register("newsletter-popup", theme.NewsletterPopup),
      s.register("lookbook-section", theme.LookbookSection),
      s.register("rich-banner", theme.RichBanner),
      s.register("collections-slider", theme.CollectionsSlider);
  }),
  (theme.init = function () {
    theme.roarJs.init(),
      theme.customerTemplates.init(),
      $('a[href="#"]').on("click", function (s) {
        s.preventDefault();
      }),
      $(document).one("touchstart", function () {
        theme.Helpers.setTouch();
      });
  }),
  $(theme.init),
  document.addEventListener("lazybeforeunveil", function (s) {
    var t = s.target.getAttribute("data-bg");
    t && (s.target.style.backgroundImage = "url(" + t + ")");
  });
//# sourceMappingURL=/s/files/1/0561/4829/5870/t/7/assets/theme.js.map?v=129557242528979315421676117322
